// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file src/protos/learning_management/lms.db.proto (package geneo.lms.db, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { DifficultyLevelEnum, FileEnum, FileExtensionEnum, PracticalProject, Question_QuestionEnum, Resource_ResourceEnum } from "@protos/content_management/content.db_pb";
import { Class_ClassEnum, Subject_SubjectEnum } from "@protos/common/common.db_pb";
import { ProfileRolesEnum, ReportRoleTypeEnum } from "@protos/user_management/ums.db_pb";

/**
 * Enum for taskEnum
 *
 * @generated from enum geneo.lms.db.TaskEnum
 */
export enum TaskEnum {
  /**
   * Represents an undefined task
   *
   * @generated from enum value: TASK_UNDEFINED = 0;
   */
  TASK_UNDEFINED = 0,

  /**
   * Represents an automated homework task
   *
   * @generated from enum value: TASK_HOMEWORK_AUTOMATED = 1;
   */
  TASK_HOMEWORK_AUTOMATED = 1,

  /**
   * Represents a custom homework task
   *
   * @generated from enum value: TASK_HOMEWORK_CUSTOM = 2;
   */
  TASK_HOMEWORK_CUSTOM = 2,

  /**
   * Represents a custom homework task
   *
   * @generated from enum value: TASK_HOMEWORK_TEACHER_CUSTOM = 5;
   */
  TASK_HOMEWORK_TEACHER_CUSTOM = 5,

  /**
   * Represents an automated assessment task
   *
   * @generated from enum value: TASK_ASSESSMENT_AUTOMATED = 3;
   */
  TASK_ASSESSMENT_AUTOMATED = 3,

  /**
   * Represents a custom assessment task
   *
   * @generated from enum value: TASK_ASSESSMENT_CUSTOM = 4;
   */
  TASK_ASSESSMENT_CUSTOM = 4,

  /**
   * Represents an automated assessment task
   *
   * @generated from enum value: TASK_FORMATIVE_ASSESSMENT_AUTOMATED = 6;
   */
  TASK_FORMATIVE_ASSESSMENT_AUTOMATED = 6,

  /**
   * Represents a custom assessment task
   *
   * @generated from enum value: TASK_FORMATIVE_ASSESSMENT_CUSTOM = 7;
   */
  TASK_FORMATIVE_ASSESSMENT_CUSTOM = 7,

  /**
   * Represents a custom assessment task
   *
   * @generated from enum value: TASK_DIAGNOSTIC_ASSESSMENT_AUTOMATED = 8;
   */
  TASK_DIAGNOSTIC_ASSESSMENT_AUTOMATED = 8,

  /**
   * Represents a custom assessment task
   *
   * @generated from enum value: TASK_DIAGNOSTIC_ASSESSMENT_CUSTOM = 9;
   */
  TASK_DIAGNOSTIC_ASSESSMENT_CUSTOM = 9,

  /**
   * @generated from enum value: TASK_QUESTION_PAPER_CUSTOM = 10;
   */
  TASK_QUESTION_PAPER_CUSTOM = 10,

  /**
   * @generated from enum value: TASK_QUESTION_PAPER_AUTOMATED = 11;
   */
  TASK_QUESTION_PAPER_AUTOMATED = 11,

  /**
   * @generated from enum value: TASK_MULTI_SUBJECT_ASSESSMENT_AUTOMATED = 12;
   */
  TASK_MULTI_SUBJECT_ASSESSMENT_AUTOMATED = 12,

  /**
   * @generated from enum value: TASK_MULTI_SUBJECT_ASSESSMENT_CUSTOM = 13;
   */
  TASK_MULTI_SUBJECT_ASSESSMENT_CUSTOM = 13,

  /**
   * @generated from enum value: TASK_MULTI_SUBJECT_FORMATIVE_ASSESSMENT_AUTOMATED = 14;
   */
  TASK_MULTI_SUBJECT_FORMATIVE_ASSESSMENT_AUTOMATED = 14,

  /**
   * @generated from enum value: TASK_MULTI_SUBJECT_FORMATIVE_ASSESSMENT_CUSTOM = 15;
   */
  TASK_MULTI_SUBJECT_FORMATIVE_ASSESSMENT_CUSTOM = 15,

  /**
   * @generated from enum value: TASK_MULTI_SUBJECT_DIAGNOSTIC_ASSESSMENT_AUTOMATED = 16;
   */
  TASK_MULTI_SUBJECT_DIAGNOSTIC_ASSESSMENT_AUTOMATED = 16,

  /**
   * @generated from enum value: TASK_MULTI_SUBJECT_DIAGNOSTIC_ASSESSMENT_CUSTOM = 17;
   */
  TASK_MULTI_SUBJECT_DIAGNOSTIC_ASSESSMENT_CUSTOM = 17,

  /**
   * @generated from enum value: TASK_MULTI_SUBJECT_QUESTION_PAPER_CUSTOM = 18;
   */
  TASK_MULTI_SUBJECT_QUESTION_PAPER_CUSTOM = 18,

  /**
   * @generated from enum value: TASK_MULTI_SUBJECT_QUESTION_PAPER_AUTOMATED = 19;
   */
  TASK_MULTI_SUBJECT_QUESTION_PAPER_AUTOMATED = 19,

  /**
   * @generated from enum value: TASK_PROJECT_CUSTOM = 20;
   */
  TASK_PROJECT_CUSTOM = 20,
}
// Retrieve enum metadata with: proto3.getEnumType(TaskEnum)
proto3.util.setEnumType(TaskEnum, "geneo.lms.db.TaskEnum", [
  { no: 0, name: "TASK_UNDEFINED" },
  { no: 1, name: "TASK_HOMEWORK_AUTOMATED" },
  { no: 2, name: "TASK_HOMEWORK_CUSTOM" },
  { no: 5, name: "TASK_HOMEWORK_TEACHER_CUSTOM" },
  { no: 3, name: "TASK_ASSESSMENT_AUTOMATED" },
  { no: 4, name: "TASK_ASSESSMENT_CUSTOM" },
  { no: 6, name: "TASK_FORMATIVE_ASSESSMENT_AUTOMATED" },
  { no: 7, name: "TASK_FORMATIVE_ASSESSMENT_CUSTOM" },
  { no: 8, name: "TASK_DIAGNOSTIC_ASSESSMENT_AUTOMATED" },
  { no: 9, name: "TASK_DIAGNOSTIC_ASSESSMENT_CUSTOM" },
  { no: 10, name: "TASK_QUESTION_PAPER_CUSTOM" },
  { no: 11, name: "TASK_QUESTION_PAPER_AUTOMATED" },
  { no: 12, name: "TASK_MULTI_SUBJECT_ASSESSMENT_AUTOMATED" },
  { no: 13, name: "TASK_MULTI_SUBJECT_ASSESSMENT_CUSTOM" },
  { no: 14, name: "TASK_MULTI_SUBJECT_FORMATIVE_ASSESSMENT_AUTOMATED" },
  { no: 15, name: "TASK_MULTI_SUBJECT_FORMATIVE_ASSESSMENT_CUSTOM" },
  { no: 16, name: "TASK_MULTI_SUBJECT_DIAGNOSTIC_ASSESSMENT_AUTOMATED" },
  { no: 17, name: "TASK_MULTI_SUBJECT_DIAGNOSTIC_ASSESSMENT_CUSTOM" },
  { no: 18, name: "TASK_MULTI_SUBJECT_QUESTION_PAPER_CUSTOM" },
  { no: 19, name: "TASK_MULTI_SUBJECT_QUESTION_PAPER_AUTOMATED" },
  { no: 20, name: "TASK_PROJECT_CUSTOM" },
]);

/**
 * Enum for taskEnum
 *
 * @generated from enum geneo.lms.db.AssignmentConfigEnum
 */
export enum AssignmentConfigEnum {
  /**
   * @generated from enum value: ASSIGNMENT_CONFIG_UNDEFINED = 0;
   */
  ASSIGNMENT_CONFIG_UNDEFINED = 0,

  /**
   * @generated from enum value: ASSIGNMENT_CONFIG_SHUFFLING = 1;
   */
  ASSIGNMENT_CONFIG_SHUFFLING = 1,

  /**
   * @generated from enum value: ASSIGNMENT_CONFIG_REATTEMPT = 2;
   */
  ASSIGNMENT_CONFIG_REATTEMPT = 2,

  /**
   * @generated from enum value: ASSIGNMENT_CONFIG_TIMED = 3;
   */
  ASSIGNMENT_CONFIG_TIMED = 3,

  /**
   * @generated from enum value: ASSIGNMENT_CONFIG_ALLOW_LATE_SUBMISSION = 4;
   */
  ASSIGNMENT_CONFIG_ALLOW_LATE_SUBMISSION = 4,

  /**
   * @generated from enum value: ASSIGNMENT_CONFIG_QUESTION_BASED_TIMER = 5;
   */
  ASSIGNMENT_CONFIG_QUESTION_BASED_TIMER = 5,

  /**
   * @generated from enum value: ASSIGNMENT_CONFIG_PROCTORING = 6;
   */
  ASSIGNMENT_CONFIG_PROCTORING = 6,

  /**
   * @generated from enum value: ASSIGNMENT_CONFIG_ATTENDANCE = 7;
   */
  ASSIGNMENT_CONFIG_ATTENDANCE = 7,
}
// Retrieve enum metadata with: proto3.getEnumType(AssignmentConfigEnum)
proto3.util.setEnumType(AssignmentConfigEnum, "geneo.lms.db.AssignmentConfigEnum", [
  { no: 0, name: "ASSIGNMENT_CONFIG_UNDEFINED" },
  { no: 1, name: "ASSIGNMENT_CONFIG_SHUFFLING" },
  { no: 2, name: "ASSIGNMENT_CONFIG_REATTEMPT" },
  { no: 3, name: "ASSIGNMENT_CONFIG_TIMED" },
  { no: 4, name: "ASSIGNMENT_CONFIG_ALLOW_LATE_SUBMISSION" },
  { no: 5, name: "ASSIGNMENT_CONFIG_QUESTION_BASED_TIMER" },
  { no: 6, name: "ASSIGNMENT_CONFIG_PROCTORING" },
  { no: 7, name: "ASSIGNMENT_CONFIG_ATTENDANCE" },
]);

/**
 * Enum for taskActionEnum
 *
 * @generated from enum geneo.lms.db.TaskActionEnum
 */
export enum TaskActionEnum {
  /**
   * Represents an undefined action
   *
   * @generated from enum value: TASK_ACTION_UNDEFINED = 0;
   */
  TASK_ACTION_UNDEFINED = 0,

  /**
   * Represents a read action
   *
   * @generated from enum value: TASK_ACTION_READ = 1;
   */
  TASK_ACTION_READ = 1,

  /**
   * Represents a write action
   *
   * @generated from enum value: TASK_ACTION_WRITE = 2;
   */
  TASK_ACTION_WRITE = 2,

  /**
   * Represents a watch video action
   *
   * @generated from enum value: TASK_ACTION_WATCH_VIDEO = 3;
   */
  TASK_ACTION_WATCH_VIDEO = 3,

  /**
   * Represents a fill in the blank action
   *
   * @generated from enum value: TASK_ACTION_FIB = 4;
   */
  TASK_ACTION_FIB = 4,

  /**
   * Represents a match the following action
   *
   * @generated from enum value: TASK_ACTION_MTF = 5;
   */
  TASK_ACTION_MTF = 5,

  /**
   * Represents an activity action
   *
   * @generated from enum value: TASK_ACTION_ACTIVITY = 6;
   */
  TASK_ACTION_ACTIVITY = 6,

  /**
   * Represents an activity question action
   *
   * @generated from enum value: TASK_ACTION_ACTIVITY_QUESTION = 7;
   */
  TASK_ACTION_ACTIVITY_QUESTION = 7,

  /**
   * Represents a single-choice multiple-choice question action
   *
   * @generated from enum value: TASK_ACTION_MCQ_S = 8;
   */
  TASK_ACTION_MCQ_S = 8,

  /**
   * Represents a multiple-choice multiple-choice question action
   *
   * @generated from enum value: TASK_ACTION_MCQ_M = 9;
   */
  TASK_ACTION_MCQ_M = 9,

  /**
   * Represents a true or false question action
   *
   * @generated from enum value: TASK_ACTION_TF = 10;
   */
  TASK_ACTION_TF = 10,

  /**
   * Represents a short answer question action
   *
   * @generated from enum value: TASK_ACTION_SHORT = 11;
   */
  TASK_ACTION_SHORT = 11,

  /**
   * Represents a long answer question action
   *
   * @generated from enum value: TASK_ACTION_LONG = 12;
   */
  TASK_ACTION_LONG = 12,
}
// Retrieve enum metadata with: proto3.getEnumType(TaskActionEnum)
proto3.util.setEnumType(TaskActionEnum, "geneo.lms.db.TaskActionEnum", [
  { no: 0, name: "TASK_ACTION_UNDEFINED" },
  { no: 1, name: "TASK_ACTION_READ" },
  { no: 2, name: "TASK_ACTION_WRITE" },
  { no: 3, name: "TASK_ACTION_WATCH_VIDEO" },
  { no: 4, name: "TASK_ACTION_FIB" },
  { no: 5, name: "TASK_ACTION_MTF" },
  { no: 6, name: "TASK_ACTION_ACTIVITY" },
  { no: 7, name: "TASK_ACTION_ACTIVITY_QUESTION" },
  { no: 8, name: "TASK_ACTION_MCQ_S" },
  { no: 9, name: "TASK_ACTION_MCQ_M" },
  { no: 10, name: "TASK_ACTION_TF" },
  { no: 11, name: "TASK_ACTION_SHORT" },
  { no: 12, name: "TASK_ACTION_LONG" },
]);

/**
 * Enum for taskCreationStatusEnum
 *
 * @generated from enum geneo.lms.db.TaskCreationStatusEnum
 */
export enum TaskCreationStatusEnum {
  /**
   * Represents an undefined task creation status
   *
   * @generated from enum value: TASK_CREATION_STATUS_UNDEFINED = 0;
   */
  TASK_CREATION_STATUS_UNDEFINED = 0,

  /**
   * Represents an initialized task
   *
   * @generated from enum value: TASK_CREATION_STATUS_INITIALIZED = 1;
   */
  TASK_CREATION_STATUS_INITIALIZED = 1,

  /**
   * Represents a draft task
   *
   * @generated from enum value: TASK_CREATION_STATUS_DRAFT = 2;
   */
  TASK_CREATION_STATUS_DRAFT = 2,

  /**
   * Represents an approved task
   *
   * @generated from enum value: TASK_CREATION_STATUS_APPROVED = 3;
   */
  TASK_CREATION_STATUS_APPROVED = 3,

  /**
   * Represents a duplicated task
   *
   * @generated from enum value: TASK_CREATION_STATUS_DUPLICATED = 4;
   */
  TASK_CREATION_STATUS_DUPLICATED = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(TaskCreationStatusEnum)
proto3.util.setEnumType(TaskCreationStatusEnum, "geneo.lms.db.TaskCreationStatusEnum", [
  { no: 0, name: "TASK_CREATION_STATUS_UNDEFINED" },
  { no: 1, name: "TASK_CREATION_STATUS_INITIALIZED" },
  { no: 2, name: "TASK_CREATION_STATUS_DRAFT" },
  { no: 3, name: "TASK_CREATION_STATUS_APPROVED" },
  { no: 4, name: "TASK_CREATION_STATUS_DUPLICATED" },
]);

/**
 * Enum for taskGroupStatusEnum
 *
 * @generated from enum geneo.lms.db.TaskGroupStatusEnum
 */
export enum TaskGroupStatusEnum {
  /**
   * Represents an undefined task group status
   *
   * @generated from enum value: TASK_GROUP_STATUS_UNDEFINED = 0;
   */
  TASK_GROUP_STATUS_UNDEFINED = 0,

  /**
   * Represents an assigned task group
   *
   * @generated from enum value: TASK_GROUP_STATUS_ASSIGNED = 1;
   */
  TASK_GROUP_STATUS_ASSIGNED = 1,

  /**
   * Represents a cancelled task group
   *
   * @generated from enum value: TASK_GROUP_STATUS_CANCELLED = 2;
   */
  TASK_GROUP_STATUS_CANCELLED = 2,

  /**
   * Represents a completed task group
   *
   * @generated from enum value: TASK_GROUP_STATUS_COMPLETED = 3;
   */
  TASK_GROUP_STATUS_COMPLETED = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(TaskGroupStatusEnum)
proto3.util.setEnumType(TaskGroupStatusEnum, "geneo.lms.db.TaskGroupStatusEnum", [
  { no: 0, name: "TASK_GROUP_STATUS_UNDEFINED" },
  { no: 1, name: "TASK_GROUP_STATUS_ASSIGNED" },
  { no: 2, name: "TASK_GROUP_STATUS_CANCELLED" },
  { no: 3, name: "TASK_GROUP_STATUS_COMPLETED" },
]);

/**
 * Enum for taskEvaluationEnum
 *
 * @generated from enum geneo.lms.db.TaskEvaluationStatusEnum
 */
export enum TaskEvaluationStatusEnum {
  /**
   * Represents an undefined task evaluation status
   *
   * @generated from enum value: TASK_EVALUATION_STATUS_UNDEFINED = 0;
   */
  TASK_EVALUATION_STATUS_UNDEFINED = 0,

  /**
   * Represents a task evaluation not started
   *
   * @generated from enum value: TASK_EVALUATION_STATUS_NOT_STARTED = 1;
   */
  TASK_EVALUATION_STATUS_NOT_STARTED = 1,

  /**
   * Represents a task evaluation in progress
   *
   * @generated from enum value: TASK_EVALUATION_STATUS_IN_PROGRESS = 2;
   */
  TASK_EVALUATION_STATUS_IN_PROGRESS = 2,

  /**
   * Represents a task evaluation completed
   *
   * @generated from enum value: TASK_EVALUATION_STATUS_COMPLETED = 3;
   */
  TASK_EVALUATION_STATUS_COMPLETED = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(TaskEvaluationStatusEnum)
proto3.util.setEnumType(TaskEvaluationStatusEnum, "geneo.lms.db.TaskEvaluationStatusEnum", [
  { no: 0, name: "TASK_EVALUATION_STATUS_UNDEFINED" },
  { no: 1, name: "TASK_EVALUATION_STATUS_NOT_STARTED" },
  { no: 2, name: "TASK_EVALUATION_STATUS_IN_PROGRESS" },
  { no: 3, name: "TASK_EVALUATION_STATUS_COMPLETED" },
]);

/**
 * Enum for taskStudentStatusEnum
 *
 * @generated from enum geneo.lms.db.TaskStudentAttemptStatusEnum
 */
export enum TaskStudentAttemptStatusEnum {
  /**
   * Represents an undefined task student status
   *
   * @generated from enum value: TASK_STUDENT_STATUS_UNDEFINED = 0;
   */
  TASK_STUDENT_STATUS_UNDEFINED = 0,

  /**
   * Represents an assigned task student status
   *
   * @generated from enum value: TASK_STUDENT_STATUS_PENDING = 1;
   */
  TASK_STUDENT_STATUS_PENDING = 1,

  /**
   * Represents a task in progress student status
   *
   * @generated from enum value: TASK_STUDENT_STATUS_IN_PROGRESS = 2;
   */
  TASK_STUDENT_STATUS_IN_PROGRESS = 2,

  /**
   * Represents a completed task student status
   *
   * @generated from enum value: TASK_STUDENT_STATUS_COMPLETED = 3;
   */
  TASK_STUDENT_STATUS_COMPLETED = 3,

  /**
   * Represents a exited task student status
   *
   * @generated from enum value: TASK_STUDENT_STATUS_EXITED = 4;
   */
  TASK_STUDENT_STATUS_EXITED = 4,

  /**
   * Represents a exited task student status
   *
   * @generated from enum value: TASK_STUDENT_STATUS_TIMED_OUT = 5;
   */
  TASK_STUDENT_STATUS_TIMED_OUT = 5,

  /**
   * Represents a exited task student status
   *
   * @generated from enum value: TASK_STUDENT_STATUS_ENDED_BY_SYSTEM = 6;
   */
  TASK_STUDENT_STATUS_ENDED_BY_SYSTEM = 6,

  /**
   * Represents a paused task student status
   *
   * @generated from enum value: TASK_STUDENT_STATUS_PAUSED = 7;
   */
  TASK_STUDENT_STATUS_PAUSED = 7,

  /**
   * Represents a task student session ended by admin
   *
   * @generated from enum value: TASK_STUDENT_STATUS_ENDED_BY_ADMIN = 8;
   */
  TASK_STUDENT_STATUS_ENDED_BY_ADMIN = 8,
}
// Retrieve enum metadata with: proto3.getEnumType(TaskStudentAttemptStatusEnum)
proto3.util.setEnumType(TaskStudentAttemptStatusEnum, "geneo.lms.db.TaskStudentAttemptStatusEnum", [
  { no: 0, name: "TASK_STUDENT_STATUS_UNDEFINED" },
  { no: 1, name: "TASK_STUDENT_STATUS_PENDING" },
  { no: 2, name: "TASK_STUDENT_STATUS_IN_PROGRESS" },
  { no: 3, name: "TASK_STUDENT_STATUS_COMPLETED" },
  { no: 4, name: "TASK_STUDENT_STATUS_EXITED" },
  { no: 5, name: "TASK_STUDENT_STATUS_TIMED_OUT" },
  { no: 6, name: "TASK_STUDENT_STATUS_ENDED_BY_SYSTEM" },
  { no: 7, name: "TASK_STUDENT_STATUS_PAUSED" },
  { no: 8, name: "TASK_STUDENT_STATUS_ENDED_BY_ADMIN" },
]);

/**
 * Enum for TaskActiveStatusEnum
 *
 * @generated from enum geneo.lms.db.TaskActiveStatusEnum
 */
export enum TaskActiveStatusEnum {
  /**
   * Represents an undefined task active status
   *
   * @generated from enum value: TASK_ACTIVE_STATUS_UNDEFINED = 0;
   */
  TASK_ACTIVE_STATUS_UNDEFINED = 0,

  /**
   * Represents an active task status
   *
   * @generated from enum value: TASK_ACTIVE_STATUS_ACTIVE = 1;
   */
  TASK_ACTIVE_STATUS_ACTIVE = 1,

  /**
   * Represents an inactive task status
   *
   * @generated from enum value: TASK_ACTIVE_STATUS_INACTIVE = 2;
   */
  TASK_ACTIVE_STATUS_INACTIVE = 2,

  /**
   * Represents a suspended task status
   *
   * @generated from enum value: TASK_ACTIVE_STATUS_SUSPENDED = 3;
   */
  TASK_ACTIVE_STATUS_SUSPENDED = 3,

  /**
   * Represents a cancelled task status
   *
   * @generated from enum value: TASK_ACTIVE_STATUS_CANCELLED = 4;
   */
  TASK_ACTIVE_STATUS_CANCELLED = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(TaskActiveStatusEnum)
proto3.util.setEnumType(TaskActiveStatusEnum, "geneo.lms.db.TaskActiveStatusEnum", [
  { no: 0, name: "TASK_ACTIVE_STATUS_UNDEFINED" },
  { no: 1, name: "TASK_ACTIVE_STATUS_ACTIVE" },
  { no: 2, name: "TASK_ACTIVE_STATUS_INACTIVE" },
  { no: 3, name: "TASK_ACTIVE_STATUS_SUSPENDED" },
  { no: 4, name: "TASK_ACTIVE_STATUS_CANCELLED" },
]);

/**
 * @generated from enum geneo.lms.db.AssessmentEnum
 */
export enum AssessmentEnum {
  /**
   * Represent a undefined assesment
   *
   * @generated from enum value: ASSESSMENT_UNDEFINED = 0;
   */
  ASSESSMENT_UNDEFINED = 0,

  /**
   * Represents a formative assessment_type
   *
   * @generated from enum value: ASSESSMENT_FORMATIVE_ASSESSMENT = 1;
   */
  ASSESSMENT_FORMATIVE_ASSESSMENT = 1,

  /**
   * Represents a homework assessment_type
   *
   * @generated from enum value: ASSESSMENT_HOMEWORK = 2;
   */
  ASSESSMENT_HOMEWORK = 2,

  /**
   * Represents a diagnostics assessment_type
   *
   * @generated from enum value: ASSESSMENT_DIAGNOSTIC_ASSESSMENT = 3;
   */
  ASSESSMENT_DIAGNOSTIC_ASSESSMENT = 3,

  /**
   * Represents a diagnostics assessment_type
   *
   * @generated from enum value: ASSESSMENT_QUESTION_PAPER = 4;
   */
  ASSESSMENT_QUESTION_PAPER = 4,

  /**
   * Represents a project assessment_type
   *
   * @generated from enum value: ASSESSMENT_PROJECT = 5;
   */
  ASSESSMENT_PROJECT = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(AssessmentEnum)
proto3.util.setEnumType(AssessmentEnum, "geneo.lms.db.AssessmentEnum", [
  { no: 0, name: "ASSESSMENT_UNDEFINED" },
  { no: 1, name: "ASSESSMENT_FORMATIVE_ASSESSMENT" },
  { no: 2, name: "ASSESSMENT_HOMEWORK" },
  { no: 3, name: "ASSESSMENT_DIAGNOSTIC_ASSESSMENT" },
  { no: 4, name: "ASSESSMENT_QUESTION_PAPER" },
  { no: 5, name: "ASSESSMENT_PROJECT" },
]);

/**
 * @generated from enum geneo.lms.db.FeatureKeyEnum
 */
export enum FeatureKeyEnum {
  /**
   * @generated from enum value: FEATURE_KEY_UNSPECIFIED = 0;
   */
  FEATURE_KEY_UNSPECIFIED = 0,

  /**
   * ================= TEACHER FEATURES ================= //
   *
   * @generated from enum value: TEACHER = 1;
   */
  TEACHER = 1,

  /**
   * Teacher Authentication (2-10)
   *
   * @generated from enum value: TEACHER__USERNAME_PASSWORD = 2;
   */
  TEACHER__USERNAME_PASSWORD = 2,

  /**
   * @generated from enum value: TEACHER__MOBILE_PASSWORD = 3;
   */
  TEACHER__MOBILE_PASSWORD = 3,

  /**
   * @generated from enum value: TEACHER__EMAIL_PASSWORD = 4;
   */
  TEACHER__EMAIL_PASSWORD = 4,

  /**
   * @generated from enum value: TEACHER__MOBILE_OTP = 5;
   */
  TEACHER__MOBILE_OTP = 5,

  /**
   * @generated from enum value: TEACHER__EMAIL_OTP = 6;
   */
  TEACHER__EMAIL_OTP = 6,

  /**
   * @generated from enum value: TEACHER__FORGOT_PASSWORD = 7;
   */
  TEACHER__FORGOT_PASSWORD = 7,

  /**
   * @generated from enum value: TEACHER__VERIFICATION_FLOW = 8;
   */
  TEACHER__VERIFICATION_FLOW = 8,

  /**
   * @generated from enum value: TEACHER__EMAIL_SMS_NOTIFICATIONS = 9;
   */
  TEACHER__EMAIL_SMS_NOTIFICATIONS = 9,

  /**
   * @generated from enum value: TEACHER__REGISTRATION = 10;
   */
  TEACHER__REGISTRATION = 10,

  /**
   * Teach Flow (11-27)
   *
   * @generated from enum value: TEACHER__TEACH_FLOW = 11;
   */
  TEACHER__TEACH_FLOW = 11,

  /**
   * @generated from enum value: TEACHER__TEACH_FLOW__TEACHING_RESOURCES_CHAPTER = 12;
   */
  TEACHER__TEACH_FLOW__TEACHING_RESOURCES_CHAPTER = 12,

  /**
   * @generated from enum value: TEACHER__TEACH_FLOW__TEACHING_RESOURCES_TOPIC = 13;
   */
  TEACHER__TEACH_FLOW__TEACHING_RESOURCES_TOPIC = 13,

  /**
   * @generated from enum value: TEACHER__TEACH_FLOW__CONTENT = 14;
   */
  TEACHER__TEACH_FLOW__CONTENT = 14,

  /**
   * @generated from enum value: TEACHER__TEACH_FLOW__CONTENT_UPLOAD_CHAPTER_LEVEL = 15;
   */
  TEACHER__TEACH_FLOW__CONTENT_UPLOAD_CHAPTER_LEVEL = 15,

  /**
   * @generated from enum value: TEACHER__TEACH_FLOW__CONTENT_UPLOAD_TOPIC_LEVEL = 16;
   */
  TEACHER__TEACH_FLOW__CONTENT_UPLOAD_TOPIC_LEVEL = 16,

  /**
   * @generated from enum value: TEACHER__TEACH_FLOW__CONTENT_LOCK_UNLOCK_CHAPTER_LEVEL = 17;
   */
  TEACHER__TEACH_FLOW__CONTENT_LOCK_UNLOCK_CHAPTER_LEVEL = 17,

  /**
   * @generated from enum value: TEACHER__TEACH_FLOW__CONTENT_LOCK_UNLOCK_TOPIC_LEVEL = 18;
   */
  TEACHER__TEACH_FLOW__CONTENT_LOCK_UNLOCK_TOPIC_LEVEL = 18,

  /**
   * @generated from enum value: TEACHER__TEACH_FLOW__CONTENT_LOCK_UNLOCK_LESSON_LEVEL = 19;
   */
  TEACHER__TEACH_FLOW__CONTENT_LOCK_UNLOCK_LESSON_LEVEL = 19,

  /**
   * @generated from enum value: TEACHER__TEACH_FLOW__CONTENT_LOCK_UNLOCK_RESOURCE_LEVEL = 20;
   */
  TEACHER__TEACH_FLOW__CONTENT_LOCK_UNLOCK_RESOURCE_LEVEL = 20,

  /**
   * @generated from enum value: TEACHER__TEACH_FLOW__CONNECTED_CLASSROOM = 21;
   */
  TEACHER__TEACH_FLOW__CONNECTED_CLASSROOM = 21,

  /**
   * @generated from enum value: TEACHER__TEACH_FLOW__CONNECTED_CLASSROOM_SESSION_DASHBOARD = 22;
   */
  TEACHER__TEACH_FLOW__CONNECTED_CLASSROOM_SESSION_DASHBOARD = 22,

  /**
   * @generated from enum value: TEACHER__TEACH_FLOW__DOWNLOAD_CONTENT_CHAPTER_LEVEL = 23;
   */
  TEACHER__TEACH_FLOW__DOWNLOAD_CONTENT_CHAPTER_LEVEL = 23,

  /**
   * @generated from enum value: TEACHER__TEACH_FLOW__DOWNLOAD_CONTENT_TOPIC_LEVEL = 24;
   */
  TEACHER__TEACH_FLOW__DOWNLOAD_CONTENT_TOPIC_LEVEL = 24,

  /**
   * @generated from enum value: TEACHER__TEACH_FLOW__DOWNLOAD_CONTENT_LESSON_LEVEL = 25;
   */
  TEACHER__TEACH_FLOW__DOWNLOAD_CONTENT_LESSON_LEVEL = 25,

  /**
   * @generated from enum value: TEACHER__TEACH_FLOW__CREATE_LESSON_PLAN = 26;
   */
  TEACHER__TEACH_FLOW__CREATE_LESSON_PLAN = 26,

  /**
   * @generated from enum value: TEACHER__TEACH_FLOW__EDIT_LESSON_PLAN = 27;
   */
  TEACHER__TEACH_FLOW__EDIT_LESSON_PLAN = 27,

  /**
   * Assessment (28-47)
   *
   * @generated from enum value: TEACHER__ASSESSMENT = 28;
   */
  TEACHER__ASSESSMENT = 28,

  /**
   * @generated from enum value: TEACHER__ASSESSMENT__CREATE = 29;
   */
  TEACHER__ASSESSMENT__CREATE = 29,

  /**
   * @generated from enum value: TEACHER__ASSESSMENT__CREATE_FORMATIVE_ASSESSMENT = 30;
   */
  TEACHER__ASSESSMENT__CREATE_FORMATIVE_ASSESSMENT = 30,

  /**
   * @generated from enum value: TEACHER__ASSESSMENT__CREATE_HOMEWORK = 31;
   */
  TEACHER__ASSESSMENT__CREATE_HOMEWORK = 31,

  /**
   * @generated from enum value: TEACHER__ASSESSMENT__CREATE_CUSTOM_HOMEWORK = 32;
   */
  TEACHER__ASSESSMENT__CREATE_CUSTOM_HOMEWORK = 32,

  /**
   * @generated from enum value: TEACHER__ASSESSMENT__CHOOSE_FROM_LIBRARY = 33;
   */
  TEACHER__ASSESSMENT__CHOOSE_FROM_LIBRARY = 33,

  /**
   * @generated from enum value: TEACHER__ASSESSMENT__CHOOSE_FROM_LIBRARY__ASSESSMENT_TYPE = 34;
   */
  TEACHER__ASSESSMENT__CHOOSE_FROM_LIBRARY__ASSESSMENT_TYPE = 34,

  /**
   * @generated from enum value: TEACHER__ASSESSMENT__ASSIGNMENT = 35;
   */
  TEACHER__ASSESSMENT__ASSIGNMENT = 35,

  /**
   * @generated from enum value: TEACHER__ASSESSMENT__ASSIGNMENT_QUESTION_SHUFFLING = 36;
   */
  TEACHER__ASSESSMENT__ASSIGNMENT_QUESTION_SHUFFLING = 36,

  /**
   * @generated from enum value: TEACHER__ASSESSMENT__ASSIGNMENT_RE_ATTEMPT = 37;
   */
  TEACHER__ASSESSMENT__ASSIGNMENT_RE_ATTEMPT = 37,

  /**
   * @generated from enum value: TEACHER__ASSESSMENT__ASSIGNMENT_TIME_DURATION = 38;
   */
  TEACHER__ASSESSMENT__ASSIGNMENT_TIME_DURATION = 38,

  /**
   * @generated from enum value: TEACHER__ASSESSMENT__DELETE = 39;
   */
  TEACHER__ASSESSMENT__DELETE = 39,

  /**
   * @generated from enum value: TEACHER__ASSESSMENT__PUSH_NOTIFICATIONS = 40;
   */
  TEACHER__ASSESSMENT__PUSH_NOTIFICATIONS = 40,

  /**
   * @generated from enum value: TEACHER__ASSESSMENT__EMAIL_SMS_NOTIFICATIONS = 41;
   */
  TEACHER__ASSESSMENT__EMAIL_SMS_NOTIFICATIONS = 41,

  /**
   * @generated from enum value: TEACHER__ASSESSMENT__ONGOING = 42;
   */
  TEACHER__ASSESSMENT__ONGOING = 42,

  /**
   * @generated from enum value: TEACHER__ASSESSMENT__ONGOING__VIEW_REPORT = 43;
   */
  TEACHER__ASSESSMENT__ONGOING__VIEW_REPORT = 43,

  /**
   * @generated from enum value: TEACHER__ASSESSMENT__ONGOING__VIEW_STUDENT_REPORT = 44;
   */
  TEACHER__ASSESSMENT__ONGOING__VIEW_STUDENT_REPORT = 44,

  /**
   * @generated from enum value: TEACHER__ASSESSMENT__COMPLETED = 45;
   */
  TEACHER__ASSESSMENT__COMPLETED = 45,

  /**
   * @generated from enum value: TEACHER__ASSESSMENT__COMPLETED__VIEW_REPORT = 46;
   */
  TEACHER__ASSESSMENT__COMPLETED__VIEW_REPORT = 46,

  /**
   * @generated from enum value: TEACHER__ASSESSMENT__COMPLETED__VIEW_STUDENT_REPORT = 47;
   */
  TEACHER__ASSESSMENT__COMPLETED__VIEW_STUDENT_REPORT = 47,

  /**
   * Other Teacher Features (48-53)
   *
   * @generated from enum value: TEACHER__ANALYTICS = 48;
   */
  TEACHER__ANALYTICS = 48,

  /**
   * @generated from enum value: TEACHER__PROFILE__PHONE_NUMBER_CHANGE = 49;
   */
  TEACHER__PROFILE__PHONE_NUMBER_CHANGE = 49,

  /**
   * @generated from enum value: TEACHER__PROFILE__EMAIL_CHANGE = 50;
   */
  TEACHER__PROFILE__EMAIL_CHANGE = 50,

  /**
   * @generated from enum value: TEACHER__CHANGE_PASSWORD = 51;
   */
  TEACHER__CHANGE_PASSWORD = 51,

  /**
   * @generated from enum value: TEACHER__DOWNLOAD__SETTINGS = 52;
   */
  TEACHER__DOWNLOAD__SETTINGS = 52,

  /**
   * @generated from enum value: TEACHER__HELP_SUPPORT = 53;
   */
  TEACHER__HELP_SUPPORT = 53,

  /**
   * ================= STUDENT FEATURES ================= //
   *
   * @generated from enum value: STUDENT = 54;
   */
  STUDENT = 54,

  /**
   * Student Authentication (55-62)
   *
   * @generated from enum value: STUDENT__USERNAME_PASSWORD = 55;
   */
  STUDENT__USERNAME_PASSWORD = 55,

  /**
   * @generated from enum value: STUDENT__MOBILE_PASSWORD = 56;
   */
  STUDENT__MOBILE_PASSWORD = 56,

  /**
   * @generated from enum value: STUDENT__EMAIL_PASSWORD = 57;
   */
  STUDENT__EMAIL_PASSWORD = 57,

  /**
   * @generated from enum value: STUDENT__MOBILE_OTP = 58;
   */
  STUDENT__MOBILE_OTP = 58,

  /**
   * @generated from enum value: STUDENT__EMAIL_OTP = 59;
   */
  STUDENT__EMAIL_OTP = 59,

  /**
   * @generated from enum value: STUDENT__FORGOT_PASSWORD = 60;
   */
  STUDENT__FORGOT_PASSWORD = 60,

  /**
   * @generated from enum value: STUDENT__VERIFICATION_FLOW = 61;
   */
  STUDENT__VERIFICATION_FLOW = 61,

  /**
   * @generated from enum value: STUDENT__EMAIL_SMS_NOTIFICATIONS = 62;
   */
  STUDENT__EMAIL_SMS_NOTIFICATIONS = 62,

  /**
   * Learn Flow (63-68)
   *
   * @generated from enum value: STUDENT__LEARN_FLOW = 63;
   */
  STUDENT__LEARN_FLOW = 63,

  /**
   * @generated from enum value: STUDENT__LEARN_FLOW__CONTENT_ACCESS = 64;
   */
  STUDENT__LEARN_FLOW__CONTENT_ACCESS = 64,

  /**
   * @generated from enum value: STUDENT__LEARN_FLOW__PDF_CONVERSION = 65;
   */
  STUDENT__LEARN_FLOW__PDF_CONVERSION = 65,

  /**
   * @generated from enum value: STUDENT__LEARN_FLOW__DOWNLOAD_CONTENT_CHAPTER_LEVEL = 66;
   */
  STUDENT__LEARN_FLOW__DOWNLOAD_CONTENT_CHAPTER_LEVEL = 66,

  /**
   * @generated from enum value: STUDENT__LEARN_FLOW__DOWNLOAD_CONTENT_TOPIC_LEVEL = 67;
   */
  STUDENT__LEARN_FLOW__DOWNLOAD_CONTENT_TOPIC_LEVEL = 67,

  /**
   * @generated from enum value: STUDENT__LEARN_FLOW__DOWNLOAD_CONTENT_LESSON_PLAN_LEVEL = 68;
   */
  STUDENT__LEARN_FLOW__DOWNLOAD_CONTENT_LESSON_PLAN_LEVEL = 68,

  /**
   * Student Assessment (69-75)
   *
   * @generated from enum value: STUDENT__ASSESSMENT = 69;
   */
  STUDENT__ASSESSMENT = 69,

  /**
   * @generated from enum value: STUDENT__ASSESSMENT__ACTIVE = 70;
   */
  STUDENT__ASSESSMENT__ACTIVE = 70,

  /**
   * @generated from enum value: STUDENT__ASSESSMENT__RECOMMENDED_RESOURCES = 71;
   */
  STUDENT__ASSESSMENT__RECOMMENDED_RESOURCES = 71,

  /**
   * @generated from enum value: STUDENT__ASSESSMENT__COMPLETED = 72;
   */
  STUDENT__ASSESSMENT__COMPLETED = 72,

  /**
   * @generated from enum value: STUDENT__ASSESSMENT__DOWNLOAD_REPORTS = 73;
   */
  STUDENT__ASSESSMENT__DOWNLOAD_REPORTS = 73,

  /**
   * @generated from enum value: STUDENT__ASSESSMENT__PUSH_NOTIFICATIONS = 74;
   */
  STUDENT__ASSESSMENT__PUSH_NOTIFICATIONS = 74,

  /**
   * @generated from enum value: STUDENT__ASSESSMENT__EMAIL_SMS_NOTIFICATIONS = 75;
   */
  STUDENT__ASSESSMENT__EMAIL_SMS_NOTIFICATIONS = 75,

  /**
   * Performance & Profile (76-82)
   *
   * @generated from enum value: STUDENT__PERFORMANCE = 76;
   */
  STUDENT__PERFORMANCE = 76,

  /**
   * @generated from enum value: STUDENT__PERFORMANCE__SUGGESTED_LEARNING = 77;
   */
  STUDENT__PERFORMANCE__SUGGESTED_LEARNING = 77,

  /**
   * @generated from enum value: STUDENT__PROFILE = 78;
   */
  STUDENT__PROFILE = 78,

  /**
   * @generated from enum value: STUDENT__CHANGE_PASSWORD = 79;
   */
  STUDENT__CHANGE_PASSWORD = 79,

  /**
   * @generated from enum value: STUDENT__DOWNLOAD_SETTINGS = 80;
   */
  STUDENT__DOWNLOAD_SETTINGS = 80,

  /**
   * @generated from enum value: STUDENT__HELP_SUPPORT = 81;
   */
  STUDENT__HELP_SUPPORT = 81,

  /**
   * @generated from enum value: STUDENT__REGISTRATION = 82;
   */
  STUDENT__REGISTRATION = 82,

  /**
   * ================= ADMIN FEATURES ================= //
   *
   * @generated from enum value: ADMIN = 83;
   */
  ADMIN = 83,

  /**
   * Admin Core (84-88)
   *
   * @generated from enum value: ADMIN__LOGIN = 84;
   */
  ADMIN__LOGIN = 84,

  /**
   * @generated from enum value: ADMIN__DASHBOARD = 85;
   */
  ADMIN__DASHBOARD = 85,

  /**
   * @generated from enum value: ADMIN__REGISTRATIONS = 86;
   */
  ADMIN__REGISTRATIONS = 86,

  /**
   * @generated from enum value: ADMIN__REGISTRATIONS__PROCESSING = 87;
   */
  ADMIN__REGISTRATIONS__PROCESSING = 87,

  /**
   * @generated from enum value: ADMIN__CONTENT_ACCESS = 88;
   */
  ADMIN__CONTENT_ACCESS = 88,

  /**
   * Content Approval (89-90)
   *
   * @generated from enum value: ADMIN__CONTENT_APPROVAL = 89;
   */
  ADMIN__CONTENT_APPROVAL = 89,

  /**
   * @generated from enum value: ADMIN__CONTENT_APPROVAL__PROCESSING = 90;
   */
  ADMIN__CONTENT_APPROVAL__PROCESSING = 90,

  /**
   * User Management (91-101)
   *
   * @generated from enum value: ADMIN__UMS = 91;
   */
  ADMIN__UMS = 91,

  /**
   * @generated from enum value: ADMIN__UMS__SCHOOL_INFO = 92;
   */
  ADMIN__UMS__SCHOOL_INFO = 92,

  /**
   * @generated from enum value: ADMIN__UMS__COURSE_MAPPING = 93;
   */
  ADMIN__UMS__COURSE_MAPPING = 93,

  /**
   * @generated from enum value: ADMIN__UMS__COURSE_MAPPING_ADD_SECTION = 94;
   */
  ADMIN__UMS__COURSE_MAPPING_ADD_SECTION = 94,

  /**
   * @generated from enum value: ADMIN__UMS__TEACHER_MANAGEMENT = 95;
   */
  ADMIN__UMS__TEACHER_MANAGEMENT = 95,

  /**
   * @generated from enum value: ADMIN__UMS__TEACHER_MANAGEMENT__EDIT_PROFILE = 96;
   */
  ADMIN__UMS__TEACHER_MANAGEMENT__EDIT_PROFILE = 96,

  /**
   * @generated from enum value: ADMIN__UMS__TEACHER_MANAGEMENT__RESET_PASSWORD = 97;
   */
  ADMIN__UMS__TEACHER_MANAGEMENT__RESET_PASSWORD = 97,

  /**
   * @generated from enum value: ADMIN__UMS__STUDENT_MANAGEMENT = 98;
   */
  ADMIN__UMS__STUDENT_MANAGEMENT = 98,

  /**
   * @generated from enum value: ADMIN__UMS__STUDENT_MANAGEMENT__EDIT_PROFILE = 99;
   */
  ADMIN__UMS__STUDENT_MANAGEMENT__EDIT_PROFILE = 99,

  /**
   * @generated from enum value: ADMIN__UMS__STUDENT_MANAGEMENT__RESET_PASSWORD = 100;
   */
  ADMIN__UMS__STUDENT_MANAGEMENT__RESET_PASSWORD = 100,

  /**
   * @generated from enum value: ADMIN__UMS__TEACHER_COURSE_MAPPING = 101;
   */
  ADMIN__UMS__TEACHER_COURSE_MAPPING = 101,

  /**
   * Content Management (102-104)
   *
   * @generated from enum value: ADMIN__CONTENT_MANAGEMENT = 102;
   */
  ADMIN__CONTENT_MANAGEMENT = 102,

  /**
   * @generated from enum value: ADMIN__CONTENT_MANAGEMENT__UPLOAD_CONTENT = 103;
   */
  ADMIN__CONTENT_MANAGEMENT__UPLOAD_CONTENT = 103,

  /**
   * @generated from enum value: ADMIN__CONTENT_MANAGEMENT__LOCK_UNLOCK = 104;
   */
  ADMIN__CONTENT_MANAGEMENT__LOCK_UNLOCK = 104,

  /**
   * Clicker Management (105-107)
   *
   * @generated from enum value: ADMIN__CLICKER_MANAGEMENT = 105;
   */
  ADMIN__CLICKER_MANAGEMENT = 105,

  /**
   * @generated from enum value: ADMIN__CLICKER_MANAGEMENT__GRADE_SECTION_MAPPING = 106;
   */
  ADMIN__CLICKER_MANAGEMENT__GRADE_SECTION_MAPPING = 106,

  /**
   * @generated from enum value: ADMIN__CLICKER_MANAGEMENT__STUDENT_MAPPING = 107;
   */
  ADMIN__CLICKER_MANAGEMENT__STUDENT_MAPPING = 107,

  /**
   * Reports & Offline (108-109)
   *
   * @generated from enum value: ADMIN__DOWNLOAD_REPORTS = 108;
   */
  ADMIN__DOWNLOAD_REPORTS = 108,

  /**
   * @generated from enum value: ADMIN__MANAGE_OFFLINE_VERSION = 109;
   */
  ADMIN__MANAGE_OFFLINE_VERSION = 109,

  /**
   * School Management (110-114)
   *
   * @generated from enum value: ADMIN__UMS__SCHOOL = 110;
   */
  ADMIN__UMS__SCHOOL = 110,

  /**
   * @generated from enum value: ADMIN__UMS__SCHOOL__SCHOOL_INFO = 111;
   */
  ADMIN__UMS__SCHOOL__SCHOOL_INFO = 111,

  /**
   * @generated from enum value: ADMIN__UMS__SCHOOL__INFO__ADD_SPOC = 112;
   */
  ADMIN__UMS__SCHOOL__INFO__ADD_SPOC = 112,

  /**
   * @generated from enum value: ADMIN__UMS__SCHOOL__COURSE_MAPPING = 113;
   */
  ADMIN__UMS__SCHOOL__COURSE_MAPPING = 113,

  /**
   * @generated from enum value: ADMIN__UMS__SCHOOL__COURSE_MAPPING__ADD_SECTION = 114;
   */
  ADMIN__UMS__SCHOOL__COURSE_MAPPING__ADD_SECTION = 114,

  /**
   * Teacher Management (115-121)
   *
   * @generated from enum value: ADMIN__UMS__TEACHER = 115;
   */
  ADMIN__UMS__TEACHER = 115,

  /**
   * @generated from enum value: ADMIN__UMS__TEACHER__LIST = 116;
   */
  ADMIN__UMS__TEACHER__LIST = 116,

  /**
   * @generated from enum value: ADMIN__UMS__TEACHER__LIST__EDIT_PROFILE = 117;
   */
  ADMIN__UMS__TEACHER__LIST__EDIT_PROFILE = 117,

  /**
   * @generated from enum value: ADMIN__UMS__TEACHER__LIST__RESET_PASSWORD = 118;
   */
  ADMIN__UMS__TEACHER__LIST__RESET_PASSWORD = 118,

  /**
   * @generated from enum value: ADMIN__UMS__TEACHER__CLASS_MAPPING = 119;
   */
  ADMIN__UMS__TEACHER__CLASS_MAPPING = 119,

  /**
   * @generated from enum value: ADMIN__UMS__TEACHER__CLASS_MAPPING__EDIT_MAPPING = 120;
   */
  ADMIN__UMS__TEACHER__CLASS_MAPPING__EDIT_MAPPING = 120,

  /**
   * @generated from enum value: ADMIN__UMS__TEACHER__CLASS_MAPPING__ADD_MAPPING = 121;
   */
  ADMIN__UMS__TEACHER__CLASS_MAPPING__ADD_MAPPING = 121,

  /**
   * Student Management (122-126)
   *
   * @generated from enum value: ADMIN__UMS__STUDENT = 122;
   */
  ADMIN__UMS__STUDENT = 122,

  /**
   * @generated from enum value: ADMIN__UMS__STUDENT__LIST = 123;
   */
  ADMIN__UMS__STUDENT__LIST = 123,

  /**
   * @generated from enum value: ADMIN__UMS__STUDENT__LIST__ADD_STUDENT = 124;
   */
  ADMIN__UMS__STUDENT__LIST__ADD_STUDENT = 124,

  /**
   * @generated from enum value: ADMIN__UMS__STUDENT__LIST__EDIT_PROFILE = 125;
   */
  ADMIN__UMS__STUDENT__LIST__EDIT_PROFILE = 125,

  /**
   * @generated from enum value: ADMIN__UMS__STUDENT__LIST__RESET_PASSWORD = 126;
   */
  ADMIN__UMS__STUDENT__LIST__RESET_PASSWORD = 126,

  /**
   * Additional Teacher Features (127-131)
   *
   * @generated from enum value: TEACHER__TEACH_FLOW__CHAPTER_SCORE = 127;
   */
  TEACHER__TEACH_FLOW__CHAPTER_SCORE = 127,

  /**
   * @generated from enum value: TEACHER__TEACH_FLOW__LEARNING_OUTCOMES = 128;
   */
  TEACHER__TEACH_FLOW__LEARNING_OUTCOMES = 128,

  /**
   * @generated from enum value: TEACHER__DASHBOARD = 129;
   */
  TEACHER__DASHBOARD = 129,

  /**
   * @generated from enum value: TEACHER__DASHBOARD__HOW_TO_VIDEOS = 130;
   */
  TEACHER__DASHBOARD__HOW_TO_VIDEOS = 130,

  /**
   * @generated from enum value: TEACHER__DASHBOARD__RECOMMENDED_LESSON_PLANS = 131;
   */
  TEACHER__DASHBOARD__RECOMMENDED_LESSON_PLANS = 131,
}
// Retrieve enum metadata with: proto3.getEnumType(FeatureKeyEnum)
proto3.util.setEnumType(FeatureKeyEnum, "geneo.lms.db.FeatureKeyEnum", [
  { no: 0, name: "FEATURE_KEY_UNSPECIFIED" },
  { no: 1, name: "TEACHER" },
  { no: 2, name: "TEACHER__USERNAME_PASSWORD" },
  { no: 3, name: "TEACHER__MOBILE_PASSWORD" },
  { no: 4, name: "TEACHER__EMAIL_PASSWORD" },
  { no: 5, name: "TEACHER__MOBILE_OTP" },
  { no: 6, name: "TEACHER__EMAIL_OTP" },
  { no: 7, name: "TEACHER__FORGOT_PASSWORD" },
  { no: 8, name: "TEACHER__VERIFICATION_FLOW" },
  { no: 9, name: "TEACHER__EMAIL_SMS_NOTIFICATIONS" },
  { no: 10, name: "TEACHER__REGISTRATION" },
  { no: 11, name: "TEACHER__TEACH_FLOW" },
  { no: 12, name: "TEACHER__TEACH_FLOW__TEACHING_RESOURCES_CHAPTER" },
  { no: 13, name: "TEACHER__TEACH_FLOW__TEACHING_RESOURCES_TOPIC" },
  { no: 14, name: "TEACHER__TEACH_FLOW__CONTENT" },
  { no: 15, name: "TEACHER__TEACH_FLOW__CONTENT_UPLOAD_CHAPTER_LEVEL" },
  { no: 16, name: "TEACHER__TEACH_FLOW__CONTENT_UPLOAD_TOPIC_LEVEL" },
  { no: 17, name: "TEACHER__TEACH_FLOW__CONTENT_LOCK_UNLOCK_CHAPTER_LEVEL" },
  { no: 18, name: "TEACHER__TEACH_FLOW__CONTENT_LOCK_UNLOCK_TOPIC_LEVEL" },
  { no: 19, name: "TEACHER__TEACH_FLOW__CONTENT_LOCK_UNLOCK_LESSON_LEVEL" },
  { no: 20, name: "TEACHER__TEACH_FLOW__CONTENT_LOCK_UNLOCK_RESOURCE_LEVEL" },
  { no: 21, name: "TEACHER__TEACH_FLOW__CONNECTED_CLASSROOM" },
  { no: 22, name: "TEACHER__TEACH_FLOW__CONNECTED_CLASSROOM_SESSION_DASHBOARD" },
  { no: 23, name: "TEACHER__TEACH_FLOW__DOWNLOAD_CONTENT_CHAPTER_LEVEL" },
  { no: 24, name: "TEACHER__TEACH_FLOW__DOWNLOAD_CONTENT_TOPIC_LEVEL" },
  { no: 25, name: "TEACHER__TEACH_FLOW__DOWNLOAD_CONTENT_LESSON_LEVEL" },
  { no: 26, name: "TEACHER__TEACH_FLOW__CREATE_LESSON_PLAN" },
  { no: 27, name: "TEACHER__TEACH_FLOW__EDIT_LESSON_PLAN" },
  { no: 28, name: "TEACHER__ASSESSMENT" },
  { no: 29, name: "TEACHER__ASSESSMENT__CREATE" },
  { no: 30, name: "TEACHER__ASSESSMENT__CREATE_FORMATIVE_ASSESSMENT" },
  { no: 31, name: "TEACHER__ASSESSMENT__CREATE_HOMEWORK" },
  { no: 32, name: "TEACHER__ASSESSMENT__CREATE_CUSTOM_HOMEWORK" },
  { no: 33, name: "TEACHER__ASSESSMENT__CHOOSE_FROM_LIBRARY" },
  { no: 34, name: "TEACHER__ASSESSMENT__CHOOSE_FROM_LIBRARY__ASSESSMENT_TYPE" },
  { no: 35, name: "TEACHER__ASSESSMENT__ASSIGNMENT" },
  { no: 36, name: "TEACHER__ASSESSMENT__ASSIGNMENT_QUESTION_SHUFFLING" },
  { no: 37, name: "TEACHER__ASSESSMENT__ASSIGNMENT_RE_ATTEMPT" },
  { no: 38, name: "TEACHER__ASSESSMENT__ASSIGNMENT_TIME_DURATION" },
  { no: 39, name: "TEACHER__ASSESSMENT__DELETE" },
  { no: 40, name: "TEACHER__ASSESSMENT__PUSH_NOTIFICATIONS" },
  { no: 41, name: "TEACHER__ASSESSMENT__EMAIL_SMS_NOTIFICATIONS" },
  { no: 42, name: "TEACHER__ASSESSMENT__ONGOING" },
  { no: 43, name: "TEACHER__ASSESSMENT__ONGOING__VIEW_REPORT" },
  { no: 44, name: "TEACHER__ASSESSMENT__ONGOING__VIEW_STUDENT_REPORT" },
  { no: 45, name: "TEACHER__ASSESSMENT__COMPLETED" },
  { no: 46, name: "TEACHER__ASSESSMENT__COMPLETED__VIEW_REPORT" },
  { no: 47, name: "TEACHER__ASSESSMENT__COMPLETED__VIEW_STUDENT_REPORT" },
  { no: 48, name: "TEACHER__ANALYTICS" },
  { no: 49, name: "TEACHER__PROFILE__PHONE_NUMBER_CHANGE" },
  { no: 50, name: "TEACHER__PROFILE__EMAIL_CHANGE" },
  { no: 51, name: "TEACHER__CHANGE_PASSWORD" },
  { no: 52, name: "TEACHER__DOWNLOAD__SETTINGS" },
  { no: 53, name: "TEACHER__HELP_SUPPORT" },
  { no: 54, name: "STUDENT" },
  { no: 55, name: "STUDENT__USERNAME_PASSWORD" },
  { no: 56, name: "STUDENT__MOBILE_PASSWORD" },
  { no: 57, name: "STUDENT__EMAIL_PASSWORD" },
  { no: 58, name: "STUDENT__MOBILE_OTP" },
  { no: 59, name: "STUDENT__EMAIL_OTP" },
  { no: 60, name: "STUDENT__FORGOT_PASSWORD" },
  { no: 61, name: "STUDENT__VERIFICATION_FLOW" },
  { no: 62, name: "STUDENT__EMAIL_SMS_NOTIFICATIONS" },
  { no: 63, name: "STUDENT__LEARN_FLOW" },
  { no: 64, name: "STUDENT__LEARN_FLOW__CONTENT_ACCESS" },
  { no: 65, name: "STUDENT__LEARN_FLOW__PDF_CONVERSION" },
  { no: 66, name: "STUDENT__LEARN_FLOW__DOWNLOAD_CONTENT_CHAPTER_LEVEL" },
  { no: 67, name: "STUDENT__LEARN_FLOW__DOWNLOAD_CONTENT_TOPIC_LEVEL" },
  { no: 68, name: "STUDENT__LEARN_FLOW__DOWNLOAD_CONTENT_LESSON_PLAN_LEVEL" },
  { no: 69, name: "STUDENT__ASSESSMENT" },
  { no: 70, name: "STUDENT__ASSESSMENT__ACTIVE" },
  { no: 71, name: "STUDENT__ASSESSMENT__RECOMMENDED_RESOURCES" },
  { no: 72, name: "STUDENT__ASSESSMENT__COMPLETED" },
  { no: 73, name: "STUDENT__ASSESSMENT__DOWNLOAD_REPORTS" },
  { no: 74, name: "STUDENT__ASSESSMENT__PUSH_NOTIFICATIONS" },
  { no: 75, name: "STUDENT__ASSESSMENT__EMAIL_SMS_NOTIFICATIONS" },
  { no: 76, name: "STUDENT__PERFORMANCE" },
  { no: 77, name: "STUDENT__PERFORMANCE__SUGGESTED_LEARNING" },
  { no: 78, name: "STUDENT__PROFILE" },
  { no: 79, name: "STUDENT__CHANGE_PASSWORD" },
  { no: 80, name: "STUDENT__DOWNLOAD_SETTINGS" },
  { no: 81, name: "STUDENT__HELP_SUPPORT" },
  { no: 82, name: "STUDENT__REGISTRATION" },
  { no: 83, name: "ADMIN" },
  { no: 84, name: "ADMIN__LOGIN" },
  { no: 85, name: "ADMIN__DASHBOARD" },
  { no: 86, name: "ADMIN__REGISTRATIONS" },
  { no: 87, name: "ADMIN__REGISTRATIONS__PROCESSING" },
  { no: 88, name: "ADMIN__CONTENT_ACCESS" },
  { no: 89, name: "ADMIN__CONTENT_APPROVAL" },
  { no: 90, name: "ADMIN__CONTENT_APPROVAL__PROCESSING" },
  { no: 91, name: "ADMIN__UMS" },
  { no: 92, name: "ADMIN__UMS__SCHOOL_INFO" },
  { no: 93, name: "ADMIN__UMS__COURSE_MAPPING" },
  { no: 94, name: "ADMIN__UMS__COURSE_MAPPING_ADD_SECTION" },
  { no: 95, name: "ADMIN__UMS__TEACHER_MANAGEMENT" },
  { no: 96, name: "ADMIN__UMS__TEACHER_MANAGEMENT__EDIT_PROFILE" },
  { no: 97, name: "ADMIN__UMS__TEACHER_MANAGEMENT__RESET_PASSWORD" },
  { no: 98, name: "ADMIN__UMS__STUDENT_MANAGEMENT" },
  { no: 99, name: "ADMIN__UMS__STUDENT_MANAGEMENT__EDIT_PROFILE" },
  { no: 100, name: "ADMIN__UMS__STUDENT_MANAGEMENT__RESET_PASSWORD" },
  { no: 101, name: "ADMIN__UMS__TEACHER_COURSE_MAPPING" },
  { no: 102, name: "ADMIN__CONTENT_MANAGEMENT" },
  { no: 103, name: "ADMIN__CONTENT_MANAGEMENT__UPLOAD_CONTENT" },
  { no: 104, name: "ADMIN__CONTENT_MANAGEMENT__LOCK_UNLOCK" },
  { no: 105, name: "ADMIN__CLICKER_MANAGEMENT" },
  { no: 106, name: "ADMIN__CLICKER_MANAGEMENT__GRADE_SECTION_MAPPING" },
  { no: 107, name: "ADMIN__CLICKER_MANAGEMENT__STUDENT_MAPPING" },
  { no: 108, name: "ADMIN__DOWNLOAD_REPORTS" },
  { no: 109, name: "ADMIN__MANAGE_OFFLINE_VERSION" },
  { no: 110, name: "ADMIN__UMS__SCHOOL" },
  { no: 111, name: "ADMIN__UMS__SCHOOL__SCHOOL_INFO" },
  { no: 112, name: "ADMIN__UMS__SCHOOL__INFO__ADD_SPOC" },
  { no: 113, name: "ADMIN__UMS__SCHOOL__COURSE_MAPPING" },
  { no: 114, name: "ADMIN__UMS__SCHOOL__COURSE_MAPPING__ADD_SECTION" },
  { no: 115, name: "ADMIN__UMS__TEACHER" },
  { no: 116, name: "ADMIN__UMS__TEACHER__LIST" },
  { no: 117, name: "ADMIN__UMS__TEACHER__LIST__EDIT_PROFILE" },
  { no: 118, name: "ADMIN__UMS__TEACHER__LIST__RESET_PASSWORD" },
  { no: 119, name: "ADMIN__UMS__TEACHER__CLASS_MAPPING" },
  { no: 120, name: "ADMIN__UMS__TEACHER__CLASS_MAPPING__EDIT_MAPPING" },
  { no: 121, name: "ADMIN__UMS__TEACHER__CLASS_MAPPING__ADD_MAPPING" },
  { no: 122, name: "ADMIN__UMS__STUDENT" },
  { no: 123, name: "ADMIN__UMS__STUDENT__LIST" },
  { no: 124, name: "ADMIN__UMS__STUDENT__LIST__ADD_STUDENT" },
  { no: 125, name: "ADMIN__UMS__STUDENT__LIST__EDIT_PROFILE" },
  { no: 126, name: "ADMIN__UMS__STUDENT__LIST__RESET_PASSWORD" },
  { no: 127, name: "TEACHER__TEACH_FLOW__CHAPTER_SCORE" },
  { no: 128, name: "TEACHER__TEACH_FLOW__LEARNING_OUTCOMES" },
  { no: 129, name: "TEACHER__DASHBOARD" },
  { no: 130, name: "TEACHER__DASHBOARD__HOW_TO_VIDEOS" },
  { no: 131, name: "TEACHER__DASHBOARD__RECOMMENDED_LESSON_PLANS" },
]);

/**
 * Enum for SessionModeEnum
 *
 * @generated from enum geneo.lms.db.SessionModeEnum
 */
export enum SessionModeEnum {
  /**
   * Represents an undefined session mode
   *
   * @generated from enum value: SESSION_MODE_UNDEFINED = 0;
   */
  SESSION_MODE_UNDEFINED = 0,

  /**
   * Represents a session mode of learn
   *
   * @generated from enum value: SESSION_MODE_LEARN = 1;
   */
  SESSION_MODE_LEARN = 1,

  /**
   * Represents a session mode of teach
   *
   * @generated from enum value: SESSION_MODE_TEACH = 2;
   */
  SESSION_MODE_TEACH = 2,

  /**
   * Represents a session mode of prepare
   *
   * @generated from enum value: SESSION_MODE_PREPARE_LESSON = 3;
   */
  SESSION_MODE_PREPARE_LESSON = 3,

  /**
   * Represents a session mode of assessment
   *
   * @generated from enum value: SESSION_MODE_RESOURCE = 4;
   */
  SESSION_MODE_RESOURCE = 4,

  /**
   * Represents a session mode of revise
   *
   * @generated from enum value: SESSION_MODE_LESSON_RESOURCE = 5;
   */
  SESSION_MODE_LESSON_RESOURCE = 5,

  /**
   * Represents a session mode of prepare
   *
   * @generated from enum value: SESSION_MODE_PREPARE_RESOURCE = 6;
   */
  SESSION_MODE_PREPARE_RESOURCE = 6,

  /**
   * Represents a session mode of prepare
   *
   * @generated from enum value: SESSION_MODE_REVIEW = 7;
   */
  SESSION_MODE_REVIEW = 7,

  /**
   * @generated from enum value: SESSION_MODE_CLICKER_ASSESSMENT = 8;
   */
  SESSION_MODE_CLICKER_ASSESSMENT = 8,

  /**
   * Student working through a project assessment's resources
   *
   * @generated from enum value: SESSION_MODE_PROJECT = 9;
   */
  SESSION_MODE_PROJECT = 9,
}
// Retrieve enum metadata with: proto3.getEnumType(SessionModeEnum)
proto3.util.setEnumType(SessionModeEnum, "geneo.lms.db.SessionModeEnum", [
  { no: 0, name: "SESSION_MODE_UNDEFINED" },
  { no: 1, name: "SESSION_MODE_LEARN" },
  { no: 2, name: "SESSION_MODE_TEACH" },
  { no: 3, name: "SESSION_MODE_PREPARE_LESSON" },
  { no: 4, name: "SESSION_MODE_RESOURCE" },
  { no: 5, name: "SESSION_MODE_LESSON_RESOURCE" },
  { no: 6, name: "SESSION_MODE_PREPARE_RESOURCE" },
  { no: 7, name: "SESSION_MODE_REVIEW" },
  { no: 8, name: "SESSION_MODE_CLICKER_ASSESSMENT" },
  { no: 9, name: "SESSION_MODE_PROJECT" },
]);

/**
 * Enum for SessionStatusEnum
 *
 * @generated from enum geneo.lms.db.SessionStatusEnum
 */
export enum SessionStatusEnum {
  /**
   * Represents an undefined session status
   *
   * @generated from enum value: SESSION_STATUS_UNDEFINED = 0;
   */
  SESSION_STATUS_UNDEFINED = 0,

  /**
   * Represents an ongoing session status
   *
   * @generated from enum value: SESSION_STATUS_STARTED = 1;
   */
  SESSION_STATUS_STARTED = 1,

  /**
   * Represents an ongoing session status
   *
   * @generated from enum value: SESSION_STATUS_ONGOING = 2;
   */
  SESSION_STATUS_ONGOING = 2,

  /**
   * Represents an exited session status
   *
   * @generated from enum value: SESSION_STATUS_EXITED = 3;
   */
  SESSION_STATUS_EXITED = 3,

  /**
   * Represents a completed session status
   *
   * @generated from enum value: SESSION_STATUS_COMPLETED = 4;
   */
  SESSION_STATUS_COMPLETED = 4,

  /**
   * @generated from enum value: SESSION_STATUS_PAUSED = 5;
   */
  SESSION_STATUS_PAUSED = 5,

  /**
   * @generated from enum value: SESSION_STATUS_ENDED_BY_SYSTEM = 6;
   */
  SESSION_STATUS_ENDED_BY_SYSTEM = 6,

  /**
   * @generated from enum value: SESSION_STATUS_ENDED_BY_ADMIN = 7;
   */
  SESSION_STATUS_ENDED_BY_ADMIN = 7,
}
// Retrieve enum metadata with: proto3.getEnumType(SessionStatusEnum)
proto3.util.setEnumType(SessionStatusEnum, "geneo.lms.db.SessionStatusEnum", [
  { no: 0, name: "SESSION_STATUS_UNDEFINED" },
  { no: 1, name: "SESSION_STATUS_STARTED" },
  { no: 2, name: "SESSION_STATUS_ONGOING" },
  { no: 3, name: "SESSION_STATUS_EXITED" },
  { no: 4, name: "SESSION_STATUS_COMPLETED" },
  { no: 5, name: "SESSION_STATUS_PAUSED" },
  { no: 6, name: "SESSION_STATUS_ENDED_BY_SYSTEM" },
  { no: 7, name: "SESSION_STATUS_ENDED_BY_ADMIN" },
]);

/**
 * Enum for PersonEnum
 *
 * @generated from enum geneo.lms.db.PersonEnum
 */
export enum PersonEnum {
  /**
   * Represents an undefined person type
   *
   * @generated from enum value: PERSON_TYPE_UNDEFINED = 0;
   */
  PERSON_TYPE_UNDEFINED = 0,

  /**
   * Represents a person type of student
   *
   * @generated from enum value: PERSON_TYPE_STUDENT = 1;
   */
  PERSON_TYPE_STUDENT = 1,

  /**
   * Represents a person type of teacher
   *
   * @generated from enum value: PERSON_TYPE_TEACHER = 2;
   */
  PERSON_TYPE_TEACHER = 2,

  /**
   * Represents a person type of parent
   *
   * @generated from enum value: PERSON_TYPE_PARENT = 3;
   */
  PERSON_TYPE_PARENT = 3,

  /**
   * Represents a person type of admin
   *
   * @generated from enum value: PERSON_TYPE_ADMIN = 4;
   */
  PERSON_TYPE_ADMIN = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(PersonEnum)
proto3.util.setEnumType(PersonEnum, "geneo.lms.db.PersonEnum", [
  { no: 0, name: "PERSON_TYPE_UNDEFINED" },
  { no: 1, name: "PERSON_TYPE_STUDENT" },
  { no: 2, name: "PERSON_TYPE_TEACHER" },
  { no: 3, name: "PERSON_TYPE_PARENT" },
  { no: 4, name: "PERSON_TYPE_ADMIN" },
]);

/**
 * Enum for SessionModeEnum
 *
 * @generated from enum geneo.lms.db.HomeworkSessionModeEnum
 */
export enum HomeworkSessionModeEnum {
  /**
   * Represents an undefined session mode
   *
   * @generated from enum value: HOMEWORK_SESSION_MODE_UNDEFINED = 0;
   */
  HOMEWORK_SESSION_MODE_UNDEFINED = 0,

  /**
   * Represents a session mode of lesson
   *
   * @generated from enum value: HOMEWORK_SESSION_MODE_FIRST_ATTEMPT = 1;
   */
  HOMEWORK_SESSION_MODE_FIRST_ATTEMPT = 1,

  /**
   * Represents a session mode of learn
   *
   * @generated from enum value: HOMEWORK_SESSION_MODE_REATTEMPT = 2;
   */
  HOMEWORK_SESSION_MODE_REATTEMPT = 2,

  /**
   * Represents a session mode of assessment
   *
   * @generated from enum value: HOMEWORK_SESSION_MODE_RESUME = 3;
   */
  HOMEWORK_SESSION_MODE_RESUME = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(HomeworkSessionModeEnum)
proto3.util.setEnumType(HomeworkSessionModeEnum, "geneo.lms.db.HomeworkSessionModeEnum", [
  { no: 0, name: "HOMEWORK_SESSION_MODE_UNDEFINED" },
  { no: 1, name: "HOMEWORK_SESSION_MODE_FIRST_ATTEMPT" },
  { no: 2, name: "HOMEWORK_SESSION_MODE_REATTEMPT" },
  { no: 3, name: "HOMEWORK_SESSION_MODE_RESUME" },
]);

/**
 * @generated from enum geneo.lms.db.ModeOfConductionEnum
 */
export enum ModeOfConductionEnum {
  /**
   * @generated from enum value: MODE_OF_CONDUCTION_UNDEFINED = 0;
   */
  MODE_OF_CONDUCTION_UNDEFINED = 0,

  /**
   * @generated from enum value: MODE_OF_CONDUCTION_GENEO_APP = 1;
   */
  MODE_OF_CONDUCTION_GENEO_APP = 1,

  /**
   * @generated from enum value: MODE_OF_CONDUCTION_GENEO_CLICKER = 2;
   */
  MODE_OF_CONDUCTION_GENEO_CLICKER = 2,

  /**
   * @generated from enum value: MODE_OF_CONDUCTION_GENEO_OMR = 3;
   */
  MODE_OF_CONDUCTION_GENEO_OMR = 3,

  /**
   * web-based live clicker assessment ("LiveQuiz")
   *
   * @generated from enum value: MODE_OF_CONDUCTION_WEB_LIVE = 4;
   */
  MODE_OF_CONDUCTION_WEB_LIVE = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(ModeOfConductionEnum)
proto3.util.setEnumType(ModeOfConductionEnum, "geneo.lms.db.ModeOfConductionEnum", [
  { no: 0, name: "MODE_OF_CONDUCTION_UNDEFINED" },
  { no: 1, name: "MODE_OF_CONDUCTION_GENEO_APP" },
  { no: 2, name: "MODE_OF_CONDUCTION_GENEO_CLICKER" },
  { no: 3, name: "MODE_OF_CONDUCTION_GENEO_OMR" },
  { no: 4, name: "MODE_OF_CONDUCTION_WEB_LIVE" },
]);

/**
 * @generated from enum geneo.lms.db.QpgSubsectionTypeEnum
 */
export enum QpgSubsectionTypeEnum {
  /**
   * @generated from enum value: QPG_SUBSECTION_TYPE_UNDEFINED = 0;
   */
  QPG_SUBSECTION_TYPE_UNDEFINED = 0,

  /**
   * @generated from enum value: QPG_SUBSECTION_TYPE_PASSAGE = 1;
   */
  QPG_SUBSECTION_TYPE_PASSAGE = 1,
}
// Retrieve enum metadata with: proto3.getEnumType(QpgSubsectionTypeEnum)
proto3.util.setEnumType(QpgSubsectionTypeEnum, "geneo.lms.db.QpgSubsectionTypeEnum", [
  { no: 0, name: "QPG_SUBSECTION_TYPE_UNDEFINED" },
  { no: 1, name: "QPG_SUBSECTION_TYPE_PASSAGE" },
]);

/**
 * @generated from enum geneo.lms.db.MarkingSchemeEnum
 */
export enum MarkingSchemeEnum {
  /**
   * @generated from enum value: MARKING_SCHEME_UNDEFINED = 0;
   */
  MARKING_SCHEME_UNDEFINED = 0,

  /**
   * @generated from enum value: MARKING_SCHEME_GENEO = 1;
   */
  MARKING_SCHEME_GENEO = 1,

  /**
   * @generated from enum value: MARKING_SCHEME_JEE = 2;
   */
  MARKING_SCHEME_JEE = 2,

  /**
   * @generated from enum value: MARKING_SCHEME_CUSTOM = 3;
   */
  MARKING_SCHEME_CUSTOM = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(MarkingSchemeEnum)
proto3.util.setEnumType(MarkingSchemeEnum, "geneo.lms.db.MarkingSchemeEnum", [
  { no: 0, name: "MARKING_SCHEME_UNDEFINED" },
  { no: 1, name: "MARKING_SCHEME_GENEO" },
  { no: 2, name: "MARKING_SCHEME_JEE" },
  { no: 3, name: "MARKING_SCHEME_CUSTOM" },
]);

/**
 * @generated from enum geneo.lms.db.SubmissionType
 */
export enum SubmissionType {
  /**
   * @generated from enum value: SUBMISSION_UNDEFINED = 0;
   */
  SUBMISSION_UNDEFINED = 0,

  /**
   * @generated from enum value: SUBMISSION_ONLINE = 1;
   */
  SUBMISSION_ONLINE = 1,

  /**
   * @generated from enum value: SUBMISSION_OFFLINE = 2;
   */
  SUBMISSION_OFFLINE = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(SubmissionType)
proto3.util.setEnumType(SubmissionType, "geneo.lms.db.SubmissionType", [
  { no: 0, name: "SUBMISSION_UNDEFINED" },
  { no: 1, name: "SUBMISSION_ONLINE" },
  { no: 2, name: "SUBMISSION_OFFLINE" },
]);

/**
 * @generated from enum geneo.lms.db.ResponseCronEvaluationStatus
 */
export enum ResponseCronEvaluationStatus {
  /**
   * @generated from enum value: REESPONSE_CRON_EVALUATION_STATUS_UNDEFINED = 0;
   */
  REESPONSE_CRON_EVALUATION_STATUS_UNDEFINED = 0,

  /**
   * @generated from enum value: REESPONSE_CRON_EVALUATION_STATUS_PENDING = 1;
   */
  REESPONSE_CRON_EVALUATION_STATUS_PENDING = 1,

  /**
   * @generated from enum value: REESPONSE_CRON_EVALUATION_STATUS_INPROGRESS = 2;
   */
  REESPONSE_CRON_EVALUATION_STATUS_INPROGRESS = 2,

  /**
   * @generated from enum value: REESPONSE_CRON_EVALUATION_STATUS_COMPLETED = 3;
   */
  REESPONSE_CRON_EVALUATION_STATUS_COMPLETED = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(ResponseCronEvaluationStatus)
proto3.util.setEnumType(ResponseCronEvaluationStatus, "geneo.lms.db.ResponseCronEvaluationStatus", [
  { no: 0, name: "REESPONSE_CRON_EVALUATION_STATUS_UNDEFINED" },
  { no: 1, name: "REESPONSE_CRON_EVALUATION_STATUS_PENDING" },
  { no: 2, name: "REESPONSE_CRON_EVALUATION_STATUS_INPROGRESS" },
  { no: 3, name: "REESPONSE_CRON_EVALUATION_STATUS_COMPLETED" },
]);

/**
 * @generated from enum geneo.lms.db.QAttemptResultEnum
 */
export enum QAttemptResultEnum {
  /**
   * @generated from enum value: RESPONSE_UNDEFINED = 0;
   */
  RESPONSE_UNDEFINED = 0,

  /**
   * @generated from enum value: RESPONSE_CORRECT = 1;
   */
  RESPONSE_CORRECT = 1,

  /**
   * @generated from enum value: RESPONSE_INCORRECT = 2;
   */
  RESPONSE_INCORRECT = 2,

  /**
   * @generated from enum value: RESPONSE_PARTIALLY_CORRECT = 3;
   */
  RESPONSE_PARTIALLY_CORRECT = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(QAttemptResultEnum)
proto3.util.setEnumType(QAttemptResultEnum, "geneo.lms.db.QAttemptResultEnum", [
  { no: 0, name: "RESPONSE_UNDEFINED" },
  { no: 1, name: "RESPONSE_CORRECT" },
  { no: 2, name: "RESPONSE_INCORRECT" },
  { no: 3, name: "RESPONSE_PARTIALLY_CORRECT" },
]);

/**
 * @generated from enum geneo.lms.db.CCSessionEnum
 */
export enum CCSessionEnum {
  /**
   * @generated from enum value: CC_SESSION_TYPE_UNDEFINED = 0;
   */
  CC_SESSION_TYPE_UNDEFINED = 0,

  /**
   * @generated from enum value: CC_SESSION_TYPE_LESSON = 1;
   */
  CC_SESSION_TYPE_LESSON = 1,

  /**
   * @generated from enum value: CC_SESSION_TYPE_ASSESSMENT = 2;
   */
  CC_SESSION_TYPE_ASSESSMENT = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(CCSessionEnum)
proto3.util.setEnumType(CCSessionEnum, "geneo.lms.db.CCSessionEnum", [
  { no: 0, name: "CC_SESSION_TYPE_UNDEFINED" },
  { no: 1, name: "CC_SESSION_TYPE_LESSON" },
  { no: 2, name: "CC_SESSION_TYPE_ASSESSMENT" },
]);

/**
 * @generated from enum geneo.lms.db.PDFGenStatus
 */
export enum PDFGenStatus {
  /**
   * @generated from enum value: PDF_GENERATION_STATUS_UNDEFINED = 0;
   */
  PDF_GENERATION_STATUS_UNDEFINED = 0,

  /**
   * @generated from enum value: PDF_GENERATION_STATUS_PENDING = 1;
   */
  PDF_GENERATION_STATUS_PENDING = 1,

  /**
   * @generated from enum value: PDF_GENERATION_STATUS_STARTED = 2;
   */
  PDF_GENERATION_STATUS_STARTED = 2,

  /**
   * @generated from enum value: PDF_GENERATION_STATUS_IN_PROGRESS = 3;
   */
  PDF_GENERATION_STATUS_IN_PROGRESS = 3,

  /**
   * @generated from enum value: PDF_GENERATION_STATUS_FAILED = 4;
   */
  PDF_GENERATION_STATUS_FAILED = 4,

  /**
   * @generated from enum value: PDF_GENERATION_STATUS_COMPLETED = 5;
   */
  PDF_GENERATION_STATUS_COMPLETED = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(PDFGenStatus)
proto3.util.setEnumType(PDFGenStatus, "geneo.lms.db.PDFGenStatus", [
  { no: 0, name: "PDF_GENERATION_STATUS_UNDEFINED" },
  { no: 1, name: "PDF_GENERATION_STATUS_PENDING" },
  { no: 2, name: "PDF_GENERATION_STATUS_STARTED" },
  { no: 3, name: "PDF_GENERATION_STATUS_IN_PROGRESS" },
  { no: 4, name: "PDF_GENERATION_STATUS_FAILED" },
  { no: 5, name: "PDF_GENERATION_STATUS_COMPLETED" },
]);

/**
 * @generated from enum geneo.lms.db.BulkJobStatus
 */
export enum BulkJobStatus {
  /**
   * @generated from enum value: BULK_JOB_STATUS_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: BULK_JOB_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: BULK_JOB_STATUS_IN_PROGRESS = 2;
   */
  IN_PROGRESS = 2,

  /**
   * @generated from enum value: BULK_JOB_STATUS_COMPLETED = 3;
   */
  COMPLETED = 3,

  /**
   * @generated from enum value: BULK_JOB_STATUS_FAILED = 4;
   */
  FAILED = 4,

  /**
   * @generated from enum value: BULK_JOB_STATUS_CANCELLED = 5;
   */
  CANCELLED = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(BulkJobStatus)
proto3.util.setEnumType(BulkJobStatus, "geneo.lms.db.BulkJobStatus", [
  { no: 0, name: "BULK_JOB_STATUS_UNDEFINED" },
  { no: 1, name: "BULK_JOB_STATUS_PENDING" },
  { no: 2, name: "BULK_JOB_STATUS_IN_PROGRESS" },
  { no: 3, name: "BULK_JOB_STATUS_COMPLETED" },
  { no: 4, name: "BULK_JOB_STATUS_FAILED" },
  { no: 5, name: "BULK_JOB_STATUS_CANCELLED" },
]);

/**
 * @generated from enum geneo.lms.db.ReportTypeEnum
 */
export enum ReportTypeEnum {
  /**
   * @generated from enum value: REPORT_TYPE_UNDEFINED = 0;
   */
  REPORT_TYPE_UNDEFINED = 0,

  /**
   * @generated from enum value: REPORT_TYPE_KDT = 1;
   */
  REPORT_TYPE_KDT = 1,

  /**
   * @generated from enum value: REPORT_TYPE_HOMEWORK = 2;
   */
  REPORT_TYPE_HOMEWORK = 2,

  /**
   * @generated from enum value: REPORT_TYPE_FORMATIVE_ASSESSMENT = 3;
   */
  REPORT_TYPE_FORMATIVE_ASSESSMENT = 3,

  /**
   * @generated from enum value: REPORT_TYPE_DIAGNOSTIC_ASSESSMENT = 4;
   */
  REPORT_TYPE_DIAGNOSTIC_ASSESSMENT = 4,

  /**
   * @generated from enum value: REPORT_TYPE_CONNECTED_CLASSROOM = 5;
   */
  REPORT_TYPE_CONNECTED_CLASSROOM = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(ReportTypeEnum)
proto3.util.setEnumType(ReportTypeEnum, "geneo.lms.db.ReportTypeEnum", [
  { no: 0, name: "REPORT_TYPE_UNDEFINED" },
  { no: 1, name: "REPORT_TYPE_KDT" },
  { no: 2, name: "REPORT_TYPE_HOMEWORK" },
  { no: 3, name: "REPORT_TYPE_FORMATIVE_ASSESSMENT" },
  { no: 4, name: "REPORT_TYPE_DIAGNOSTIC_ASSESSMENT" },
  { no: 5, name: "REPORT_TYPE_CONNECTED_CLASSROOM" },
]);

/**
 * @generated from enum geneo.lms.db.AdminLevelReportTypeEnum
 */
export enum AdminLevelReportTypeEnum {
  /**
   * @generated from enum value: ADMIN_LEVEL_REPORT_TYPE_UNDEFINED = 0;
   */
  ADMIN_LEVEL_REPORT_TYPE_UNDEFINED = 0,

  /**
   * Single section report with student details
   *
   * @generated from enum value: SECTION_REPORT = 1;
   */
  SECTION_REPORT = 1,

  /**
   * School-wide report with class-section aggregates
   *
   * @generated from enum value: SCHOOL_REPORT = 2;
   */
  SCHOOL_REPORT = 2,

  /**
   * @generated from enum value: TEACHER_PERFORMANCE_REPORT = 3;
   */
  TEACHER_PERFORMANCE_REPORT = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(AdminLevelReportTypeEnum)
proto3.util.setEnumType(AdminLevelReportTypeEnum, "geneo.lms.db.AdminLevelReportTypeEnum", [
  { no: 0, name: "ADMIN_LEVEL_REPORT_TYPE_UNDEFINED" },
  { no: 1, name: "SECTION_REPORT" },
  { no: 2, name: "SCHOOL_REPORT" },
  { no: 3, name: "TEACHER_PERFORMANCE_REPORT" },
]);

/**
 * Enum for SessionModeEnum
 *
 * @generated from enum geneo.lms.db.AssessmentSessionModeEnum
 */
export enum AssessmentSessionModeEnum {
  /**
   * Represents an undefined session mode
   *
   * @generated from enum value: ASSESSMENT_SESSION_MODE_UNDEFINED = 0;
   */
  ASSESSMENT_SESSION_MODE_UNDEFINED = 0,

  /**
   * Represents a session mode of lesson
   *
   * @generated from enum value: ASSESSMENT_SESSION_MODE_FIRST_ATTEMPT = 1;
   */
  ASSESSMENT_SESSION_MODE_FIRST_ATTEMPT = 1,

  /**
   * Represents a session mode of learn
   *
   * @generated from enum value: ASSESSMENT_SESSION_MODE_REATTEMPT = 2;
   */
  ASSESSMENT_SESSION_MODE_REATTEMPT = 2,

  /**
   * Represents a session mode of assessment
   *
   * @generated from enum value: ASSESSMENT_SESSION_MODE_RESUME = 3;
   */
  ASSESSMENT_SESSION_MODE_RESUME = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(AssessmentSessionModeEnum)
proto3.util.setEnumType(AssessmentSessionModeEnum, "geneo.lms.db.AssessmentSessionModeEnum", [
  { no: 0, name: "ASSESSMENT_SESSION_MODE_UNDEFINED" },
  { no: 1, name: "ASSESSMENT_SESSION_MODE_FIRST_ATTEMPT" },
  { no: 2, name: "ASSESSMENT_SESSION_MODE_REATTEMPT" },
  { no: 3, name: "ASSESSMENT_SESSION_MODE_RESUME" },
]);

/**
 * Enum for SessionModeEnum
 *
 * @generated from enum geneo.lms.db.TeacherAssessmentAttemptModeEnum
 */
export enum TeacherAssessmentAttemptModeEnum {
  /**
   * Represents an undefined session mode
   *
   * @generated from enum value: TEACHER_ASSESSMENT_ATTEMPT_MODE_UNDEFINED = 0;
   */
  TEACHER_ASSESSMENT_ATTEMPT_MODE_UNDEFINED = 0,

  /**
   * Represents a session mode of lesson
   *
   * @generated from enum value: TEACHER_ASSESSMENT_ATTEMPT_MODE_FIRST_START = 1;
   */
  TEACHER_ASSESSMENT_ATTEMPT_MODE_FIRST_START = 1,

  /**
   * Represents a session mode of learn
   *
   * @generated from enum value: TEACHER_ASSESSMENT_ATTEMPT_MODE_RESTART = 2;
   */
  TEACHER_ASSESSMENT_ATTEMPT_MODE_RESTART = 2,

  /**
   * Represents a session mode of assessment
   *
   * @generated from enum value: TEACHER_ASSESSMENT_ATTEMPT_MODE_RESUME = 3;
   */
  TEACHER_ASSESSMENT_ATTEMPT_MODE_RESUME = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(TeacherAssessmentAttemptModeEnum)
proto3.util.setEnumType(TeacherAssessmentAttemptModeEnum, "geneo.lms.db.TeacherAssessmentAttemptModeEnum", [
  { no: 0, name: "TEACHER_ASSESSMENT_ATTEMPT_MODE_UNDEFINED" },
  { no: 1, name: "TEACHER_ASSESSMENT_ATTEMPT_MODE_FIRST_START" },
  { no: 2, name: "TEACHER_ASSESSMENT_ATTEMPT_MODE_RESTART" },
  { no: 3, name: "TEACHER_ASSESSMENT_ATTEMPT_MODE_RESUME" },
]);

/**
 * @generated from enum geneo.lms.db.FileUploadStatus
 */
export enum FileUploadStatus {
  /**
   * @generated from enum value: FILE_UPLOAD_STATUS_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: FILE_UPLOAD_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: FILE_UPLOAD_STATUS_PROCESSING = 2;
   */
  PROCESSING = 2,

  /**
   * @generated from enum value: FILE_UPLOAD_STATUS_VALIDATED = 3;
   */
  VALIDATED = 3,

  /**
   * @generated from enum value: FILE_UPLOAD_STATUS_FAILED = 4;
   */
  FAILED = 4,

  /**
   * @generated from enum value: FILE_UPLOAD_STATUS_COMPLETED = 5;
   */
  COMPLETED = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(FileUploadStatus)
proto3.util.setEnumType(FileUploadStatus, "geneo.lms.db.FileUploadStatus", [
  { no: 0, name: "FILE_UPLOAD_STATUS_UNDEFINED" },
  { no: 1, name: "FILE_UPLOAD_STATUS_PENDING" },
  { no: 2, name: "FILE_UPLOAD_STATUS_PROCESSING" },
  { no: 3, name: "FILE_UPLOAD_STATUS_VALIDATED" },
  { no: 4, name: "FILE_UPLOAD_STATUS_FAILED" },
  { no: 5, name: "FILE_UPLOAD_STATUS_COMPLETED" },
]);

/**
 * @generated from enum geneo.lms.db.AttemptTypeEnum
 */
export enum AttemptTypeEnum {
  /**
   * @generated from enum value: ATTEMPT_TYPE_UNDEFINED = 0;
   */
  ATTEMPT_TYPE_UNDEFINED = 0,

  /**
   * @generated from enum value: ATTEMPT_TYPE_NORMAL = 1;
   */
  ATTEMPT_TYPE_NORMAL = 1,

  /**
   * @generated from enum value: ATTEMPT_TYPE_BEST = 2;
   */
  ATTEMPT_TYPE_BEST = 2,

  /**
   * @generated from enum value: ATTEMPT_TYPE_LATEST = 3;
   */
  ATTEMPT_TYPE_LATEST = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(AttemptTypeEnum)
proto3.util.setEnumType(AttemptTypeEnum, "geneo.lms.db.AttemptTypeEnum", [
  { no: 0, name: "ATTEMPT_TYPE_UNDEFINED" },
  { no: 1, name: "ATTEMPT_TYPE_NORMAL" },
  { no: 2, name: "ATTEMPT_TYPE_BEST" },
  { no: 3, name: "ATTEMPT_TYPE_LATEST" },
]);

/**
 * @generated from enum geneo.lms.db.MultiSubjectSectionStatusEnum
 */
export enum MultiSubjectSectionStatusEnum {
  /**
   * Represents an undefined multi subject section
   *
   * @generated from enum value: MULTI_SUBJECT_SECTION_STATUS_UNDEFINED = 0;
   */
  MULTI_SUBJECT_SECTION_STATUS_UNDEFINED = 0,

  /**
   * Represents an initialized multi subject section
   *
   * @generated from enum value: MULTI_SUBJECT_SECTION_STATUS_INITIALIZED = 1;
   */
  MULTI_SUBJECT_SECTION_STATUS_INITIALIZED = 1,

  /**
   * Represents a draft multi subject section
   *
   * @generated from enum value: MULTI_SUBJECT_SECTION_STATUS_DRAFT = 2;
   */
  MULTI_SUBJECT_SECTION_STATUS_DRAFT = 2,

  /**
   * Represents an approved multi subject section
   *
   * @generated from enum value: MULTI_SUBJECT_SECTION_STATUS_APPROVED = 3;
   */
  MULTI_SUBJECT_SECTION_STATUS_APPROVED = 3,

  /**
   * Represents a duplicated multi subject section
   *
   * @generated from enum value: MULTI_SUBJECT_SECTION_STATUS_DUPLICATED = 4;
   */
  MULTI_SUBJECT_SECTION_STATUS_DUPLICATED = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(MultiSubjectSectionStatusEnum)
proto3.util.setEnumType(MultiSubjectSectionStatusEnum, "geneo.lms.db.MultiSubjectSectionStatusEnum", [
  { no: 0, name: "MULTI_SUBJECT_SECTION_STATUS_UNDEFINED" },
  { no: 1, name: "MULTI_SUBJECT_SECTION_STATUS_INITIALIZED" },
  { no: 2, name: "MULTI_SUBJECT_SECTION_STATUS_DRAFT" },
  { no: 3, name: "MULTI_SUBJECT_SECTION_STATUS_APPROVED" },
  { no: 4, name: "MULTI_SUBJECT_SECTION_STATUS_DUPLICATED" },
]);

/**
 * @generated from message geneo.lms.db.FeatureFlag
 */
export class FeatureFlag extends Message<FeatureFlag> {
  /**
   * @generated from field: optional int32 id = 1;
   */
  id?: number;

  /**
   * @generated from field: geneo.lms.db.FeatureKeyEnum featureName = 2;
   */
  featureName = FeatureKeyEnum.FEATURE_KEY_UNSPECIFIED;

  /**
   * @generated from field: repeated string levels = 3;
   */
  levels: string[] = [];

  /**
   * @generated from field: bool enabled = 4;
   */
  enabled = false;

  /**
   * @generated from field: int32 schoolId = 5;
   */
  schoolId = 0;

  /**
   * @generated from field: string schoolDeviceId = 6;
   */
  schoolDeviceId = "";

  constructor(data?: PartialMessage<FeatureFlag>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.FeatureFlag";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 2, name: "featureName", kind: "enum", T: proto3.getEnumType(FeatureKeyEnum) },
    { no: 3, name: "levels", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "schoolId", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "schoolDeviceId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FeatureFlag {
    return new FeatureFlag().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FeatureFlag {
    return new FeatureFlag().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FeatureFlag {
    return new FeatureFlag().fromJsonString(jsonString, options);
  }

  static equals(a: FeatureFlag | PlainMessage<FeatureFlag> | undefined, b: FeatureFlag | PlainMessage<FeatureFlag> | undefined): boolean {
    return proto3.util.equals(FeatureFlag, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.TaskQuestionInfo
 */
export class TaskQuestionInfo extends Message<TaskQuestionInfo> {
  /**
   * Parent Task ID
   *
   * @generated from field: optional string parent_task_id = 1;
   */
  parentTaskId?: string;

  /**
   * Question Task ID
   *
   * @generated from field: optional string question_task_id = 2;
   */
  questionTaskId?: string;

  /**
   * Question ID
   *
   * @generated from field: optional string question_id = 3;
   */
  questionId?: string;

  /**
   * @generated from field: geneo.content.db.Question.QuestionEnum question_type = 4;
   */
  questionType = Question_QuestionEnum.QUESTION_TYPE_UNDEFINED;

  /**
   * Sequence number
   *
   * @generated from field: int32 sequence = 5;
   */
  sequence = 0;

  /**
   * @generated from field: float estimated_time_in_min = 6;
   */
  estimatedTimeInMin = 0;

  /**
   * @generated from field: optional float max_marks = 7;
   */
  maxMarks?: number;

  /**
   * @generated from field: optional int32 subject_id = 8;
   */
  subjectId?: number;

  /**
   * @generated from field: optional int32 chapter_id = 9;
   */
  chapterId?: number;

  /**
   * @generated from field: optional int32 topic_id = 10;
   */
  topicId?: number;

  /**
   * @generated from field: optional int32 section_no = 11;
   */
  sectionNo?: number;

  constructor(data?: PartialMessage<TaskQuestionInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.TaskQuestionInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "parent_task_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "question_task_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "question_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "question_type", kind: "enum", T: proto3.getEnumType(Question_QuestionEnum) },
    { no: 5, name: "sequence", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "estimated_time_in_min", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "max_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 8, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 9, name: "chapter_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 10, name: "topic_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 11, name: "section_no", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TaskQuestionInfo {
    return new TaskQuestionInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TaskQuestionInfo {
    return new TaskQuestionInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TaskQuestionInfo {
    return new TaskQuestionInfo().fromJsonString(jsonString, options);
  }

  static equals(a: TaskQuestionInfo | PlainMessage<TaskQuestionInfo> | undefined, b: TaskQuestionInfo | PlainMessage<TaskQuestionInfo> | undefined): boolean {
    return proto3.util.equals(TaskQuestionInfo, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.QuestionTypeMarks
 */
export class QuestionTypeMarks extends Message<QuestionTypeMarks> {
  /**
   * @generated from field: geneo.content.db.Question.QuestionEnum question_type = 1;
   */
  questionType = Question_QuestionEnum.QUESTION_TYPE_UNDEFINED;

  /**
   * @generated from field: float marks = 2;
   */
  marks = 0;

  constructor(data?: PartialMessage<QuestionTypeMarks>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.QuestionTypeMarks";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "question_type", kind: "enum", T: proto3.getEnumType(Question_QuestionEnum) },
    { no: 2, name: "marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuestionTypeMarks {
    return new QuestionTypeMarks().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuestionTypeMarks {
    return new QuestionTypeMarks().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuestionTypeMarks {
    return new QuestionTypeMarks().fromJsonString(jsonString, options);
  }

  static equals(a: QuestionTypeMarks | PlainMessage<QuestionTypeMarks> | undefined, b: QuestionTypeMarks | PlainMessage<QuestionTypeMarks> | undefined): boolean {
    return proto3.util.equals(QuestionTypeMarks, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.TaskResourceInfoMetaData
 */
export class TaskResourceInfoMetaData extends Message<TaskResourceInfoMetaData> {
  /**
   * @generated from oneof geneo.lms.db.TaskResourceInfoMetaData.info
   */
  info: {
    /**
     * @generated from field: geneo.lms.db.PracticalTaskResourceMetaData practical = 1;
     */
    value: PracticalTaskResourceMetaData;
    case: "practical";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<TaskResourceInfoMetaData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.TaskResourceInfoMetaData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "practical", kind: "message", T: PracticalTaskResourceMetaData, oneof: "info" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TaskResourceInfoMetaData {
    return new TaskResourceInfoMetaData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TaskResourceInfoMetaData {
    return new TaskResourceInfoMetaData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TaskResourceInfoMetaData {
    return new TaskResourceInfoMetaData().fromJsonString(jsonString, options);
  }

  static equals(a: TaskResourceInfoMetaData | PlainMessage<TaskResourceInfoMetaData> | undefined, b: TaskResourceInfoMetaData | PlainMessage<TaskResourceInfoMetaData> | undefined): boolean {
    return proto3.util.equals(TaskResourceInfoMetaData, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.PracticalTaskResourceMetaData
 */
export class PracticalTaskResourceMetaData extends Message<PracticalTaskResourceMetaData> {
  /**
   * @generated from field: optional geneo.content.db.PracticalProject teacher_solution = 1;
   */
  teacherSolution?: PracticalProject;

  constructor(data?: PartialMessage<PracticalTaskResourceMetaData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.PracticalTaskResourceMetaData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_solution", kind: "message", T: PracticalProject, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PracticalTaskResourceMetaData {
    return new PracticalTaskResourceMetaData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PracticalTaskResourceMetaData {
    return new PracticalTaskResourceMetaData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PracticalTaskResourceMetaData {
    return new PracticalTaskResourceMetaData().fromJsonString(jsonString, options);
  }

  static equals(a: PracticalTaskResourceMetaData | PlainMessage<PracticalTaskResourceMetaData> | undefined, b: PracticalTaskResourceMetaData | PlainMessage<PracticalTaskResourceMetaData> | undefined): boolean {
    return proto3.util.equals(PracticalTaskResourceMetaData, a, b);
  }
}

/**
 * Lesson-plan resource selected by a teacher for a project task.
 *
 * @generated from message geneo.lms.db.TaskResourceInfo
 */
export class TaskResourceInfo extends Message<TaskResourceInfo> {
  /**
   * @generated from field: string resource_id = 1;
   */
  resourceId = "";

  /**
   * lesson plan the resource was picked from
   *
   * @generated from field: optional string lesson_id = 2;
   */
  lessonId?: string;

  /**
   * chapter/topic the lesson plan hangs off
   *
   * @generated from field: optional int32 module_id = 3;
   */
  moduleId?: number;

  /**
   * @generated from field: int32 sequence = 4;
   */
  sequence = 0;

  /**
   * @generated from field: geneo.content.db.Resource.ResourceEnum resource_type = 5;
   */
  resourceType = Resource_ResourceEnum.RESOURCE_TYPE_UNDEFINED;

  /**
   * @generated from field: optional string title = 6;
   */
  title?: string;

  /**
   * @generated from field: float estimated_time_in_min = 7;
   */
  estimatedTimeInMin = 0;

  /**
   * @generated from field: optional geneo.lms.db.TaskResourceInfoMetaData meta_data = 8;
   */
  metaData?: TaskResourceInfoMetaData;

  constructor(data?: PartialMessage<TaskResourceInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.TaskResourceInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "resource_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "lesson_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "module_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "sequence", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "resource_type", kind: "enum", T: proto3.getEnumType(Resource_ResourceEnum) },
    { no: 6, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "estimated_time_in_min", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 8, name: "meta_data", kind: "message", T: TaskResourceInfoMetaData, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TaskResourceInfo {
    return new TaskResourceInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TaskResourceInfo {
    return new TaskResourceInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TaskResourceInfo {
    return new TaskResourceInfo().fromJsonString(jsonString, options);
  }

  static equals(a: TaskResourceInfo | PlainMessage<TaskResourceInfo> | undefined, b: TaskResourceInfo | PlainMessage<TaskResourceInfo> | undefined): boolean {
    return proto3.util.equals(TaskResourceInfo, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.TaskInfo
 */
export class TaskInfo extends Message<TaskInfo> {
  /**
   * Homework ID
   *
   * @generated from field: optional int64 homework_id = 1;
   */
  homeworkId?: bigint;

  /**
   * @generated from field: repeated string question_ids = 2;
   */
  questionIds: string[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.TaskQuestionInfo task_question_info = 3;
   */
  taskQuestionInfo: TaskQuestionInfo[] = [];

  /**
   * @generated from field: optional float estimated_time_in_min = 4;
   */
  estimatedTimeInMin?: number;

  /**
   * @generated from field: repeated geneo.lms.db.QuestionSectionMeta question_section_meta_info = 5;
   */
  questionSectionMetaInfo: QuestionSectionMeta[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.QuestionModuleMap question_module_map = 6;
   */
  questionModuleMap: QuestionModuleMap[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.QuestionTypeMarks question_type_and_marks = 7;
   */
  questionTypeAndMarks: QuestionTypeMarks[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.MultiSubjectSection multi_subject_sections = 8;
   */
  multiSubjectSections: MultiSubjectSection[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.OMRSetInfo omr_set_info = 9;
   */
  omrSetInfo: OMRSetInfo[] = [];

  /**
   * @generated from field: optional int32 marks_per_question = 10;
   */
  marksPerQuestion?: number;

  /**
   * project tasks only
   *
   * @generated from field: repeated geneo.lms.db.TaskResourceInfo task_resource_info = 11;
   */
  taskResourceInfo: TaskResourceInfo[] = [];

  constructor(data?: PartialMessage<TaskInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.TaskInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "homework_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "question_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "task_question_info", kind: "message", T: TaskQuestionInfo, repeated: true },
    { no: 4, name: "estimated_time_in_min", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 5, name: "question_section_meta_info", kind: "message", T: QuestionSectionMeta, repeated: true },
    { no: 6, name: "question_module_map", kind: "message", T: QuestionModuleMap, repeated: true },
    { no: 7, name: "question_type_and_marks", kind: "message", T: QuestionTypeMarks, repeated: true },
    { no: 8, name: "multi_subject_sections", kind: "message", T: MultiSubjectSection, repeated: true },
    { no: 9, name: "omr_set_info", kind: "message", T: OMRSetInfo, repeated: true },
    { no: 10, name: "marks_per_question", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 11, name: "task_resource_info", kind: "message", T: TaskResourceInfo, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TaskInfo {
    return new TaskInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TaskInfo {
    return new TaskInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TaskInfo {
    return new TaskInfo().fromJsonString(jsonString, options);
  }

  static equals(a: TaskInfo | PlainMessage<TaskInfo> | undefined, b: TaskInfo | PlainMessage<TaskInfo> | undefined): boolean {
    return proto3.util.equals(TaskInfo, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.OMRSetInfo
 */
export class OMRSetInfo extends Message<OMRSetInfo> {
  /**
   * @generated from field: string omr_set_name = 1;
   */
  omrSetName = "";

  /**
   * @generated from field: int32 omr_set_number = 2;
   */
  omrSetNumber = 0;

  /**
   * @generated from field: repeated geneo.lms.db.OMRSectionInfo omr_section_info = 3;
   */
  omrSectionInfo: OMRSectionInfo[] = [];

  constructor(data?: PartialMessage<OMRSetInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.OMRSetInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "omr_set_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "omr_set_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "omr_section_info", kind: "message", T: OMRSectionInfo, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OMRSetInfo {
    return new OMRSetInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OMRSetInfo {
    return new OMRSetInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OMRSetInfo {
    return new OMRSetInfo().fromJsonString(jsonString, options);
  }

  static equals(a: OMRSetInfo | PlainMessage<OMRSetInfo> | undefined, b: OMRSetInfo | PlainMessage<OMRSetInfo> | undefined): boolean {
    return proto3.util.equals(OMRSetInfo, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.OMRSectionInfo
 */
export class OMRSectionInfo extends Message<OMRSectionInfo> {
  /**
   * @generated from field: int32 subject_id = 1;
   */
  subjectId = 0;

  /**
   * @generated from field: geneo.common.db.Subject.SubjectEnum subject = 2;
   */
  subject = Subject_SubjectEnum.UNDEFINED;

  /**
   * @generated from field: optional string section_name = 3;
   */
  sectionName?: string;

  /**
   * @generated from field: repeated geneo.lms.db.OMRQuestionSequenceInfo omr_questions_sequence_info = 4;
   */
  omrQuestionsSequenceInfo: OMRQuestionSequenceInfo[] = [];

  constructor(data?: PartialMessage<OMRSectionInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.OMRSectionInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "subject", kind: "enum", T: proto3.getEnumType(Subject_SubjectEnum) },
    { no: 3, name: "section_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "omr_questions_sequence_info", kind: "message", T: OMRQuestionSequenceInfo, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OMRSectionInfo {
    return new OMRSectionInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OMRSectionInfo {
    return new OMRSectionInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OMRSectionInfo {
    return new OMRSectionInfo().fromJsonString(jsonString, options);
  }

  static equals(a: OMRSectionInfo | PlainMessage<OMRSectionInfo> | undefined, b: OMRSectionInfo | PlainMessage<OMRSectionInfo> | undefined): boolean {
    return proto3.util.equals(OMRSectionInfo, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.OMRQuestionSequenceInfo
 */
export class OMRQuestionSequenceInfo extends Message<OMRQuestionSequenceInfo> {
  /**
   * @generated from field: string question_id = 1;
   */
  questionId = "";

  /**
   * @generated from field: int32 sequence = 2;
   */
  sequence = 0;

  constructor(data?: PartialMessage<OMRQuestionSequenceInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.OMRQuestionSequenceInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "question_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sequence", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OMRQuestionSequenceInfo {
    return new OMRQuestionSequenceInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OMRQuestionSequenceInfo {
    return new OMRQuestionSequenceInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OMRQuestionSequenceInfo {
    return new OMRQuestionSequenceInfo().fromJsonString(jsonString, options);
  }

  static equals(a: OMRQuestionSequenceInfo | PlainMessage<OMRQuestionSequenceInfo> | undefined, b: OMRQuestionSequenceInfo | PlainMessage<OMRQuestionSequenceInfo> | undefined): boolean {
    return proto3.util.equals(OMRQuestionSequenceInfo, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.MultiSubjectSection
 */
export class MultiSubjectSection extends Message<MultiSubjectSection> {
  /**
   * @generated from field: int32 subject_id = 1;
   */
  subjectId = 0;

  /**
   * @generated from field: geneo.common.db.Subject.SubjectEnum subject = 2;
   */
  subject = Subject_SubjectEnum.UNDEFINED;

  /**
   * @generated from field: string section_name = 3;
   */
  sectionName = "";

  /**
   * @generated from field: string section_title = 4;
   */
  sectionTitle = "";

  /**
   * @generated from field: repeated string instructions = 5;
   */
  instructions: string[] = [];

  /**
   * @generated from field: optional int32 section_no = 6;
   */
  sectionNo?: number;

  /**
   * @generated from field: int32 number_of_question = 7;
   */
  numberOfQuestion = 0;

  /**
   * @generated from field: float preferred_marks = 8;
   */
  preferredMarks = 0;

  /**
   * @generated from field: float total_marks = 9;
   */
  totalMarks = 0;

  /**
   * @generated from field: geneo.lms.db.MultiSubjectSectionStatusEnum multi_subject_section_status = 10;
   */
  multiSubjectSectionStatus = MultiSubjectSectionStatusEnum.MULTI_SUBJECT_SECTION_STATUS_UNDEFINED;

  /**
   * @generated from field: geneo.content.db.DifficultyLevelEnum avg_difficulty_level = 11;
   */
  avgDifficultyLevel = DifficultyLevelEnum.DIFFICULTY_LEVEL_UNDEFINED;

  /**
   * @generated from field: repeated geneo.lms.db.MultiSubjectSubSection multi_subject_sub_sections = 12;
   */
  multiSubjectSubSections: MultiSubjectSubSection[] = [];

  /**
   * @generated from field: geneo.lms.db.ChapterInfo chapterInfo = 13;
   */
  chapterInfo?: ChapterInfo;

  /**
   * @generated from field: optional int32 template_id = 14;
   */
  templateId?: number;

  /**
   * @generated from field: bool is_ai_generated = 15;
   */
  isAiGenerated = false;

  /**
   * @generated from field: optional geneo.lms.db.TaskStudentAttemptStatusEnum assessment_section_attempt_status = 16;
   */
  assessmentSectionAttemptStatus?: TaskStudentAttemptStatusEnum;

  /**
   * @generated from field: optional geneo.lms.db.MarkingSchemeEnum marking_scheme_type = 17;
   */
  markingSchemeType?: MarkingSchemeEnum;

  /**
   * @generated from field: optional int64 source_assessment_id = 18;
   */
  sourceAssessmentId?: bigint;

  /**
   * @generated from field: repeated string ai_question_prompts = 19;
   */
  aiQuestionPrompts: string[] = [];

  constructor(data?: PartialMessage<MultiSubjectSection>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.MultiSubjectSection";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "subject", kind: "enum", T: proto3.getEnumType(Subject_SubjectEnum) },
    { no: 3, name: "section_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "section_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "instructions", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "section_no", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 7, name: "number_of_question", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "preferred_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 9, name: "total_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 10, name: "multi_subject_section_status", kind: "enum", T: proto3.getEnumType(MultiSubjectSectionStatusEnum) },
    { no: 11, name: "avg_difficulty_level", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum) },
    { no: 12, name: "multi_subject_sub_sections", kind: "message", T: MultiSubjectSubSection, repeated: true },
    { no: 13, name: "chapterInfo", kind: "message", T: ChapterInfo },
    { no: 14, name: "template_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 15, name: "is_ai_generated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 16, name: "assessment_section_attempt_status", kind: "enum", T: proto3.getEnumType(TaskStudentAttemptStatusEnum), opt: true },
    { no: 17, name: "marking_scheme_type", kind: "enum", T: proto3.getEnumType(MarkingSchemeEnum), opt: true },
    { no: 18, name: "source_assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 19, name: "ai_question_prompts", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MultiSubjectSection {
    return new MultiSubjectSection().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MultiSubjectSection {
    return new MultiSubjectSection().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MultiSubjectSection {
    return new MultiSubjectSection().fromJsonString(jsonString, options);
  }

  static equals(a: MultiSubjectSection | PlainMessage<MultiSubjectSection> | undefined, b: MultiSubjectSection | PlainMessage<MultiSubjectSection> | undefined): boolean {
    return proto3.util.equals(MultiSubjectSection, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.SubSectionQuestionType
 */
export class SubSectionQuestionType extends Message<SubSectionQuestionType> {
  /**
   * @generated from field: geneo.content.db.Question.QuestionEnum question_type = 2;
   */
  questionType = Question_QuestionEnum.QUESTION_TYPE_UNDEFINED;

  /**
   * @generated from field: int32 no_of_question = 3;
   */
  noOfQuestion = 0;

  /**
   * @generated from field: optional float marks = 4;
   */
  marks?: number;

  /**
   * @generated from field: bool is_alternate_enable = 5;
   */
  isAlternateEnable = false;

  /**
   * @generated from field: optional bool is_grouped = 6;
   */
  isGrouped?: boolean;

  /**
   * @generated from field: optional string group_question_heading = 7;
   */
  groupQuestionHeading?: string;

  /**
   * @generated from field: optional int32 group_question_attempted_any = 8;
   */
  groupQuestionAttemptedAny?: number;

  constructor(data?: PartialMessage<SubSectionQuestionType>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.SubSectionQuestionType";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 2, name: "question_type", kind: "enum", T: proto3.getEnumType(Question_QuestionEnum) },
    { no: 3, name: "no_of_question", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 5, name: "is_alternate_enable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "is_grouped", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 7, name: "group_question_heading", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "group_question_attempted_any", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubSectionQuestionType {
    return new SubSectionQuestionType().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubSectionQuestionType {
    return new SubSectionQuestionType().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubSectionQuestionType {
    return new SubSectionQuestionType().fromJsonString(jsonString, options);
  }

  static equals(a: SubSectionQuestionType | PlainMessage<SubSectionQuestionType> | undefined, b: SubSectionQuestionType | PlainMessage<SubSectionQuestionType> | undefined): boolean {
    return proto3.util.equals(SubSectionQuestionType, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.MultiSubjectSubSection
 */
export class MultiSubjectSubSection extends Message<MultiSubjectSubSection> {
  /**
   * @generated from field: string sub_section_name = 1;
   */
  subSectionName = "";

  /**
   * @generated from field: string sub_section_title = 2;
   */
  subSectionTitle = "";

  /**
   * @generated from field: repeated string instructions = 3;
   */
  instructions: string[] = [];

  /**
   * @generated from field: optional int32 sub_section_no = 4;
   */
  subSectionNo?: number;

  /**
   * @generated from field: repeated geneo.lms.db.SectionQuestionMetaData sub_section_meta_data = 5;
   */
  subSectionMetaData: SectionQuestionMetaData[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.QuestionTypeMarks question_type_and_marks = 6;
   */
  questionTypeAndMarks: QuestionTypeMarks[] = [];

  /**
   * @generated from field: repeated string passage_text = 7;
   */
  passageText: string[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.CloudUpload passage_images_upload = 8;
   */
  passageImagesUpload: CloudUpload[] = [];

  /**
   * @generated from field: optional int32 attempt_any_count = 9;
   */
  attemptAnyCount?: number;

  /**
   * @generated from field: optional bool is_validate = 10;
   */
  isValidate?: boolean;

  /**
   * @generated from field: optional geneo.lms.db.QpgSubsectionTypeEnum sub_section_type = 11;
   */
  subSectionType?: QpgSubsectionTypeEnum;

  /**
   * @generated from field: optional bool is_ai_generated_passage = 12;
   */
  isAiGeneratedPassage?: boolean;

  /**
   * @generated from field: repeated geneo.lms.db.SubSectionQuestionType seting_meta_info = 13;
   */
  setingMetaInfo: SubSectionQuestionType[] = [];

  constructor(data?: PartialMessage<MultiSubjectSubSection>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.MultiSubjectSubSection";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sub_section_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sub_section_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "instructions", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "sub_section_no", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "sub_section_meta_data", kind: "message", T: SectionQuestionMetaData, repeated: true },
    { no: 6, name: "question_type_and_marks", kind: "message", T: QuestionTypeMarks, repeated: true },
    { no: 7, name: "passage_text", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "passage_images_upload", kind: "message", T: CloudUpload, repeated: true },
    { no: 9, name: "attempt_any_count", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 10, name: "is_validate", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 11, name: "sub_section_type", kind: "enum", T: proto3.getEnumType(QpgSubsectionTypeEnum), opt: true },
    { no: 12, name: "is_ai_generated_passage", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 13, name: "seting_meta_info", kind: "message", T: SubSectionQuestionType, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MultiSubjectSubSection {
    return new MultiSubjectSubSection().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MultiSubjectSubSection {
    return new MultiSubjectSubSection().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MultiSubjectSubSection {
    return new MultiSubjectSubSection().fromJsonString(jsonString, options);
  }

  static equals(a: MultiSubjectSubSection | PlainMessage<MultiSubjectSubSection> | undefined, b: MultiSubjectSubSection | PlainMessage<MultiSubjectSubSection> | undefined): boolean {
    return proto3.util.equals(MultiSubjectSubSection, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.QuestionSectionMeta
 */
export class QuestionSectionMeta extends Message<QuestionSectionMeta> {
  /**
   * @generated from field: string question_section_name = 1;
   */
  questionSectionName = "";

  /**
   * @generated from field: repeated geneo.lms.db.SectionQuestionMetaData section_questions_info = 2;
   */
  sectionQuestionsInfo: SectionQuestionMetaData[] = [];

  /**
   * @generated from field: repeated string instruction = 3;
   */
  instruction: string[] = [];

  /**
   * @generated from field: int32 section_no = 4;
   */
  sectionNo = 0;

  constructor(data?: PartialMessage<QuestionSectionMeta>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.QuestionSectionMeta";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "question_section_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "section_questions_info", kind: "message", T: SectionQuestionMetaData, repeated: true },
    { no: 3, name: "instruction", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "section_no", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuestionSectionMeta {
    return new QuestionSectionMeta().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuestionSectionMeta {
    return new QuestionSectionMeta().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuestionSectionMeta {
    return new QuestionSectionMeta().fromJsonString(jsonString, options);
  }

  static equals(a: QuestionSectionMeta | PlainMessage<QuestionSectionMeta> | undefined, b: QuestionSectionMeta | PlainMessage<QuestionSectionMeta> | undefined): boolean {
    return proto3.util.equals(QuestionSectionMeta, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.SectionQuestionMetaData
 */
export class SectionQuestionMetaData extends Message<SectionQuestionMetaData> {
  /**
   * @generated from field: string question_id = 1;
   */
  questionId = "";

  /**
   * @generated from field: repeated geneo.lms.db.SectionQuestionMetaData alternate_questions = 3;
   */
  alternateQuestions: SectionQuestionMetaData[] = [];

  /**
   * @generated from field: int32 sequence = 4;
   */
  sequence = 0;

  /**
   * @generated from field: bool show_media = 5;
   */
  showMedia = false;

  /**
   * @generated from field: bool is_ai_generated = 6;
   */
  isAiGenerated = false;

  /**
   * @generated from field: float max_marks = 7;
   */
  maxMarks = 0;

  /**
   * @generated from field: optional geneo.content.db.Question.QuestionEnum question_type = 8;
   */
  questionType?: Question_QuestionEnum;

  /**
   * @generated from field: repeated geneo.lms.db.SectionQuestionMetaData grouped_questions = 9;
   */
  groupedQuestions: SectionQuestionMetaData[] = [];

  /**
   * @generated from field: optional bool is_grouped = 10;
   */
  isGrouped?: boolean;

  /**
   * @generated from field: optional string group_question_heading = 11;
   */
  groupQuestionHeading?: string;

  /**
   * @generated from field: optional int32 group_question_attempted_any = 12;
   */
  groupQuestionAttemptedAny?: number;

  constructor(data?: PartialMessage<SectionQuestionMetaData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.SectionQuestionMetaData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "question_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "alternate_questions", kind: "message", T: SectionQuestionMetaData, repeated: true },
    { no: 4, name: "sequence", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "show_media", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "is_ai_generated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "max_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 8, name: "question_type", kind: "enum", T: proto3.getEnumType(Question_QuestionEnum), opt: true },
    { no: 9, name: "grouped_questions", kind: "message", T: SectionQuestionMetaData, repeated: true },
    { no: 10, name: "is_grouped", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 11, name: "group_question_heading", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "group_question_attempted_any", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SectionQuestionMetaData {
    return new SectionQuestionMetaData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SectionQuestionMetaData {
    return new SectionQuestionMetaData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SectionQuestionMetaData {
    return new SectionQuestionMetaData().fromJsonString(jsonString, options);
  }

  static equals(a: SectionQuestionMetaData | PlainMessage<SectionQuestionMetaData> | undefined, b: SectionQuestionMetaData | PlainMessage<SectionQuestionMetaData> | undefined): boolean {
    return proto3.util.equals(SectionQuestionMetaData, a, b);
  }
}

/**
 * Message for student_group table
 *
 * @generated from message geneo.lms.db.StudentGroup
 */
export class StudentGroup extends Message<StudentGroup> {
  /**
   * Primary key for student_group
   *
   * @generated from field: optional int64 student_group_id = 1;
   */
  studentGroupId?: bigint;

  /**
   * Group name
   *
   * @generated from field: string group_name = 2;
   */
  groupName = "";

  /**
   * Foreign key referencing school_management.school_teacher_class_course (school_teacher_class_course_id)
   *
   * @generated from field: optional int64 school_class_section_id = 3;
   */
  schoolClassSectionId?: bigint;

  /**
   * Array of student user IDs
   *
   * @generated from field: repeated int64 student_ids = 4;
   */
  studentIds: bigint[] = [];

  /**
   * Creation timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_on = 5;
   */
  createdOn?: Timestamp;

  /**
   * User who created the entry
   *
   * @generated from field: optional int64 created_by = 6;
   */
  createdBy?: bigint;

  /**
   * Last modification timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp modified_on = 7;
   */
  modifiedOn?: Timestamp;

  /**
   * User who last modified the entry
   *
   * @generated from field: optional int64 modified_by = 8;
   */
  modifiedBy?: bigint;

  /**
   * @generated from field: optional string nano_id = 9;
   */
  nanoId?: string;

  /**
   * @generated from field: optional int32 school_id = 10;
   */
  schoolId?: number;

  /**
   * @generated from field: optional int64 school_device_id = 11;
   */
  schoolDeviceId?: bigint;

  /**
   * @generated from field: optional int32 version = 12;
   */
  version?: number;

  constructor(data?: PartialMessage<StudentGroup>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.StudentGroup";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_group_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "group_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "school_class_section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 4, name: "student_ids", kind: "scalar", T: 3 /* ScalarType.INT64 */, repeated: true },
    { no: 5, name: "created_on", kind: "message", T: Timestamp },
    { no: 6, name: "created_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 7, name: "modified_on", kind: "message", T: Timestamp, opt: true },
    { no: 8, name: "modified_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 9, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 11, name: "school_device_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 12, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentGroup {
    return new StudentGroup().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentGroup {
    return new StudentGroup().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentGroup {
    return new StudentGroup().fromJsonString(jsonString, options);
  }

  static equals(a: StudentGroup | PlainMessage<StudentGroup> | undefined, b: StudentGroup | PlainMessage<StudentGroup> | undefined): boolean {
    return proto3.util.equals(StudentGroup, a, b);
  }
}

/**
 * Message for task_default_instructions table
 *
 * @generated from message geneo.lms.db.TaskDefaultInstructions
 */
export class TaskDefaultInstructions extends Message<TaskDefaultInstructions> {
  /**
   * Primary key for task_default_instructions
   *
   * @generated from field: optional int64 id = 1;
   */
  id?: bigint;

  /**
   * Referencing key for task_default_instructions
   *
   * @generated from field: optional string task_instruction_id = 2;
   */
  taskInstructionId?: string;

  /**
   * Type of task (enum: task_type_enum)
   *
   * @generated from field: string task_type = 3;
   */
  taskType = "";

  /**
   * Default instructions for the task
   *
   * @generated from field: repeated string instructions = 4;
   */
  instructions: string[] = [];

  /**
   * Creation timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_on = 5;
   */
  createdOn?: Timestamp;

  /**
   * User who created the entry
   *
   * @generated from field: optional int64 created_by = 6;
   */
  createdBy?: bigint;

  /**
   * Last modification timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp modified_on = 7;
   */
  modifiedOn?: Timestamp;

  /**
   * User who last modified the entry
   *
   * @generated from field: optional int64 modified_by = 8;
   */
  modifiedBy?: bigint;

  /**
   * @generated from field: optional string nano_id = 9;
   */
  nanoId?: string;

  /**
   * @generated from field: optional int32 version = 10;
   */
  version?: number;

  constructor(data?: PartialMessage<TaskDefaultInstructions>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.TaskDefaultInstructions";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "task_instruction_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "task_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "instructions", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "created_on", kind: "message", T: Timestamp },
    { no: 6, name: "created_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 7, name: "modified_on", kind: "message", T: Timestamp, opt: true },
    { no: 8, name: "modified_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 9, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TaskDefaultInstructions {
    return new TaskDefaultInstructions().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TaskDefaultInstructions {
    return new TaskDefaultInstructions().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TaskDefaultInstructions {
    return new TaskDefaultInstructions().fromJsonString(jsonString, options);
  }

  static equals(a: TaskDefaultInstructions | PlainMessage<TaskDefaultInstructions> | undefined, b: TaskDefaultInstructions | PlainMessage<TaskDefaultInstructions> | undefined): boolean {
    return proto3.util.equals(TaskDefaultInstructions, a, b);
  }
}

/**
 * Message for task table
 *
 * @generated from message geneo.lms.db.Task
 */
export class Task extends Message<Task> {
  /**
   * Primary key for task
   *
   * @generated from field: optional int64 id = 1;
   */
  id?: bigint;

  /**
   * @generated from field: optional string task_id = 2;
   */
  taskId?: string;

  /**
   * @generated from field: optional string generic_homework_id = 3;
   */
  genericHomeworkId?: string;

  /**
   * Teacher's user ID
   *
   * @generated from field: optional int64 teacher_id = 4;
   */
  teacherId?: bigint;

  /**
   * Name of the task
   *
   * @generated from field: string task_title = 5;
   */
  taskTitle = "";

  /**
   * Type of task (enum: task_type_enum)
   *
   * @generated from field: optional geneo.lms.db.TaskEnum task_type = 6;
   */
  taskType?: TaskEnum;

  /**
   * Action type of the task (enum: task_action_type_enum)
   *
   * @generated from field: optional geneo.lms.db.TaskActionEnum task_action_type = 7;
   */
  taskActionType?: TaskActionEnum;

  /**
   * Parent task ID (foreign key referencing task.task_id)
   *
   * @generated from field: optional string parent_task_id = 8;
   */
  parentTaskId?: string;

  /**
   * Root task ID
   *
   * @generated from field: optional string root_task_id = 9;
   */
  rootTaskId?: string;

  /**
   * Course ID
   *
   * @generated from field: optional int32 course_id = 10;
   */
  courseId?: number;

  /**
   * Course module ID
   *
   * @generated from field: optional int32 module_id = 11;
   */
  moduleId?: number;

  /**
   * Task level
   *
   * @generated from field: optional int32 level = 12;
   */
  level?: number;

  /**
   * Position of the task
   *
   * @generated from field: int32 position = 13;
   */
  position = 0;

  /**
   * Task description
   *
   * @generated from field: string description = 14;
   */
  description = "";

  /**
   * Task instructions
   *
   * @generated from field: repeated string instructions = 15;
   */
  instructions: string[] = [];

  /**
   * Task difficulty level
   *
   * @generated from field: geneo.content.db.DifficultyLevelEnum difficulty_level = 16;
   */
  difficultyLevel = DifficultyLevelEnum.DIFFICULTY_LEVEL_UNDEFINED;

  /**
   * Source ID for duplicated tasks
   *
   * @generated from field: optional int64 duplicate_task_source_id = 17;
   */
  duplicateTaskSourceId?: bigint;

  /**
   * Number of times task assigned
   *
   * @generated from field: int32 num_assigned = 18;
   */
  numAssigned = 0;

  /**
   * Task data in JSONB format
   *
   * @generated from field: geneo.lms.db.TaskInfo data = 19;
   */
  data?: TaskInfo;

  /**
   * Task creation status (enum: task_creation_status_enum)
   *
   * @generated from field: geneo.lms.db.TaskCreationStatusEnum task_creation_status = 20;
   */
  taskCreationStatus = TaskCreationStatusEnum.TASK_CREATION_STATUS_UNDEFINED;

  /**
   * Creation timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_on = 21;
   */
  createdOn?: Timestamp;

  /**
   * User who created the entry
   *
   * @generated from field: optional int64 created_by = 22;
   */
  createdBy?: bigint;

  /**
   * Last modification timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp modified_on = 23;
   */
  modifiedOn?: Timestamp;

  /**
   * User who last modified the entry
   *
   * @generated from field: optional int64 modified_by = 24;
   */
  modifiedBy?: bigint;

  /**
   * @generated from field: string poster_image_url = 25;
   */
  posterImageUrl = "";

  /**
   * @generated from field: geneo.lms.db.TaskActiveStatusEnum task_active_status = 26;
   */
  taskActiveStatus = TaskActiveStatusEnum.TASK_ACTIVE_STATUS_UNDEFINED;

  /**
   * @generated from field: optional int64 school_class_section_id = 27;
   */
  schoolClassSectionId?: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 28;
   */
  deletedAt?: Timestamp;

  /**
   * @generated from field: repeated geneo.lms.db.CloudUpload task_uploads = 29;
   */
  taskUploads: CloudUpload[] = [];

  /**
   * @generated from field: optional float max_marks = 30;
   */
  maxMarks?: number;

  /**
   * Only for teacher created CUSTOM hws
   *
   * @generated from field: optional geneo.lms.db.SubmissionType submission_type = 31;
   */
  submissionType?: SubmissionType;

  /**
   * New modifications start here
   *
   * List of associated chapter IDs
   *
   * @generated from field: repeated int32 chapter_ids = 32;
   */
  chapterIds: number[] = [];

  /**
   * List of associated topic IDs
   *
   * @generated from field: repeated int32 topic_ids = 33;
   */
  topicIds: number[] = [];

  /**
   * List of associated topic IDs
   *
   * @generated from field: repeated int32 learning_outcome_ids = 34;
   */
  learningOutcomeIds: number[] = [];

  /**
   * @generated from field: optional string nano_id = 35;
   */
  nanoId?: string;

  /**
   * @generated from field: optional int32 school_id = 36;
   */
  schoolId?: number;

  /**
   * @generated from field: optional int64 school_device_id = 37;
   */
  schoolDeviceId?: bigint;

  /**
   * @generated from field: geneo.lms.db.TaskMetaInfo meta_info = 38;
   */
  metaInfo?: TaskMetaInfo;

  /**
   * @generated from field: optional int32 version = 39;
   */
  version?: number;

  /**
   * @generated from field: optional geneo.lms.db.ModeOfConductionEnum mode_of_conduction = 40;
   */
  modeOfConduction?: ModeOfConductionEnum;

  /**
   * @generated from field: optional bool is_ai_assessment = 41;
   */
  isAiAssessment?: boolean;

  /**
   * @generated from field: repeated int32 course_ids = 42;
   */
  courseIds: number[] = [];

  /**
   * @generated from field: optional bool is_multi_subject_assessment_flow = 43;
   */
  isMultiSubjectAssessmentFlow?: boolean;

  constructor(data?: PartialMessage<Task>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.Task";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "task_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "generic_homework_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 5, name: "task_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "task_type", kind: "enum", T: proto3.getEnumType(TaskEnum), opt: true },
    { no: 7, name: "task_action_type", kind: "enum", T: proto3.getEnumType(TaskActionEnum), opt: true },
    { no: 8, name: "parent_task_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "root_task_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "course_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 11, name: "module_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 12, name: "level", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 13, name: "position", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "instructions", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 16, name: "difficulty_level", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum) },
    { no: 17, name: "duplicate_task_source_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 18, name: "num_assigned", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 19, name: "data", kind: "message", T: TaskInfo },
    { no: 20, name: "task_creation_status", kind: "enum", T: proto3.getEnumType(TaskCreationStatusEnum) },
    { no: 21, name: "created_on", kind: "message", T: Timestamp },
    { no: 22, name: "created_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 23, name: "modified_on", kind: "message", T: Timestamp, opt: true },
    { no: 24, name: "modified_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 25, name: "poster_image_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 26, name: "task_active_status", kind: "enum", T: proto3.getEnumType(TaskActiveStatusEnum) },
    { no: 27, name: "school_class_section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 28, name: "deleted_at", kind: "message", T: Timestamp, opt: true },
    { no: 29, name: "task_uploads", kind: "message", T: CloudUpload, repeated: true },
    { no: 30, name: "max_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 31, name: "submission_type", kind: "enum", T: proto3.getEnumType(SubmissionType), opt: true },
    { no: 32, name: "chapter_ids", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 33, name: "topic_ids", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 34, name: "learning_outcome_ids", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 35, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 36, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 37, name: "school_device_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 38, name: "meta_info", kind: "message", T: TaskMetaInfo },
    { no: 39, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 40, name: "mode_of_conduction", kind: "enum", T: proto3.getEnumType(ModeOfConductionEnum), opt: true },
    { no: 41, name: "is_ai_assessment", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 42, name: "course_ids", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 43, name: "is_multi_subject_assessment_flow", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Task {
    return new Task().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Task {
    return new Task().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Task {
    return new Task().fromJsonString(jsonString, options);
  }

  static equals(a: Task | PlainMessage<Task> | undefined, b: Task | PlainMessage<Task> | undefined): boolean {
    return proto3.util.equals(Task, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.QuestionModuleMap
 */
export class QuestionModuleMap extends Message<QuestionModuleMap> {
  /**
   * @generated from field: string question_id = 1;
   */
  questionId = "";

  /**
   * @generated from field: optional int32 chapter_id = 2;
   */
  chapterId?: number;

  /**
   * @generated from field: optional int32 topic_id = 3;
   */
  topicId?: number;

  /**
   * @generated from field: geneo.content.db.Question.QuestionEnum question_type = 4;
   */
  questionType = Question_QuestionEnum.QUESTION_TYPE_UNDEFINED;

  /**
   * @generated from field: geneo.content.db.DifficultyLevelEnum difficulty_level = 5;
   */
  difficultyLevel = DifficultyLevelEnum.DIFFICULTY_LEVEL_UNDEFINED;

  /**
   * @generated from field: optional bool is_previously_used = 6;
   */
  isPreviouslyUsed?: boolean;

  constructor(data?: PartialMessage<QuestionModuleMap>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.QuestionModuleMap";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "question_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "chapter_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 3, name: "topic_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "question_type", kind: "enum", T: proto3.getEnumType(Question_QuestionEnum) },
    { no: 5, name: "difficulty_level", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum) },
    { no: 6, name: "is_previously_used", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuestionModuleMap {
    return new QuestionModuleMap().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuestionModuleMap {
    return new QuestionModuleMap().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuestionModuleMap {
    return new QuestionModuleMap().fromJsonString(jsonString, options);
  }

  static equals(a: QuestionModuleMap | PlainMessage<QuestionModuleMap> | undefined, b: QuestionModuleMap | PlainMessage<QuestionModuleMap> | undefined): boolean {
    return proto3.util.equals(QuestionModuleMap, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.TaskMetaInfo
 */
export class TaskMetaInfo extends Message<TaskMetaInfo> {
  /**
   * @generated from field: geneo.lms.db.ChapterInfo chapterInfo = 1;
   */
  chapterInfo?: ChapterInfo;

  /**
   * @generated from field: repeated string resource_ids = 2;
   */
  resourceIds: string[] = [];

  constructor(data?: PartialMessage<TaskMetaInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.TaskMetaInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "chapterInfo", kind: "message", T: ChapterInfo },
    { no: 2, name: "resource_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TaskMetaInfo {
    return new TaskMetaInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TaskMetaInfo {
    return new TaskMetaInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TaskMetaInfo {
    return new TaskMetaInfo().fromJsonString(jsonString, options);
  }

  static equals(a: TaskMetaInfo | PlainMessage<TaskMetaInfo> | undefined, b: TaskMetaInfo | PlainMessage<TaskMetaInfo> | undefined): boolean {
    return proto3.util.equals(TaskMetaInfo, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.ChapterInfo
 */
export class ChapterInfo extends Message<ChapterInfo> {
  /**
   * @generated from field: repeated geneo.lms.db.ChapterIdsInfo chapterTopicsInfo = 1;
   */
  chapterTopicsInfo: ChapterIdsInfo[] = [];

  constructor(data?: PartialMessage<ChapterInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.ChapterInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "chapterTopicsInfo", kind: "message", T: ChapterIdsInfo, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChapterInfo {
    return new ChapterInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChapterInfo {
    return new ChapterInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChapterInfo {
    return new ChapterInfo().fromJsonString(jsonString, options);
  }

  static equals(a: ChapterInfo | PlainMessage<ChapterInfo> | undefined, b: ChapterInfo | PlainMessage<ChapterInfo> | undefined): boolean {
    return proto3.util.equals(ChapterInfo, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.ChapterIdsInfo
 */
export class ChapterIdsInfo extends Message<ChapterIdsInfo> {
  /**
   * @generated from field: int32 chapter_id = 1;
   */
  chapterId = 0;

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: repeated geneo.lms.db.TopicIdsInfo topic_info = 3;
   */
  topicInfo: TopicIdsInfo[] = [];

  /**
   * @generated from field: int32 chapter_no = 4;
   */
  chapterNo = 0;

  /**
   * @generated from field: optional int32 no_of_questions = 5;
   */
  noOfQuestions?: number;

  /**
   * @generated from field: int32 subject_id = 6;
   */
  subjectId = 0;

  constructor(data?: PartialMessage<ChapterIdsInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.ChapterIdsInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "chapter_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "topic_info", kind: "message", T: TopicIdsInfo, repeated: true },
    { no: 4, name: "chapter_no", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "no_of_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChapterIdsInfo {
    return new ChapterIdsInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChapterIdsInfo {
    return new ChapterIdsInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChapterIdsInfo {
    return new ChapterIdsInfo().fromJsonString(jsonString, options);
  }

  static equals(a: ChapterIdsInfo | PlainMessage<ChapterIdsInfo> | undefined, b: ChapterIdsInfo | PlainMessage<ChapterIdsInfo> | undefined): boolean {
    return proto3.util.equals(ChapterIdsInfo, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.TopicIdsInfo
 */
export class TopicIdsInfo extends Message<TopicIdsInfo> {
  /**
   * @generated from field: int32 topic_id = 1;
   */
  topicId = 0;

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: int32 topic_no = 3;
   */
  topicNo = 0;

  /**
   * @generated from field: optional int32 no_of_questions = 4;
   */
  noOfQuestions?: number;

  constructor(data?: PartialMessage<TopicIdsInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.TopicIdsInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "topic_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "topic_no", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "no_of_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TopicIdsInfo {
    return new TopicIdsInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TopicIdsInfo {
    return new TopicIdsInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TopicIdsInfo {
    return new TopicIdsInfo().fromJsonString(jsonString, options);
  }

  static equals(a: TopicIdsInfo | PlainMessage<TopicIdsInfo> | undefined, b: TopicIdsInfo | PlainMessage<TopicIdsInfo> | undefined): boolean {
    return proto3.util.equals(TopicIdsInfo, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.CloudUpload
 */
export class CloudUpload extends Message<CloudUpload> {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName = "";

  /**
   * @generated from field: int64 person_id = 2;
   */
  personId = protoInt64.zero;

  /**
   * @generated from field: geneo.content.db.FileEnum file_type = 3;
   */
  fileType = FileEnum.FILE_TYPE_UNKNOWN;

  /**
   * @generated from field: optional float file_size_in_mb = 4;
   */
  fileSizeInMb?: number;

  /**
   * @generated from field: optional string gcp_file_url = 5;
   */
  gcpFileUrl?: string;

  /**
   * @generated from field: optional string external_web_resource_url = 6;
   */
  externalWebResourceUrl?: string;

  /**
   * @generated from field: geneo.content.db.FileExtensionEnum file_extension_type = 7;
   */
  fileExtensionType = FileExtensionEnum.FILE_EXTENSION_UNKNOWN;

  /**
   * @generated from field: optional bool is_uploaded = 8;
   */
  isUploaded?: boolean;

  /**
   * @generated from field: optional bool is_deleted = 9;
   */
  isDeleted?: boolean;

  /**
   * @generated from field: optional string signed_url = 10;
   */
  signedUrl?: string;

  /**
   * @generated from field: optional string download_url = 11;
   */
  downloadUrl?: string;

  /**
   * @generated from field: optional string preview_url = 12;
   */
  previewUrl?: string;

  constructor(data?: PartialMessage<CloudUpload>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.CloudUpload";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "file_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "person_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "file_type", kind: "enum", T: proto3.getEnumType(FileEnum) },
    { no: 4, name: "file_size_in_mb", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 5, name: "gcp_file_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "external_web_resource_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "file_extension_type", kind: "enum", T: proto3.getEnumType(FileExtensionEnum) },
    { no: 8, name: "is_uploaded", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 9, name: "is_deleted", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 10, name: "signed_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "download_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "preview_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CloudUpload {
    return new CloudUpload().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CloudUpload {
    return new CloudUpload().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CloudUpload {
    return new CloudUpload().fromJsonString(jsonString, options);
  }

  static equals(a: CloudUpload | PlainMessage<CloudUpload> | undefined, b: CloudUpload | PlainMessage<CloudUpload> | undefined): boolean {
    return proto3.util.equals(CloudUpload, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.AverageMetricsModel
 */
export class AverageMetricsModel extends Message<AverageMetricsModel> {
  /**
   * @generated from field: int32 no_of_submissions = 1;
   */
  noOfSubmissions = 0;

  /**
   * @generated from field: float avg_score = 2;
   */
  avgScore = 0;

  /**
   * Project tasks only: mean resource-completion percentage across every
   * assigned student. This is the whole-task progress figure, aggregated onto
   * the section-wide "all members" group. Stays 0 for every other task type.
   *
   * @generated from field: float avg_progress_percent = 3;
   */
  avgProgressPercent = 0;

  constructor(data?: PartialMessage<AverageMetricsModel>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.AverageMetricsModel";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "no_of_submissions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "avg_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "avg_progress_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AverageMetricsModel {
    return new AverageMetricsModel().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AverageMetricsModel {
    return new AverageMetricsModel().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AverageMetricsModel {
    return new AverageMetricsModel().fromJsonString(jsonString, options);
  }

  static equals(a: AverageMetricsModel | PlainMessage<AverageMetricsModel> | undefined, b: AverageMetricsModel | PlainMessage<AverageMetricsModel> | undefined): boolean {
    return proto3.util.equals(AverageMetricsModel, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.AssignmentConfigInfo
 */
export class AssignmentConfigInfo extends Message<AssignmentConfigInfo> {
  /**
   * @generated from field: repeated geneo.lms.db.AssignmentInfo assignment_info = 1;
   */
  assignmentInfo: AssignmentInfo[] = [];

  constructor(data?: PartialMessage<AssignmentConfigInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.AssignmentConfigInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assignment_info", kind: "message", T: AssignmentInfo, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AssignmentConfigInfo {
    return new AssignmentConfigInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AssignmentConfigInfo {
    return new AssignmentConfigInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AssignmentConfigInfo {
    return new AssignmentConfigInfo().fromJsonString(jsonString, options);
  }

  static equals(a: AssignmentConfigInfo | PlainMessage<AssignmentConfigInfo> | undefined, b: AssignmentConfigInfo | PlainMessage<AssignmentConfigInfo> | undefined): boolean {
    return proto3.util.equals(AssignmentConfigInfo, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.AssignmentInfo
 */
export class AssignmentInfo extends Message<AssignmentInfo> {
  /**
   * @generated from field: geneo.lms.db.AssignmentConfigEnum config_name = 1;
   */
  configName = AssignmentConfigEnum.ASSIGNMENT_CONFIG_UNDEFINED;

  /**
   * @generated from field: bool is_enabled = 2;
   */
  isEnabled = false;

  constructor(data?: PartialMessage<AssignmentInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.AssignmentInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "config_name", kind: "enum", T: proto3.getEnumType(AssignmentConfigEnum) },
    { no: 2, name: "is_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AssignmentInfo {
    return new AssignmentInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AssignmentInfo {
    return new AssignmentInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AssignmentInfo {
    return new AssignmentInfo().fromJsonString(jsonString, options);
  }

  static equals(a: AssignmentInfo | PlainMessage<AssignmentInfo> | undefined, b: AssignmentInfo | PlainMessage<AssignmentInfo> | undefined): boolean {
    return proto3.util.equals(AssignmentInfo, a, b);
  }
}

/**
 * Attendance state for an assigned assessment. Populated when the assignment is
 * created with ASSIGNMENT_CONFIG_ATTENDANCE enabled. The `present` map keys are
 * student profile ids; value true = present, false = absent. A student id that
 * is absent from the map is considered "not yet marked".
 *
 * @generated from message geneo.lms.db.AttendanceInfo
 */
export class AttendanceInfo extends Message<AttendanceInfo> {
  /**
   * @generated from field: bool is_required = 1;
   */
  isRequired = false;

  /**
   * @generated from field: map<int64, bool> present = 2;
   */
  present: { [key: string]: boolean } = {};

  constructor(data?: PartialMessage<AttendanceInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.AttendanceInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "is_required", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "present", kind: "map", K: 3 /* ScalarType.INT64 */, V: {kind: "scalar", T: 8 /* ScalarType.BOOL */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AttendanceInfo {
    return new AttendanceInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AttendanceInfo {
    return new AttendanceInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AttendanceInfo {
    return new AttendanceInfo().fromJsonString(jsonString, options);
  }

  static equals(a: AttendanceInfo | PlainMessage<AttendanceInfo> | undefined, b: AttendanceInfo | PlainMessage<AttendanceInfo> | undefined): boolean {
    return proto3.util.equals(AttendanceInfo, a, b);
  }
}

/**
 * Message for task_group_assignment table
 *
 * @generated from message geneo.lms.db.TaskGroupAssignment
 */
export class TaskGroupAssignment extends Message<TaskGroupAssignment> {
  /**
   * Primary key for task_group_assignment
   *
   * @generated from field: optional int64 task_group_assignment_id = 1;
   */
  taskGroupAssignmentId?: bigint;

  /**
   * Foreign key referencing task.task_id
   *
   * @generated from field: optional string task_id = 2;
   */
  taskId?: string;

  /**
   * @generated from field: optional string parent_task_id = 19;
   */
  parentTaskId?: string;

  /**
   * Student group ID (foreign key referencing student_group.student_group_id)
   *
   * @generated from field: optional int64 student_group_id = 3;
   */
  studentGroupId?: bigint;

  /**
   * Number of students in the group
   *
   * @generated from field: int32 num_students = 4;
   */
  numStudents = 0;

  /**
   * Date when the task was assigned
   *
   * @generated from field: google.protobuf.Timestamp task_assigned_date = 5;
   */
  taskAssignedDate?: Timestamp;

  /**
   * Date when the task commenced
   *
   * @generated from field: google.protobuf.Timestamp task_commence_date = 6;
   */
  taskCommenceDate?: Timestamp;

  /**
   * Target date for task completion
   *
   * @generated from field: google.protobuf.Timestamp task_target_date = 7;
   */
  taskTargetDate?: Timestamp;

  /**
   * Date when the task was completed
   *
   * @generated from field: google.protobuf.Timestamp task_completed_date = 8;
   */
  taskCompletedDate?: Timestamp;

  /**
   * Task cancellation date in JSONB format
   *
   * @generated from field: google.protobuf.Timestamp task_cancellation_date = 9;
   */
  taskCancellationDate?: Timestamp;

  /**
   * Task status (enum: task_group_status_enum)
   *
   * @generated from field: geneo.lms.db.TaskGroupStatusEnum task_group_status = 10;
   */
  taskGroupStatus = TaskGroupStatusEnum.TASK_GROUP_STATUS_UNDEFINED;

  /**
   * Average metrics in JSONB format
   *
   * @generated from field: geneo.lms.db.AverageMetricsModel avg_metrics = 11;
   */
  avgMetrics?: AverageMetricsModel;

  /**
   * Number of completions for the task
   *
   * @generated from field: int32 num_completions = 12;
   */
  numCompletions = 0;

  /**
   * Creation timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_on = 13;
   */
  createdOn?: Timestamp;

  /**
   * User who created the entry
   *
   * @generated from field: optional int64 created_by = 14;
   */
  createdBy?: bigint;

  /**
   * Last modification timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp modified_on = 15;
   */
  modifiedOn?: Timestamp;

  /**
   * User who last modified the entry
   *
   * @generated from field: optional int64 modified_by = 16;
   */
  modifiedBy?: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp daily_reminder_time = 17;
   */
  dailyReminderTime?: Timestamp;

  /**
   * @generated from field: optional bool allow_late_submission = 18;
   */
  allowLateSubmission?: boolean;

  /**
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 20;
   */
  deletedAt?: Timestamp;

  /**
   * @generated from field: optional int64 school_class_section_id = 21;
   */
  schoolClassSectionId?: bigint;

  /**
   * @generated from field: optional geneo.lms.db.AssignmentConfigInfo assignment_config_info = 22;
   */
  assignmentConfigInfo?: AssignmentConfigInfo;

  /**
   * @generated from field: optional string nano_id = 23;
   */
  nanoId?: string;

  /**
   * @generated from field: optional int32 school_id = 24;
   */
  schoolId?: number;

  /**
   * @generated from field: optional int64 school_device_id = 25;
   */
  schoolDeviceId?: bigint;

  /**
   * @generated from field: optional int32 version = 26;
   */
  version?: number;

  /**
   * @generated from field: optional geneo.lms.db.MarkingSchemeEnum marking_scheme_type = 27;
   */
  markingSchemeType?: MarkingSchemeEnum;

  /**
   * @generated from field: optional bool is_custom_assignment = 28;
   */
  isCustomAssignment?: boolean;

  /**
   * @generated from field: optional geneo.lms.db.AttendanceInfo attendance_info = 29;
   */
  attendanceInfo?: AttendanceInfo;

  constructor(data?: PartialMessage<TaskGroupAssignment>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.TaskGroupAssignment";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "task_group_assignment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "task_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 19, name: "parent_task_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "student_group_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 4, name: "num_students", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "task_assigned_date", kind: "message", T: Timestamp },
    { no: 6, name: "task_commence_date", kind: "message", T: Timestamp },
    { no: 7, name: "task_target_date", kind: "message", T: Timestamp },
    { no: 8, name: "task_completed_date", kind: "message", T: Timestamp },
    { no: 9, name: "task_cancellation_date", kind: "message", T: Timestamp },
    { no: 10, name: "task_group_status", kind: "enum", T: proto3.getEnumType(TaskGroupStatusEnum) },
    { no: 11, name: "avg_metrics", kind: "message", T: AverageMetricsModel },
    { no: 12, name: "num_completions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "created_on", kind: "message", T: Timestamp },
    { no: 14, name: "created_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 15, name: "modified_on", kind: "message", T: Timestamp, opt: true },
    { no: 16, name: "modified_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 17, name: "daily_reminder_time", kind: "message", T: Timestamp, opt: true },
    { no: 18, name: "allow_late_submission", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 20, name: "deleted_at", kind: "message", T: Timestamp, opt: true },
    { no: 21, name: "school_class_section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 22, name: "assignment_config_info", kind: "message", T: AssignmentConfigInfo, opt: true },
    { no: 23, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 24, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 25, name: "school_device_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 26, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 27, name: "marking_scheme_type", kind: "enum", T: proto3.getEnumType(MarkingSchemeEnum), opt: true },
    { no: 28, name: "is_custom_assignment", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 29, name: "attendance_info", kind: "message", T: AttendanceInfo, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TaskGroupAssignment {
    return new TaskGroupAssignment().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TaskGroupAssignment {
    return new TaskGroupAssignment().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TaskGroupAssignment {
    return new TaskGroupAssignment().fromJsonString(jsonString, options);
  }

  static equals(a: TaskGroupAssignment | PlainMessage<TaskGroupAssignment> | undefined, b: TaskGroupAssignment | PlainMessage<TaskGroupAssignment> | undefined): boolean {
    return proto3.util.equals(TaskGroupAssignment, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.ProctoringMetricsModel
 */
export class ProctoringMetricsModel extends Message<ProctoringMetricsModel> {
  /**
   * @generated from field: repeated google.protobuf.Timestamp full_screen_exits = 1;
   */
  fullScreenExits: Timestamp[] = [];

  /**
   * @generated from field: repeated google.protobuf.Timestamp tab_switches = 2;
   */
  tabSwitches: Timestamp[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.TimeStampWithKey copy_attempts = 3;
   */
  copyAttempts: TimeStampWithKey[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.TimeStampWithKey paste_attempts = 4;
   */
  pasteAttempts: TimeStampWithKey[] = [];

  /**
   * @generated from field: repeated google.protobuf.Timestamp right_click_attempts = 5;
   */
  rightClickAttempts: Timestamp[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.TimeStampWithKey blocked_shortcuts = 6;
   */
  blockedShortcuts: TimeStampWithKey[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.IdleTimeInformation idle_time_data = 7;
   */
  idleTimeData: IdleTimeInformation[] = [];

  /**
   * @generated from field: repeated google.protobuf.Timestamp multiple_sessions = 8;
   */
  multipleSessions: Timestamp[] = [];

  /**
   * Client/server clock mismatches; timestamp is server time, key carries mismatch info.
   *
   * @generated from field: repeated geneo.lms.db.TimeStampWithKey time_mismatches = 9;
   */
  timeMismatches: TimeStampWithKey[] = [];

  constructor(data?: PartialMessage<ProctoringMetricsModel>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.ProctoringMetricsModel";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "full_screen_exits", kind: "message", T: Timestamp, repeated: true },
    { no: 2, name: "tab_switches", kind: "message", T: Timestamp, repeated: true },
    { no: 3, name: "copy_attempts", kind: "message", T: TimeStampWithKey, repeated: true },
    { no: 4, name: "paste_attempts", kind: "message", T: TimeStampWithKey, repeated: true },
    { no: 5, name: "right_click_attempts", kind: "message", T: Timestamp, repeated: true },
    { no: 6, name: "blocked_shortcuts", kind: "message", T: TimeStampWithKey, repeated: true },
    { no: 7, name: "idle_time_data", kind: "message", T: IdleTimeInformation, repeated: true },
    { no: 8, name: "multiple_sessions", kind: "message", T: Timestamp, repeated: true },
    { no: 9, name: "time_mismatches", kind: "message", T: TimeStampWithKey, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProctoringMetricsModel {
    return new ProctoringMetricsModel().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProctoringMetricsModel {
    return new ProctoringMetricsModel().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProctoringMetricsModel {
    return new ProctoringMetricsModel().fromJsonString(jsonString, options);
  }

  static equals(a: ProctoringMetricsModel | PlainMessage<ProctoringMetricsModel> | undefined, b: ProctoringMetricsModel | PlainMessage<ProctoringMetricsModel> | undefined): boolean {
    return proto3.util.equals(ProctoringMetricsModel, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.MetricsModel
 */
export class MetricsModel extends Message<MetricsModel> {
  /**
   * @generated from field: float response_score = 1;
   */
  responseScore = 0;

  /**
   * @generated from field: float max_score = 2;
   */
  maxScore = 0;

  /**
   * @generated from field: float time_spent_in_sec = 3;
   */
  timeSpentInSec = 0;

  /**
   * @generated from field: int32 total_questions = 4;
   */
  totalQuestions = 0;

  /**
   * @generated from field: int32 correct_count = 5;
   */
  correctCount = 0;

  /**
   * @generated from field: optional geneo.lms.db.ProctoringMetricsModel proctoring_metrics = 6;
   */
  proctoringMetrics?: ProctoringMetricsModel;

  constructor(data?: PartialMessage<MetricsModel>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.MetricsModel";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "response_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 2, name: "max_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "time_spent_in_sec", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "total_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "correct_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "proctoring_metrics", kind: "message", T: ProctoringMetricsModel, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MetricsModel {
    return new MetricsModel().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MetricsModel {
    return new MetricsModel().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MetricsModel {
    return new MetricsModel().fromJsonString(jsonString, options);
  }

  static equals(a: MetricsModel | PlainMessage<MetricsModel> | undefined, b: MetricsModel | PlainMessage<MetricsModel> | undefined): boolean {
    return proto3.util.equals(MetricsModel, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.TaskProjectProgress
 */
export class TaskProjectProgress extends Message<TaskProjectProgress> {
  /**
   * union of resources completed by the group
   *
   * @generated from field: repeated string completed_resource_ids = 1;
   */
  completedResourceIds: string[] = [];

  /**
   * true once every task resource is covered
   *
   * @generated from field: bool is_complete = 2;
   */
  isComplete = false;

  /**
   * server-computed; never accepted from a client
   *
   * @generated from field: float progress_percent = 3;
   */
  progressPercent = 0;

  /**
   * size of TaskInfo.task_resource_info when this was written
   *
   * @generated from field: int32 total_resource_count = 4;
   */
  totalResourceCount = 0;

  /**
   * acting student, for audit
   *
   * @generated from field: optional int64 last_updated_by_student_id = 5;
   */
  lastUpdatedByStudentId?: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_updated_on = 6;
   */
  lastUpdatedOn?: Timestamp;

  /**
   * @generated from field: optional string nano_id = 7;
   */
  nanoId?: string;

  /**
   * @generated from field: optional int32 version = 8;
   */
  version?: number;

  constructor(data?: PartialMessage<TaskProjectProgress>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.TaskProjectProgress";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "completed_resource_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "is_complete", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "progress_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "total_resource_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "last_updated_by_student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 6, name: "last_updated_on", kind: "message", T: Timestamp, opt: true },
    { no: 7, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TaskProjectProgress {
    return new TaskProjectProgress().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TaskProjectProgress {
    return new TaskProjectProgress().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TaskProjectProgress {
    return new TaskProjectProgress().fromJsonString(jsonString, options);
  }

  static equals(a: TaskProjectProgress | PlainMessage<TaskProjectProgress> | undefined, b: TaskProjectProgress | PlainMessage<TaskProjectProgress> | undefined): boolean {
    return proto3.util.equals(TaskProjectProgress, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.TaskTeacherReview
 */
export class TaskTeacherReview extends Message<TaskTeacherReview> {
  /**
   * @generated from field: repeated string remarks = 1;
   */
  remarks: string[] = [];

  constructor(data?: PartialMessage<TaskTeacherReview>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.TaskTeacherReview";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "remarks", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TaskTeacherReview {
    return new TaskTeacherReview().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TaskTeacherReview {
    return new TaskTeacherReview().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TaskTeacherReview {
    return new TaskTeacherReview().fromJsonString(jsonString, options);
  }

  static equals(a: TaskTeacherReview | PlainMessage<TaskTeacherReview> | undefined, b: TaskTeacherReview | PlainMessage<TaskTeacherReview> | undefined): boolean {
    return proto3.util.equals(TaskTeacherReview, a, b);
  }
}

/**
 * Message for task_student_assignment table
 *
 * @generated from message geneo.lms.db.TaskStudentAssignment
 */
export class TaskStudentAssignment extends Message<TaskStudentAssignment> {
  /**
   * Primary key for task_student_assignment
   *
   * @generated from field: optional int64 task_student_assignment_id = 1;
   */
  taskStudentAssignmentId?: bigint;

  /**
   * Foreign key referencing task.task_id
   *
   * @generated from field: optional string task_id = 2;
   */
  taskId?: string;

  /**
   * @generated from field: optional string parent_task_id = 20;
   */
  parentTaskId?: string;

  /**
   * Student's user ID
   *
   * @generated from field: optional int64 student_id = 3;
   */
  studentId?: bigint;

  /**
   * Student group ID (foreign key referencing student_group.student_group_id)
   *
   * @generated from field: optional int64 student_group_id = 4;
   */
  studentGroupId?: bigint;

  /**
   * Date when the task was assigned to the student
   *
   * @generated from field: google.protobuf.Timestamp task_assigned_date = 5;
   */
  taskAssignedDate?: Timestamp;

  /**
   * Target date for task completion by the student
   *
   * @generated from field: google.protobuf.Timestamp task_target_date = 6;
   */
  taskTargetDate?: Timestamp;

  /**
   * Date when the student commenced the task
   *
   * @generated from field: google.protobuf.Timestamp task_commence_date = 7;
   */
  taskCommenceDate?: Timestamp;

  /**
   * Date when the student completed the task
   *
   * @generated from field: google.protobuf.Timestamp task_completed_date = 8;
   */
  taskCompletedDate?: Timestamp;

  /**
   * Task status for the student (enum: task_student_status_enum)
   *
   * @generated from field: geneo.lms.db.TaskStudentAttemptStatusEnum task_student_status = 9;
   */
  taskStudentStatus = TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_UNDEFINED;

  /**
   * Task evaluation status for the student (enum: task_evaluation_enum)
   *
   * @generated from field: geneo.lms.db.TaskEvaluationStatusEnum task_evaluation_status = 10;
   */
  taskEvaluationStatus = TaskEvaluationStatusEnum.TASK_EVALUATION_STATUS_UNDEFINED;

  /**
   * Metrics related to the student's task performance in JSONB format
   *
   * @generated from field: geneo.lms.db.MetricsModel metrics = 11;
   */
  metrics?: MetricsModel;

  /**
   * Student's response to the task in JSONB format
   *
   * @generated from field: repeated geneo.lms.db.StudentAssessmentResponse response = 12;
   */
  response: StudentAssessmentResponse[] = [];

  /**
   * Teacher's review of the student's task in JSONB format
   *
   * @generated from field: geneo.lms.db.TaskTeacherReview teacher_review = 13;
   */
  teacherReview?: TaskTeacherReview;

  /**
   * Creation timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_on = 14;
   */
  createdOn?: Timestamp;

  /**
   * User who created the entry
   *
   * @generated from field: optional int64 created_by = 15;
   */
  createdBy?: bigint;

  /**
   * Last modification timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp modified_on = 16;
   */
  modifiedOn?: Timestamp;

  /**
   * User who last modified the entry
   *
   * @generated from field: optional int64 modified_by = 17;
   */
  modifiedBy?: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp daily_reminder_time = 18;
   */
  dailyReminderTime?: Timestamp;

  /**
   * @generated from field: optional bool allow_late_submission = 19;
   */
  allowLateSubmission?: boolean;

  /**
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 21;
   */
  deletedAt?: Timestamp;

  /**
   * @generated from field: optional int32 metrics_evaluation_version = 22;
   */
  metricsEvaluationVersion?: number;

  /**
   * @generated from field: repeated geneo.lms.db.CloudUpload user_uploads = 23;
   */
  userUploads: CloudUpload[] = [];

  /**
   * @generated from field: optional geneo.lms.db.ResponseCronEvaluationStatus response_cron_evaluation_status = 24;
   */
  responseCronEvaluationStatus?: ResponseCronEvaluationStatus;

  /**
   * @generated from field: optional string nano_id = 25;
   */
  nanoId?: string;

  /**
   * @generated from field: optional int32 school_id = 26;
   */
  schoolId?: number;

  /**
   * @generated from field: optional int64 school_device_id = 27;
   */
  schoolDeviceId?: bigint;

  /**
   * @generated from field: optional int32 version = 28;
   */
  version?: number;

  /**
   * @generated from field: optional float attempt_spent_time_in_secs = 29;
   */
  attemptSpentTimeInSecs?: number;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_reviewed_on = 30;
   */
  lastReviewedOn?: Timestamp;

  /**
   * @generated from field: optional string set_name = 31;
   */
  setName?: string;

  /**
   * @generated from field: optional geneo.lms.db.TaskProjectProgress project_progress = 32;
   */
  projectProgress?: TaskProjectProgress;

  /**
   * @generated from field: repeated geneo.lms.db.StudentPracticalResponse practical_responses = 33;
   */
  practicalResponses: StudentPracticalResponse[] = [];

  constructor(data?: PartialMessage<TaskStudentAssignment>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.TaskStudentAssignment";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "task_student_assignment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "task_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 20, name: "parent_task_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 4, name: "student_group_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 5, name: "task_assigned_date", kind: "message", T: Timestamp },
    { no: 6, name: "task_target_date", kind: "message", T: Timestamp },
    { no: 7, name: "task_commence_date", kind: "message", T: Timestamp },
    { no: 8, name: "task_completed_date", kind: "message", T: Timestamp },
    { no: 9, name: "task_student_status", kind: "enum", T: proto3.getEnumType(TaskStudentAttemptStatusEnum) },
    { no: 10, name: "task_evaluation_status", kind: "enum", T: proto3.getEnumType(TaskEvaluationStatusEnum) },
    { no: 11, name: "metrics", kind: "message", T: MetricsModel },
    { no: 12, name: "response", kind: "message", T: StudentAssessmentResponse, repeated: true },
    { no: 13, name: "teacher_review", kind: "message", T: TaskTeacherReview },
    { no: 14, name: "created_on", kind: "message", T: Timestamp },
    { no: 15, name: "created_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 16, name: "modified_on", kind: "message", T: Timestamp, opt: true },
    { no: 17, name: "modified_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 18, name: "daily_reminder_time", kind: "message", T: Timestamp, opt: true },
    { no: 19, name: "allow_late_submission", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 21, name: "deleted_at", kind: "message", T: Timestamp, opt: true },
    { no: 22, name: "metrics_evaluation_version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 23, name: "user_uploads", kind: "message", T: CloudUpload, repeated: true },
    { no: 24, name: "response_cron_evaluation_status", kind: "enum", T: proto3.getEnumType(ResponseCronEvaluationStatus), opt: true },
    { no: 25, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 26, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 27, name: "school_device_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 28, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 29, name: "attempt_spent_time_in_secs", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 30, name: "last_reviewed_on", kind: "message", T: Timestamp, opt: true },
    { no: 31, name: "set_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 32, name: "project_progress", kind: "message", T: TaskProjectProgress, opt: true },
    { no: 33, name: "practical_responses", kind: "message", T: StudentPracticalResponse, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TaskStudentAssignment {
    return new TaskStudentAssignment().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TaskStudentAssignment {
    return new TaskStudentAssignment().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TaskStudentAssignment {
    return new TaskStudentAssignment().fromJsonString(jsonString, options);
  }

  static equals(a: TaskStudentAssignment | PlainMessage<TaskStudentAssignment> | undefined, b: TaskStudentAssignment | PlainMessage<TaskStudentAssignment> | undefined): boolean {
    return proto3.util.equals(TaskStudentAssignment, a, b);
  }
}

/**
 * The presence of a row is the feature discriminator - a task with no
 * task_group_progress rows follows the existing (non-collaborative) code path
 *
 * @generated from message geneo.lms.db.TaskGroupProgress
 */
export class TaskGroupProgress extends Message<TaskGroupProgress> {
  /**
   * @generated from field: optional int64 task_group_progress_id = 1;
   */
  taskGroupProgressId?: bigint;

  /**
   * @generated from field: optional string task_id = 2;
   */
  taskId?: string;

  /**
   * @generated from field: optional int64 student_group_id = 3;
   */
  studentGroupId?: bigint;

  /**
   * @generated from field: repeated geneo.lms.db.StudentAssessmentResponse responses = 4;
   */
  responses: StudentAssessmentResponse[] = [];

  /**
   * @generated from field: geneo.lms.db.TaskStudentAttemptStatusEnum task_attempt_status = 5;
   */
  taskAttemptStatus = TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_UNDEFINED;

  /**
   * @generated from field: geneo.lms.db.TaskEvaluationStatusEnum task_evaluation_status = 6;
   */
  taskEvaluationStatus = TaskEvaluationStatusEnum.TASK_EVALUATION_STATUS_UNDEFINED;

  /**
   * @generated from field: optional google.protobuf.Timestamp task_completed_date = 7;
   */
  taskCompletedDate?: Timestamp;

  /**
   * @generated from field: optional geneo.lms.db.MetricsModel group_metrics = 8;
   */
  groupMetrics?: MetricsModel;

  /**
   * @generated from field: int32 graded_student_count = 9;
   */
  gradedStudentCount = 0;

  /**
   * @generated from field: bool is_group_grade_final = 10;
   */
  isGroupGradeFinal = false;

  /**
   * @generated from field: optional int64 last_modified_by_student_id = 11;
   */
  lastModifiedByStudentId?: bigint;

  /**
   * @generated from field: optional int64 last_modified_by_teacher_id = 12;
   */
  lastModifiedByTeacherId?: bigint;

  /**
   * @generated from field: int64 group_version = 13;
   */
  groupVersion = protoInt64.zero;

  /**
   * @generated from field: google.protobuf.Timestamp created_on = 14;
   */
  createdOn?: Timestamp;

  /**
   * @generated from field: optional int64 created_by = 15;
   */
  createdBy?: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp modified_on = 16;
   */
  modifiedOn?: Timestamp;

  /**
   * @generated from field: optional int64 modified_by = 17;
   */
  modifiedBy?: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 18;
   */
  deletedAt?: Timestamp;

  /**
   * @generated from field: optional string nano_id = 19;
   */
  nanoId?: string;

  /**
   * @generated from field: optional int32 school_id = 20;
   */
  schoolId?: number;

  /**
   * @generated from field: optional int64 school_device_id = 21;
   */
  schoolDeviceId?: bigint;

  /**
   * @generated from field: optional int32 version = 22;
   */
  version?: number;

  /**
   * @generated from field: optional geneo.lms.db.TaskProjectProgress project_progress = 23;
   */
  projectProgress?: TaskProjectProgress;

  /**
   * @generated from field: repeated geneo.lms.db.StudentPracticalResponse practical_responses = 24;
   */
  practicalResponses: StudentPracticalResponse[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.CloudUpload user_uploads = 25;
   */
  userUploads: CloudUpload[] = [];

  constructor(data?: PartialMessage<TaskGroupProgress>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.TaskGroupProgress";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "task_group_progress_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "task_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "student_group_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 4, name: "responses", kind: "message", T: StudentAssessmentResponse, repeated: true },
    { no: 5, name: "task_attempt_status", kind: "enum", T: proto3.getEnumType(TaskStudentAttemptStatusEnum) },
    { no: 6, name: "task_evaluation_status", kind: "enum", T: proto3.getEnumType(TaskEvaluationStatusEnum) },
    { no: 7, name: "task_completed_date", kind: "message", T: Timestamp, opt: true },
    { no: 8, name: "group_metrics", kind: "message", T: MetricsModel, opt: true },
    { no: 9, name: "graded_student_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "is_group_grade_final", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "last_modified_by_student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 12, name: "last_modified_by_teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 13, name: "group_version", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 14, name: "created_on", kind: "message", T: Timestamp },
    { no: 15, name: "created_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 16, name: "modified_on", kind: "message", T: Timestamp, opt: true },
    { no: 17, name: "modified_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 18, name: "deleted_at", kind: "message", T: Timestamp, opt: true },
    { no: 19, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 20, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 21, name: "school_device_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 22, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 23, name: "project_progress", kind: "message", T: TaskProjectProgress, opt: true },
    { no: 24, name: "practical_responses", kind: "message", T: StudentPracticalResponse, repeated: true },
    { no: 25, name: "user_uploads", kind: "message", T: CloudUpload, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TaskGroupProgress {
    return new TaskGroupProgress().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TaskGroupProgress {
    return new TaskGroupProgress().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TaskGroupProgress {
    return new TaskGroupProgress().fromJsonString(jsonString, options);
  }

  static equals(a: TaskGroupProgress | PlainMessage<TaskGroupProgress> | undefined, b: TaskGroupProgress | PlainMessage<TaskGroupProgress> | undefined): boolean {
    return proto3.util.equals(TaskGroupProgress, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.StudentHomeworkSession
 */
export class StudentHomeworkSession extends Message<StudentHomeworkSession> {
  /**
   * @generated from field: int64 student_homework_session_id = 1;
   */
  studentHomeworkSessionId = protoInt64.zero;

  /**
   * @generated from field: int64 task_student_assignment_id = 12;
   */
  taskStudentAssignmentId = protoInt64.zero;

  /**
   * @generated from field: int64 homework_id = 2;
   */
  homeworkId = protoInt64.zero;

  /**
   * @generated from field: int64 student_id = 3;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 4;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 5;
   */
  endTime?: Timestamp;

  /**
   * Task status for the student (enum: task_student_status_enum)
   *
   * @generated from field: geneo.lms.db.TaskStudentAttemptStatusEnum session_status = 6;
   */
  sessionStatus = TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_UNDEFINED;

  /**
   * @generated from field: geneo.lms.db.HomeworkSessionModeEnum session_mode = 7;
   */
  sessionMode = HomeworkSessionModeEnum.HOMEWORK_SESSION_MODE_UNDEFINED;

  /**
   * @generated from field: repeated geneo.lms.db.StudentAssessmentResponse responses = 8;
   */
  responses: StudentAssessmentResponse[] = [];

  /**
   * Metrics associated with the lesson session. Nullable field.
   *
   * @generated from field: geneo.lms.db.MetricsModel metrics = 9;
   */
  metrics?: MetricsModel;

  /**
   * @generated from field: int32 session_number = 10;
   */
  sessionNumber = 0;

  /**
   * @generated from field: optional int64 previous_student_homework_session_id = 11;
   */
  previousStudentHomeworkSessionId?: bigint;

  /**
   * @generated from field: optional int64 active_session_id = 13;
   */
  activeSessionId?: bigint;

  /**
   * @generated from field: repeated geneo.lms.db.CloudUpload user_uploads = 14;
   */
  userUploads: CloudUpload[] = [];

  /**
   * @generated from field: optional bool is_evaluation_completed = 15;
   */
  isEvaluationCompleted?: boolean;

  /**
   * @generated from field: optional string nano_id = 16;
   */
  nanoId?: string;

  /**
   * @generated from field: optional int32 school_id = 17;
   */
  schoolId?: number;

  /**
   * @generated from field: optional int64 school_device_id = 18;
   */
  schoolDeviceId?: bigint;

  /**
   * @generated from field: optional int32 version = 19;
   */
  version?: number;

  /**
   * @generated from field: optional float attempt_spent_time_in_secs = 20;
   */
  attemptSpentTimeInSecs?: number;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_reviewed_on = 21;
   */
  lastReviewedOn?: Timestamp;

  /**
   * @generated from field: optional int64 connected_class_session_id = 22;
   */
  connectedClassSessionId?: bigint;

  constructor(data?: PartialMessage<StudentHomeworkSession>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.StudentHomeworkSession";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_homework_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 12, name: "task_student_assignment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "homework_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "start_time", kind: "message", T: Timestamp },
    { no: 5, name: "end_time", kind: "message", T: Timestamp },
    { no: 6, name: "session_status", kind: "enum", T: proto3.getEnumType(TaskStudentAttemptStatusEnum) },
    { no: 7, name: "session_mode", kind: "enum", T: proto3.getEnumType(HomeworkSessionModeEnum) },
    { no: 8, name: "responses", kind: "message", T: StudentAssessmentResponse, repeated: true },
    { no: 9, name: "metrics", kind: "message", T: MetricsModel },
    { no: 10, name: "session_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "previous_student_homework_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 13, name: "active_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 14, name: "user_uploads", kind: "message", T: CloudUpload, repeated: true },
    { no: 15, name: "is_evaluation_completed", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 16, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 17, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 18, name: "school_device_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 19, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 20, name: "attempt_spent_time_in_secs", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 21, name: "last_reviewed_on", kind: "message", T: Timestamp, opt: true },
    { no: 22, name: "connected_class_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentHomeworkSession {
    return new StudentHomeworkSession().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentHomeworkSession {
    return new StudentHomeworkSession().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentHomeworkSession {
    return new StudentHomeworkSession().fromJsonString(jsonString, options);
  }

  static equals(a: StudentHomeworkSession | PlainMessage<StudentHomeworkSession> | undefined, b: StudentHomeworkSession | PlainMessage<StudentHomeworkSession> | undefined): boolean {
    return proto3.util.equals(StudentHomeworkSession, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.ContentAttempt
 */
export class ContentAttempt extends Message<ContentAttempt> {
  /**
   * @generated from field: google.protobuf.Timestamp start_time = 1;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp end_time = 2;
   */
  endTime?: Timestamp;

  /**
   * @generated from field: repeated string answer = 3;
   */
  answer: string[] = [];

  /**
   * @generated from field: repeated string uploaded_image_urls = 4;
   */
  uploadedImageUrls: string[] = [];

  /**
   * @generated from field: optional google.protobuf.Timestamp server_start_time = 5;
   */
  serverStartTime?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp server_end_time = 6;
   */
  serverEndTime?: Timestamp;

  /**
   * @generated from field: optional bool is_clear_answer = 7;
   */
  isClearAnswer?: boolean;

  constructor(data?: PartialMessage<ContentAttempt>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.ContentAttempt";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "start_time", kind: "message", T: Timestamp },
    { no: 2, name: "end_time", kind: "message", T: Timestamp, opt: true },
    { no: 3, name: "answer", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "uploaded_image_urls", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "server_start_time", kind: "message", T: Timestamp, opt: true },
    { no: 6, name: "server_end_time", kind: "message", T: Timestamp, opt: true },
    { no: 7, name: "is_clear_answer", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ContentAttempt {
    return new ContentAttempt().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ContentAttempt {
    return new ContentAttempt().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ContentAttempt {
    return new ContentAttempt().fromJsonString(jsonString, options);
  }

  static equals(a: ContentAttempt | PlainMessage<ContentAttempt> | undefined, b: ContentAttempt | PlainMessage<ContentAttempt> | undefined): boolean {
    return proto3.util.equals(ContentAttempt, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.StudentTaskResponse
 */
export class StudentTaskResponse extends Message<StudentTaskResponse> {
  /**
   * @generated from field: optional int64 homework_id = 1;
   */
  homeworkId?: bigint;

  /**
   * @generated from field: optional string question_id = 2;
   */
  questionId?: string;

  /**
   * @generated from field: optional string question_task_id = 3;
   */
  questionTaskId?: string;

  /**
   * @generated from field: repeated geneo.lms.db.ContentAttempt responses = 4;
   */
  responses: ContentAttempt[] = [];

  /**
   * @generated from field: optional geneo.lms.db.QAttemptResultEnum is_correct = 5;
   */
  isCorrect?: QAttemptResultEnum;

  /**
   * @generated from field: float max_score = 6;
   */
  maxScore = 0;

  /**
   * @generated from field: float response_score = 7;
   */
  responseScore = 0;

  /**
   * @generated from field: repeated string remarks = 11;
   */
  remarks: string[] = [];

  /**
   * @generated from field: float expectedTimeInSec = 8;
   */
  expectedTimeInSec = 0;

  /**
   * @generated from field: float timeTakenInSec = 9;
   */
  timeTakenInSec = 0;

  /**
   * @generated from field: int64 session_id = 10;
   */
  sessionId = protoInt64.zero;

  /**
   * @generated from field: optional geneo.lms.db.TaskEvaluationStatusEnum task_evaluation_status = 12;
   */
  taskEvaluationStatus?: TaskEvaluationStatusEnum;

  /**
   * @generated from field: optional bool is_attempted = 13;
   */
  isAttempted?: boolean;

  /**
   * @generated from field: optional int32 evaluationMetricsVersion = 14;
   */
  evaluationMetricsVersion?: number;

  /**
   * @generated from field: optional geneo.content.db.Question.QuestionEnum question_type = 15;
   */
  questionType?: Question_QuestionEnum;

  /**
   * @generated from field: optional int32 version = 16;
   */
  version?: number;

  /**
   * @generated from field: float max_marks = 17;
   */
  maxMarks = 0;

  /**
   * @generated from field: float response_marks = 18;
   */
  responseMarks = 0;

  constructor(data?: PartialMessage<StudentTaskResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.StudentTaskResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "homework_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "question_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "question_task_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "responses", kind: "message", T: ContentAttempt, repeated: true },
    { no: 5, name: "is_correct", kind: "enum", T: proto3.getEnumType(QAttemptResultEnum), opt: true },
    { no: 6, name: "max_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "response_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 11, name: "remarks", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "expectedTimeInSec", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 9, name: "timeTakenInSec", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 10, name: "session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 12, name: "task_evaluation_status", kind: "enum", T: proto3.getEnumType(TaskEvaluationStatusEnum), opt: true },
    { no: 13, name: "is_attempted", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 14, name: "evaluationMetricsVersion", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 15, name: "question_type", kind: "enum", T: proto3.getEnumType(Question_QuestionEnum), opt: true },
    { no: 16, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 17, name: "max_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 18, name: "response_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentTaskResponse {
    return new StudentTaskResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentTaskResponse {
    return new StudentTaskResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentTaskResponse {
    return new StudentTaskResponse().fromJsonString(jsonString, options);
  }

  static equals(a: StudentTaskResponse | PlainMessage<StudentTaskResponse> | undefined, b: StudentTaskResponse | PlainMessage<StudentTaskResponse> | undefined): boolean {
    return proto3.util.equals(StudentTaskResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.StudentAssessmentResponse
 */
export class StudentAssessmentResponse extends Message<StudentAssessmentResponse> {
  /**
   * @generated from field: optional int64 assessment_id = 1;
   */
  assessmentId?: bigint;

  /**
   * @generated from field: optional string question_id = 2;
   */
  questionId?: string;

  /**
   * @generated from field: optional int64 homework_id = 3;
   */
  homeworkId?: bigint;

  /**
   * @generated from field: repeated geneo.lms.db.ContentAttempt responses = 4;
   */
  responses: ContentAttempt[] = [];

  /**
   * @generated from field: optional geneo.lms.db.QAttemptResultEnum is_correct = 5;
   */
  isCorrect?: QAttemptResultEnum;

  /**
   * @generated from field: float max_score = 6;
   */
  maxScore = 0;

  /**
   * @generated from field: float max_marks = 18;
   */
  maxMarks = 0;

  /**
   * @generated from field: float response_score = 7;
   */
  responseScore = 0;

  /**
   * @generated from field: float response_marks = 19;
   */
  responseMarks = 0;

  /**
   * @generated from field: repeated string remarks = 11;
   */
  remarks: string[] = [];

  /**
   * @generated from field: float expectedTimeInSec = 8;
   */
  expectedTimeInSec = 0;

  /**
   * @generated from field: float timeTakenInSec = 9;
   */
  timeTakenInSec = 0;

  /**
   * @generated from field: int64 session_id = 10;
   */
  sessionId = protoInt64.zero;

  /**
   * @generated from field: optional geneo.lms.db.TaskEvaluationStatusEnum task_evaluation_status = 12;
   */
  taskEvaluationStatus?: TaskEvaluationStatusEnum;

  /**
   * @generated from field: optional bool is_attempted = 13;
   */
  isAttempted?: boolean;

  /**
   * @generated from field: optional int32 evaluationMetricsVersion = 14;
   */
  evaluationMetricsVersion?: number;

  /**
   * @generated from field: optional geneo.content.db.Question.QuestionEnum question_type = 15;
   */
  questionType?: Question_QuestionEnum;

  /**
   * @generated from field: optional int32 version = 16;
   */
  version?: number;

  /**
   * @generated from field: optional string question_task_id = 17;
   */
  questionTaskId?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_reviewed_on = 20;
   */
  lastReviewedOn?: Timestamp;

  /**
   * @generated from field: optional int32 section_no = 21;
   */
  sectionNo?: number;

  constructor(data?: PartialMessage<StudentAssessmentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.StudentAssessmentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "question_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "homework_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 4, name: "responses", kind: "message", T: ContentAttempt, repeated: true },
    { no: 5, name: "is_correct", kind: "enum", T: proto3.getEnumType(QAttemptResultEnum), opt: true },
    { no: 6, name: "max_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 18, name: "max_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "response_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 19, name: "response_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 11, name: "remarks", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "expectedTimeInSec", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 9, name: "timeTakenInSec", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 10, name: "session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 12, name: "task_evaluation_status", kind: "enum", T: proto3.getEnumType(TaskEvaluationStatusEnum), opt: true },
    { no: 13, name: "is_attempted", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 14, name: "evaluationMetricsVersion", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 15, name: "question_type", kind: "enum", T: proto3.getEnumType(Question_QuestionEnum), opt: true },
    { no: 16, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 17, name: "question_task_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 20, name: "last_reviewed_on", kind: "message", T: Timestamp, opt: true },
    { no: 21, name: "section_no", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentAssessmentResponse {
    return new StudentAssessmentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentAssessmentResponse {
    return new StudentAssessmentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentAssessmentResponse {
    return new StudentAssessmentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: StudentAssessmentResponse | PlainMessage<StudentAssessmentResponse> | undefined, b: StudentAssessmentResponse | PlainMessage<StudentAssessmentResponse> | undefined): boolean {
    return proto3.util.equals(StudentAssessmentResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.StudentContentResponse
 */
export class StudentContentResponse extends Message<StudentContentResponse> {
  /**
   * @generated from field: optional string content_id = 1;
   */
  contentId?: string;

  /**
   * @generated from field: repeated geneo.lms.db.ContentAttempt responses = 2;
   */
  responses: ContentAttempt[] = [];

  constructor(data?: PartialMessage<StudentContentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.StudentContentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "content_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "responses", kind: "message", T: ContentAttempt, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentContentResponse {
    return new StudentContentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentContentResponse {
    return new StudentContentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentContentResponse {
    return new StudentContentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: StudentContentResponse | PlainMessage<StudentContentResponse> | undefined, b: StudentContentResponse | PlainMessage<StudentContentResponse> | undefined): boolean {
    return proto3.util.equals(StudentContentResponse, a, b);
  }
}

/**
 * What a teacher produced against ONE content while teaching it.
 *
 * `responses` covers content that asks questions. A practical asks none: the
 * teacher authors a whole project in the Geneo IoT editor and it saves as one
 * artifact, so it gets its own field here rather than being forced into a
 * ContentAttempt. Exactly one of the two is populated, decided by the content's
 * type - a practical resource has a single CONTENT_TYPE_PRACTICAL content, so it
 * is still one entry keyed by content_id like any other.
 *
 * Keeping it inside this message is what keeps teacher_resource_session generic:
 * the session row stores whatever the resource type produced, and a future
 * resource type that captures teacher input adds a field here, not a column.
 *
 * @generated from message geneo.lms.db.TeacherContentResponse
 */
export class TeacherContentResponse extends Message<TeacherContentResponse> {
  /**
   * @generated from field: optional string content_id = 1;
   */
  contentId?: string;

  /**
   * @generated from field: repeated geneo.lms.db.ContentAttempt responses = 2;
   */
  responses: ContentAttempt[] = [];

  /**
   * The project as the teacher left it at the end of a sitting, so the next
   * class resumes instead of opening a blank editor.
   *
   * @generated from field: optional geneo.content.db.PracticalProject practical_response = 3;
   */
  practicalResponse?: PracticalProject;

  constructor(data?: PartialMessage<TeacherContentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.TeacherContentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "content_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "responses", kind: "message", T: ContentAttempt, repeated: true },
    { no: 3, name: "practical_response", kind: "message", T: PracticalProject, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherContentResponse {
    return new TeacherContentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherContentResponse {
    return new TeacherContentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherContentResponse {
    return new TeacherContentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherContentResponse | PlainMessage<TeacherContentResponse> | undefined, b: TeacherContentResponse | PlainMessage<TeacherContentResponse> | undefined): boolean {
    return proto3.util.equals(TeacherContentResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.StudentPracticalResponse
 */
export class StudentPracticalResponse extends Message<StudentPracticalResponse> {
  /**
   * @generated from field: string resource_id = 1;
   */
  resourceId = "";

  /**
   * @generated from field: geneo.content.db.PracticalProject project = 2;
   */
  project?: PracticalProject;

  /**
   * acting student, for audit
   *
   * @generated from field: optional int64 last_updated_by_student_id = 3;
   */
  lastUpdatedByStudentId?: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_updated_on = 4;
   */
  lastUpdatedOn?: Timestamp;

  constructor(data?: PartialMessage<StudentPracticalResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.StudentPracticalResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "resource_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "project", kind: "message", T: PracticalProject },
    { no: 3, name: "last_updated_by_student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 4, name: "last_updated_on", kind: "message", T: Timestamp, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentPracticalResponse {
    return new StudentPracticalResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentPracticalResponse {
    return new StudentPracticalResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentPracticalResponse {
    return new StudentPracticalResponse().fromJsonString(jsonString, options);
  }

  static equals(a: StudentPracticalResponse | PlainMessage<StudentPracticalResponse> | undefined, b: StudentPracticalResponse | PlainMessage<StudentPracticalResponse> | undefined): boolean {
    return proto3.util.equals(StudentPracticalResponse, a, b);
  }
}

/**
 * StudentLessonSessionMetrics represents the metrics for a student's lesson session.
 *
 * @generated from message geneo.lms.db.StudentLessonSessionMetrics
 */
export class StudentLessonSessionMetrics extends Message<StudentLessonSessionMetrics> {
  /**
   * Unique identifier for the student's lesson session.
   *
   * @generated from field: optional int64 student_lesson_session_id = 1;
   */
  studentLessonSessionId?: bigint;

  /**
   * Indicates if the lesson session is complete or not. Optional field.
   *
   * @generated from field: bool is_complete = 2;
   */
  isComplete = false;

  /**
   * @generated from field: float response_score = 3;
   */
  responseScore = 0;

  /**
   * @generated from field: float max_score = 4;
   */
  maxScore = 0;

  /**
   * List of resource IDs that have been completed by the student.
   *
   * @generated from field: repeated string completed_resource_ids = 5;
   */
  completedResourceIds: string[] = [];

  /**
   * List of visited resource content information.
   *
   * @generated from field: repeated geneo.lms.db.VisitedResourceContentInfoList visited_resource_content_info_list = 6;
   */
  visitedResourceContentInfoList: VisitedResourceContentInfoList[] = [];

  /**
   * @generated from field: optional string nano_id = 7;
   */
  nanoId?: string;

  /**
   * @generated from field: optional int32 version = 8;
   */
  version?: number;

  constructor(data?: PartialMessage<StudentLessonSessionMetrics>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.StudentLessonSessionMetrics";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_lesson_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "is_complete", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "response_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "max_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "completed_resource_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "visited_resource_content_info_list", kind: "message", T: VisitedResourceContentInfoList, repeated: true },
    { no: 7, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentLessonSessionMetrics {
    return new StudentLessonSessionMetrics().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentLessonSessionMetrics {
    return new StudentLessonSessionMetrics().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentLessonSessionMetrics {
    return new StudentLessonSessionMetrics().fromJsonString(jsonString, options);
  }

  static equals(a: StudentLessonSessionMetrics | PlainMessage<StudentLessonSessionMetrics> | undefined, b: StudentLessonSessionMetrics | PlainMessage<StudentLessonSessionMetrics> | undefined): boolean {
    return proto3.util.equals(StudentLessonSessionMetrics, a, b);
  }
}

/**
 * StudentLessonSessionMetrics represents the metrics for a student's lesson session.
 *
 * @generated from message geneo.lms.db.TeacherLessonSessionMetrics
 */
export class TeacherLessonSessionMetrics extends Message<TeacherLessonSessionMetrics> {
  /**
   * Unique identifier for the student's lesson session.
   *
   * @generated from field: optional int64 teacher_lesson_session_id = 1;
   */
  teacherLessonSessionId?: bigint;

  /**
   * Indicates if the lesson session is complete or not. Optional field.
   *
   * @generated from field: bool is_complete = 2;
   */
  isComplete = false;

  /**
   * List of resource IDs that have been completed by the student.
   *
   * @generated from field: repeated string completed_resource_ids = 3;
   */
  completedResourceIds: string[] = [];

  /**
   * List of visited resource content information.
   *
   * @generated from field: repeated geneo.lms.db.VisitedResourceContentInfoList visited_resource_content_info_list = 4;
   */
  visitedResourceContentInfoList: VisitedResourceContentInfoList[] = [];

  /**
   * @generated from field: float response_score = 5;
   */
  responseScore = 0;

  /**
   * @generated from field: float max_score = 6;
   */
  maxScore = 0;

  /**
   * @generated from field: optional string nano_id = 7;
   */
  nanoId?: string;

  /**
   * @generated from field: optional int32 version = 8;
   */
  version?: number;

  constructor(data?: PartialMessage<TeacherLessonSessionMetrics>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.TeacherLessonSessionMetrics";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_lesson_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "is_complete", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "completed_resource_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "visited_resource_content_info_list", kind: "message", T: VisitedResourceContentInfoList, repeated: true },
    { no: 5, name: "response_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "max_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherLessonSessionMetrics {
    return new TeacherLessonSessionMetrics().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherLessonSessionMetrics {
    return new TeacherLessonSessionMetrics().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherLessonSessionMetrics {
    return new TeacherLessonSessionMetrics().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherLessonSessionMetrics | PlainMessage<TeacherLessonSessionMetrics> | undefined, b: TeacherLessonSessionMetrics | PlainMessage<TeacherLessonSessionMetrics> | undefined): boolean {
    return proto3.util.equals(TeacherLessonSessionMetrics, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.TeacherAssessmentSessionMetrics
 */
export class TeacherAssessmentSessionMetrics extends Message<TeacherAssessmentSessionMetrics> {
  /**
   * @generated from field: optional int64 teacher_assessment_session_id = 1;
   */
  teacherAssessmentSessionId?: bigint;

  /**
   * @generated from field: bool is_complete = 2;
   */
  isComplete = false;

  /**
   * @generated from field: repeated string completed_question_ids = 3;
   */
  completedQuestionIds: string[] = [];

  /**
   * @generated from field: float class_score = 4;
   */
  classScore = 0;

  /**
   * @generated from field: int32 total_students = 5;
   */
  totalStudents = 0;

  /**
   * @generated from field: repeated geneo.lms.db.QuestionSessionStats question_session_stats = 6;
   */
  questionSessionStats: QuestionSessionStats[] = [];

  /**
   * @generated from field: int32 joined_students = 7;
   */
  joinedStudents = 0;

  /**
   * Will be equal to joined count if session has ended
   *
   * @generated from field: int32 attempted_students = 8;
   */
  attemptedStudents = 0;

  /**
   * @generated from field: optional float total_time_spent_seconds = 9;
   */
  totalTimeSpentSeconds?: number;

  /**
   * @generated from field: optional int32 total_students_joined = 10;
   */
  totalStudentsJoined?: number;

  /**
   * @generated from field: optional int32 total_student_completed_submissions = 11;
   */
  totalStudentCompletedSubmissions?: number;

  /**
   * @generated from field: optional float session_completion_percentage = 12;
   */
  sessionCompletionPercentage?: number;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_activity_time = 13;
   */
  lastActivityTime?: Timestamp;

  /**
   * @generated from field: repeated string visited_question_ids = 14;
   */
  visitedQuestionIds: string[] = [];

  constructor(data?: PartialMessage<TeacherAssessmentSessionMetrics>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.TeacherAssessmentSessionMetrics";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_assessment_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "is_complete", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "completed_question_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "class_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "total_students", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "question_session_stats", kind: "message", T: QuestionSessionStats, repeated: true },
    { no: 7, name: "joined_students", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "attempted_students", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "total_time_spent_seconds", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 10, name: "total_students_joined", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 11, name: "total_student_completed_submissions", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 12, name: "session_completion_percentage", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 13, name: "last_activity_time", kind: "message", T: Timestamp, opt: true },
    { no: 14, name: "visited_question_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherAssessmentSessionMetrics {
    return new TeacherAssessmentSessionMetrics().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherAssessmentSessionMetrics {
    return new TeacherAssessmentSessionMetrics().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherAssessmentSessionMetrics {
    return new TeacherAssessmentSessionMetrics().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherAssessmentSessionMetrics | PlainMessage<TeacherAssessmentSessionMetrics> | undefined, b: TeacherAssessmentSessionMetrics | PlainMessage<TeacherAssessmentSessionMetrics> | undefined): boolean {
    return proto3.util.equals(TeacherAssessmentSessionMetrics, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.QuestionSessionStats
 */
export class QuestionSessionStats extends Message<QuestionSessionStats> {
  /**
   * @generated from field: string question_id = 1;
   */
  questionId = "";

  /**
   * @generated from field: optional geneo.content.db.Question.QuestionEnum question_type = 2;
   */
  questionType?: Question_QuestionEnum;

  /**
   * @generated from field: float max_score = 4;
   */
  maxScore = 0;

  /**
   * @generated from field: float class_average_score = 5;
   */
  classAverageScore = 0;

  /**
   * @generated from field: int32 joined_students = 6;
   */
  joinedStudents = 0;

  /**
   * @generated from field: int32 attempted_students = 7;
   */
  attemptedStudents = 0;

  /**
   * @generated from field: int32 correct_responses = 8;
   */
  correctResponses = 0;

  /**
   * @generated from field: int32 incorrect_responses = 9;
   */
  incorrectResponses = 0;

  /**
   * @generated from field: float accuracy_percentage = 10;
   */
  accuracyPercentage = 0;

  /**
   * @generated from field: repeated geneo.lms.db.StudentQuestionMetrics student_metrics = 11;
   */
  studentMetrics: StudentQuestionMetrics[] = [];

  /**
   * @generated from field: optional google.protobuf.Timestamp start_time = 12;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp end_time = 13;
   */
  endTime?: Timestamp;

  /**
   * @generated from field: float average_time_taken_sec = 14;
   */
  averageTimeTakenSec = 0;

  /**
   * @generated from field: optional int64 teacher_assessment_session_id = 15;
   */
  teacherAssessmentSessionId?: bigint;

  /**
   * @generated from field: optional int64 connected_class_session_id = 16;
   */
  connectedClassSessionId?: bigint;

  constructor(data?: PartialMessage<QuestionSessionStats>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.QuestionSessionStats";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "question_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "question_type", kind: "enum", T: proto3.getEnumType(Question_QuestionEnum), opt: true },
    { no: 4, name: "max_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "class_average_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "joined_students", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "attempted_students", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "correct_responses", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "incorrect_responses", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "accuracy_percentage", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 11, name: "student_metrics", kind: "message", T: StudentQuestionMetrics, repeated: true },
    { no: 12, name: "start_time", kind: "message", T: Timestamp, opt: true },
    { no: 13, name: "end_time", kind: "message", T: Timestamp, opt: true },
    { no: 14, name: "average_time_taken_sec", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 15, name: "teacher_assessment_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 16, name: "connected_class_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuestionSessionStats {
    return new QuestionSessionStats().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuestionSessionStats {
    return new QuestionSessionStats().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuestionSessionStats {
    return new QuestionSessionStats().fromJsonString(jsonString, options);
  }

  static equals(a: QuestionSessionStats | PlainMessage<QuestionSessionStats> | undefined, b: QuestionSessionStats | PlainMessage<QuestionSessionStats> | undefined): boolean {
    return proto3.util.equals(QuestionSessionStats, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.StudentQuestionMetrics
 */
export class StudentQuestionMetrics extends Message<StudentQuestionMetrics> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: string student_name = 2;
   */
  studentName = "";

  /**
   * @generated from field: bool is_attempted = 3;
   */
  isAttempted = false;

  /**
   * @generated from field: repeated geneo.lms.db.CAStudentReponse responses = 4;
   */
  responses: CAStudentReponse[] = [];

  constructor(data?: PartialMessage<StudentQuestionMetrics>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.StudentQuestionMetrics";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "student_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "is_attempted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "responses", kind: "message", T: CAStudentReponse, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentQuestionMetrics {
    return new StudentQuestionMetrics().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentQuestionMetrics {
    return new StudentQuestionMetrics().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentQuestionMetrics {
    return new StudentQuestionMetrics().fromJsonString(jsonString, options);
  }

  static equals(a: StudentQuestionMetrics | PlainMessage<StudentQuestionMetrics> | undefined, b: StudentQuestionMetrics | PlainMessage<StudentQuestionMetrics> | undefined): boolean {
    return proto3.util.equals(StudentQuestionMetrics, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.CAStudentReponse
 */
export class CAStudentReponse extends Message<CAStudentReponse> {
  /**
   * @generated from field: optional string question_id = 1;
   */
  questionId?: string;

  /**
   * @generated from field: float response_score = 4;
   */
  responseScore = 0;

  /**
   * @generated from field: float max_score = 5;
   */
  maxScore = 0;

  /**
   * @generated from field: bool is_correct = 6;
   */
  isCorrect = false;

  /**
   * @generated from field: float time_taken_sec = 7;
   */
  timeTakenSec = 0;

  /**
   * @generated from field: optional string student_answer = 8;
   */
  studentAnswer?: string;

  /**
   * @generated from field: optional string correct_answer = 9;
   */
  correctAnswer?: string;

  /**
   * @generated from field: repeated string remarks = 10;
   */
  remarks: string[] = [];

  /**
   * @generated from field: optional geneo.lms.db.TaskEvaluationStatusEnum evaluation_status = 11;
   */
  evaluationStatus?: TaskEvaluationStatusEnum;

  /**
   * @generated from field: optional google.protobuf.Timestamp response_time = 12;
   */
  responseTime?: Timestamp;

  /**
   * @generated from field: bool is_attempted = 13;
   */
  isAttempted = false;

  constructor(data?: PartialMessage<CAStudentReponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.CAStudentReponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "question_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "response_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "max_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "is_correct", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "time_taken_sec", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 8, name: "student_answer", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "correct_answer", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "remarks", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "evaluation_status", kind: "enum", T: proto3.getEnumType(TaskEvaluationStatusEnum), opt: true },
    { no: 12, name: "response_time", kind: "message", T: Timestamp, opt: true },
    { no: 13, name: "is_attempted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CAStudentReponse {
    return new CAStudentReponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CAStudentReponse {
    return new CAStudentReponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CAStudentReponse {
    return new CAStudentReponse().fromJsonString(jsonString, options);
  }

  static equals(a: CAStudentReponse | PlainMessage<CAStudentReponse> | undefined, b: CAStudentReponse | PlainMessage<CAStudentReponse> | undefined): boolean {
    return proto3.util.equals(CAStudentReponse, a, b);
  }
}

/**
 * VisitedResourceContentInfoList represents the information about visited resource content.
 *
 * @generated from message geneo.lms.db.VisitedResourceContentInfoList
 */
export class VisitedResourceContentInfoList extends Message<VisitedResourceContentInfoList> {
  /**
   * Identifier for the visited resource.
   *
   * @generated from field: optional string resource_id = 1;
   */
  resourceId?: string;

  /**
   * Optional field indicating the page number of the visited resource.
   *
   * @generated from field: int32 page_no = 2;
   */
  pageNo = 0;

  /**
   * @generated from field: repeated string page_content_ids = 3;
   */
  pageContentIds: string[] = [];

  constructor(data?: PartialMessage<VisitedResourceContentInfoList>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.VisitedResourceContentInfoList";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "resource_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "page_no", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_content_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VisitedResourceContentInfoList {
    return new VisitedResourceContentInfoList().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VisitedResourceContentInfoList {
    return new VisitedResourceContentInfoList().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VisitedResourceContentInfoList {
    return new VisitedResourceContentInfoList().fromJsonString(jsonString, options);
  }

  static equals(a: VisitedResourceContentInfoList | PlainMessage<VisitedResourceContentInfoList> | undefined, b: VisitedResourceContentInfoList | PlainMessage<VisitedResourceContentInfoList> | undefined): boolean {
    return proto3.util.equals(VisitedResourceContentInfoList, a, b);
  }
}

/**
 * StudentLessonSession represents a lesson session for a student.
 *
 * @generated from message geneo.lms.db.StudentLessonSession
 */
export class StudentLessonSession extends Message<StudentLessonSession> {
  /**
   * Unique identifier for the student's lesson session.
   *
   * @generated from field: optional int64 student_lesson_session_id = 1;
   */
  studentLessonSessionId?: bigint;

  /**
   * ID of the student associated with the lesson session.
   *
   * @generated from field: optional int64 student_id = 2;
   */
  studentId?: bigint;

  /**
   * ID of the lesson associated with the session.
   *
   * @generated from field: optional string lesson_id = 3;
   */
  lessonId?: string;

  /**
   * ID of the school where the lesson session takes place.
   *
   * @generated from field: optional int32 school_id = 4;
   */
  schoolId?: number;

  /**
   * Academic year associated with the lesson session.
   *
   * @generated from field: int32 academic_year = 5;
   */
  academicYear = 0;

  /**
   * Grade of the student.
   *
   * @generated from field: geneo.common.db.Class.ClassEnum class = 6;
   */
  class = Class_ClassEnum.UNDEFINED;

  /**
   * Section of the student.
   *
   * @generated from field: string section = 7;
   */
  section = "";

  /**
   * Subject of the lesson session.
   *
   * @generated from field: geneo.common.db.Subject.SubjectEnum subject = 8;
   */
  subject = Subject_SubjectEnum.UNDEFINED;

  /**
   * Mode of the lesson session (e.g., online, offline, etc.).
   *
   * @generated from field: geneo.lms.db.SessionModeEnum session_mode = 9;
   */
  sessionMode = SessionModeEnum.SESSION_MODE_UNDEFINED;

  /**
   * Status of the lesson session (e.g., in progress, completed, etc.).
   *
   * @generated from field: geneo.lms.db.SessionStatusEnum session_status = 10;
   */
  sessionStatus = SessionStatusEnum.SESSION_STATUS_UNDEFINED;

  /**
   * ID of the teacher's lesson session. Nullable field.
   *
   * @generated from field: optional int64 teacher_lesson_session_id = 11;
   */
  teacherLessonSessionId?: bigint;

  /**
   * List of resource IDs associated with the session.
   *
   * @generated from field: repeated string session_resource_ids = 12;
   */
  sessionResourceIds: string[] = [];

  /**
   * Start time of the lesson session.
   *
   * @generated from field: google.protobuf.Timestamp start_time = 13;
   */
  startTime?: Timestamp;

  /**
   * End time of the lesson session. Nullable field.
   *
   * @generated from field: google.protobuf.Timestamp end_time = 14;
   */
  endTime?: Timestamp;

  /**
   * Metrics associated with the lesson session. Nullable field.
   *
   * @generated from field: geneo.lms.db.StudentLessonSessionMetrics metrics = 15;
   */
  metrics?: StudentLessonSessionMetrics;

  /**
   * Timestamp when the session was created. Nullable field.
   *
   * @generated from field: google.protobuf.Timestamp created_on = 16;
   */
  createdOn?: Timestamp;

  /**
   * ID of the user who created the session. Nullable field.
   *
   * @generated from field: optional int64 created_by = 17;
   */
  createdBy?: bigint;

  /**
   * Timestamp when the session was last modified. Nullable field.
   *
   * @generated from field: optional google.protobuf.Timestamp modified_on = 18;
   */
  modifiedOn?: Timestamp;

  /**
   * ID of the user who last modified the session. Nullable field.
   *
   * @generated from field: optional int64 modified_by = 19;
   */
  modifiedBy?: bigint;

  /**
   * @generated from field: optional int64 active_session_id = 20;
   */
  activeSessionId?: bigint;

  /**
   * @generated from field: optional string nano_id = 21;
   */
  nanoId?: string;

  /**
   * optional int32 school_id = 22 ;
   *
   * @generated from field: optional int64 school_device_id = 22;
   */
  schoolDeviceId?: bigint;

  /**
   * @generated from field: optional int32 version = 23;
   */
  version?: number;

  constructor(data?: PartialMessage<StudentLessonSession>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.StudentLessonSession";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_lesson_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 3, name: "lesson_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "academic_year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "class", kind: "enum", T: proto3.getEnumType(Class_ClassEnum) },
    { no: 7, name: "section", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "subject", kind: "enum", T: proto3.getEnumType(Subject_SubjectEnum) },
    { no: 9, name: "session_mode", kind: "enum", T: proto3.getEnumType(SessionModeEnum) },
    { no: 10, name: "session_status", kind: "enum", T: proto3.getEnumType(SessionStatusEnum) },
    { no: 11, name: "teacher_lesson_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 12, name: "session_resource_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 13, name: "start_time", kind: "message", T: Timestamp },
    { no: 14, name: "end_time", kind: "message", T: Timestamp },
    { no: 15, name: "metrics", kind: "message", T: StudentLessonSessionMetrics },
    { no: 16, name: "created_on", kind: "message", T: Timestamp },
    { no: 17, name: "created_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 18, name: "modified_on", kind: "message", T: Timestamp, opt: true },
    { no: 19, name: "modified_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 20, name: "active_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 21, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 22, name: "school_device_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 23, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentLessonSession {
    return new StudentLessonSession().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentLessonSession {
    return new StudentLessonSession().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentLessonSession {
    return new StudentLessonSession().fromJsonString(jsonString, options);
  }

  static equals(a: StudentLessonSession | PlainMessage<StudentLessonSession> | undefined, b: StudentLessonSession | PlainMessage<StudentLessonSession> | undefined): boolean {
    return proto3.util.equals(StudentLessonSession, a, b);
  }
}

/**
 * TeacherLessonSession represents a lesson session for a teacher.
 *
 * @generated from message geneo.lms.db.TeacherLessonSession
 */
export class TeacherLessonSession extends Message<TeacherLessonSession> {
  /**
   * Unique identifier for the teacher's lesson session.
   *
   * @generated from field: optional int64 teacher_lesson_session_id = 1;
   */
  teacherLessonSessionId?: bigint;

  /**
   * ID of the teacher associated with the lesson session.
   *
   * @generated from field: optional int64 teacher_id = 2;
   */
  teacherId?: bigint;

  /**
   * ID of the lesson associated with the session.
   *
   * @generated from field: optional string lesson_id = 3;
   */
  lessonId?: string;

  /**
   * ID of the school where the lesson session takes place.
   *
   * @generated from field: optional int32 school_id = 4;
   */
  schoolId?: number;

  /**
   * Academic year associated with the lesson session.
   *
   * @generated from field: int32 academic_year = 5;
   */
  academicYear = 0;

  /**
   * Grade associated with the lesson session.
   *
   * @generated from field: geneo.common.db.Class.ClassEnum class = 6;
   */
  class = Class_ClassEnum.UNDEFINED;

  /**
   * Section associated with the lesson session.
   *
   * @generated from field: string section = 7;
   */
  section = "";

  /**
   * Subject associated with the lesson session.
   *
   * @generated from field: geneo.common.db.Subject.SubjectEnum subject = 8;
   */
  subject = Subject_SubjectEnum.UNDEFINED;

  /**
   * Mode of the lesson session (e.g., online, offline, etc.).
   *
   * @generated from field: geneo.lms.db.SessionModeEnum session_mode = 9;
   */
  sessionMode = SessionModeEnum.SESSION_MODE_UNDEFINED;

  /**
   * Status of the lesson session (e.g., in progress, completed, etc.).
   *
   * @generated from field: geneo.lms.db.SessionStatusEnum session_status = 10;
   */
  sessionStatus = SessionStatusEnum.SESSION_STATUS_UNDEFINED;

  /**
   * List of resource IDs associated with the session.
   *
   * @generated from field: repeated string session_resource_ids = 11;
   */
  sessionResourceIds: string[] = [];

  /**
   * Start time of the lesson session.
   *
   * @generated from field: google.protobuf.Timestamp start_time = 12;
   */
  startTime?: Timestamp;

  /**
   * End time of the lesson session. Nullable field.
   *
   * @generated from field: google.protobuf.Timestamp end_time = 13;
   */
  endTime?: Timestamp;

  /**
   * Metrics associated with the lesson session. Nullable field.
   *
   * @generated from field: geneo.lms.db.TeacherLessonSessionMetrics metrics = 14;
   */
  metrics?: TeacherLessonSessionMetrics;

  /**
   * Timestamp when the session was created. Nullable field.
   *
   * @generated from field: google.protobuf.Timestamp created_on = 15;
   */
  createdOn?: Timestamp;

  /**
   * ID of the user who created the session. Nullable field.
   *
   * @generated from field: optional int64 created_by = 16;
   */
  createdBy?: bigint;

  /**
   * Timestamp when the session was last modified. Nullable field.
   *
   * @generated from field: optional google.protobuf.Timestamp modified_on = 17;
   */
  modifiedOn?: Timestamp;

  /**
   * ID of the user who last modified the session. Nullable field.
   *
   * @generated from field: optional int64 modified_by = 18;
   */
  modifiedBy?: bigint;

  /**
   * @generated from field: optional int64 active_session_id = 19;
   */
  activeSessionId?: bigint;

  /**
   * @generated from field: optional string nano_id = 20;
   */
  nanoId?: string;

  /**
   * optional int32 school_id = 12 ;
   *
   * @generated from field: optional int64 school_device_id = 21;
   */
  schoolDeviceId?: bigint;

  /**
   * @generated from field: optional int32 version = 22;
   */
  version?: number;

  constructor(data?: PartialMessage<TeacherLessonSession>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.TeacherLessonSession";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_lesson_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 3, name: "lesson_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "academic_year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "class", kind: "enum", T: proto3.getEnumType(Class_ClassEnum) },
    { no: 7, name: "section", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "subject", kind: "enum", T: proto3.getEnumType(Subject_SubjectEnum) },
    { no: 9, name: "session_mode", kind: "enum", T: proto3.getEnumType(SessionModeEnum) },
    { no: 10, name: "session_status", kind: "enum", T: proto3.getEnumType(SessionStatusEnum) },
    { no: 11, name: "session_resource_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 12, name: "start_time", kind: "message", T: Timestamp },
    { no: 13, name: "end_time", kind: "message", T: Timestamp },
    { no: 14, name: "metrics", kind: "message", T: TeacherLessonSessionMetrics },
    { no: 15, name: "created_on", kind: "message", T: Timestamp },
    { no: 16, name: "created_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 17, name: "modified_on", kind: "message", T: Timestamp, opt: true },
    { no: 18, name: "modified_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 19, name: "active_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 20, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 21, name: "school_device_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 22, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherLessonSession {
    return new TeacherLessonSession().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherLessonSession {
    return new TeacherLessonSession().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherLessonSession {
    return new TeacherLessonSession().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherLessonSession | PlainMessage<TeacherLessonSession> | undefined, b: TeacherLessonSession | PlainMessage<TeacherLessonSession> | undefined): boolean {
    return proto3.util.equals(TeacherLessonSession, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.TeacherAssessmentSession
 */
export class TeacherAssessmentSession extends Message<TeacherAssessmentSession> {
  /**
   * @generated from field: int64 teacher_assessment_session_id = 1;
   */
  teacherAssessmentSessionId = protoInt64.zero;

  /**
   * @generated from field: int64 teacher_id = 2;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int64 assessment_id = 3;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: geneo.lms.db.SessionModeEnum session_mode = 4;
   */
  sessionMode = SessionModeEnum.SESSION_MODE_UNDEFINED;

  /**
   * @generated from field: geneo.lms.db.TeacherAssessmentAttemptModeEnum teacher_assessment_session_mode = 5;
   */
  teacherAssessmentSessionMode = TeacherAssessmentAttemptModeEnum.TEACHER_ASSESSMENT_ATTEMPT_MODE_UNDEFINED;

  /**
   * @generated from field: geneo.lms.db.SessionStatusEnum session_status = 6;
   */
  sessionStatus = SessionStatusEnum.SESSION_STATUS_UNDEFINED;

  /**
   * @generated from field: repeated geneo.lms.db.ConnectedClassQuestionSession question_sessions = 7;
   */
  questionSessions: ConnectedClassQuestionSession[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 8;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp end_time = 9;
   */
  endTime?: Timestamp;

  /**
   * @generated from field: optional geneo.lms.db.TeacherAssessmentSessionMetrics metrics = 10;
   */
  metrics?: TeacherAssessmentSessionMetrics;

  /**
   * @generated from field: google.protobuf.Timestamp created_on = 11;
   */
  createdOn?: Timestamp;

  /**
   * @generated from field: optional int64 created_by = 12;
   */
  createdBy?: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp modified_on = 13;
   */
  modifiedOn?: Timestamp;

  /**
   * @generated from field: optional int64 modified_by = 14;
   */
  modifiedBy?: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 15;
   */
  deletedAt?: Timestamp;

  /**
   * @generated from field: optional int64 active_session_id = 16;
   */
  activeSessionId?: bigint;

  /**
   * @generated from field: optional string nano_id = 17;
   */
  nanoId?: string;

  /**
   * @generated from field: optional int64 school_device_id = 18;
   */
  schoolDeviceId?: bigint;

  /**
   * @generated from field: optional int32 version = 19;
   */
  version?: number;

  /**
   * @generated from field: repeated string assessment_question_ids = 20;
   */
  assessmentQuestionIds: string[] = [];

  /**
   * @generated from field: optional int64 section_id = 21;
   */
  sectionId?: bigint;

  /**
   * @generated from field: optional int32 course_id = 22;
   */
  courseId?: number;

  /**
   * @generated from field: int64 connected_class_session_id = 23;
   */
  connectedClassSessionId = protoInt64.zero;

  /**
   * @generated from field: optional int32 session_number = 24;
   */
  sessionNumber?: number;

  constructor(data?: PartialMessage<TeacherAssessmentSession>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.TeacherAssessmentSession";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_assessment_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "session_mode", kind: "enum", T: proto3.getEnumType(SessionModeEnum) },
    { no: 5, name: "teacher_assessment_session_mode", kind: "enum", T: proto3.getEnumType(TeacherAssessmentAttemptModeEnum) },
    { no: 6, name: "session_status", kind: "enum", T: proto3.getEnumType(SessionStatusEnum) },
    { no: 7, name: "question_sessions", kind: "message", T: ConnectedClassQuestionSession, repeated: true },
    { no: 8, name: "start_time", kind: "message", T: Timestamp },
    { no: 9, name: "end_time", kind: "message", T: Timestamp, opt: true },
    { no: 10, name: "metrics", kind: "message", T: TeacherAssessmentSessionMetrics, opt: true },
    { no: 11, name: "created_on", kind: "message", T: Timestamp },
    { no: 12, name: "created_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 13, name: "modified_on", kind: "message", T: Timestamp, opt: true },
    { no: 14, name: "modified_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 15, name: "deleted_at", kind: "message", T: Timestamp, opt: true },
    { no: 16, name: "active_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 17, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 18, name: "school_device_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 19, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 20, name: "assessment_question_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 21, name: "section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 22, name: "course_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 23, name: "connected_class_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 24, name: "session_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherAssessmentSession {
    return new TeacherAssessmentSession().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherAssessmentSession {
    return new TeacherAssessmentSession().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherAssessmentSession {
    return new TeacherAssessmentSession().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherAssessmentSession | PlainMessage<TeacherAssessmentSession> | undefined, b: TeacherAssessmentSession | PlainMessage<TeacherAssessmentSession> | undefined): boolean {
    return proto3.util.equals(TeacherAssessmentSession, a, b);
  }
}

/**
 * StudentLessonSessionMetrics represents the metrics for a student's lesson session.
 *
 * @generated from message geneo.lms.db.StudentResourceSessionMetrics
 */
export class StudentResourceSessionMetrics extends Message<StudentResourceSessionMetrics> {
  /**
   * Unique identifier for the student's lesson session.
   *
   * @generated from field: optional int64 student_resource_session_id = 1;
   */
  studentResourceSessionId?: bigint;

  /**
   * Indicates if the lesson session is complete or not. Optional field.
   *
   * @generated from field: bool is_complete = 2;
   */
  isComplete = false;

  /**
   * @generated from field: float response_score = 3;
   */
  responseScore = 0;

  /**
   * @generated from field: float max_score = 4;
   */
  maxScore = 0;

  /**
   * List of resource IDs that have been completed by the student.
   *
   * @generated from field: repeated int32 completed_pages = 5;
   */
  completedPages: number[] = [];

  /**
   * List of visited resource content information.
   *
   * @generated from field: repeated geneo.lms.db.VisitedResourceContentInfoList visited_resource_content_info_list = 6;
   */
  visitedResourceContentInfoList: VisitedResourceContentInfoList[] = [];

  constructor(data?: PartialMessage<StudentResourceSessionMetrics>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.StudentResourceSessionMetrics";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_resource_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "is_complete", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "response_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "max_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "completed_pages", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 6, name: "visited_resource_content_info_list", kind: "message", T: VisitedResourceContentInfoList, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentResourceSessionMetrics {
    return new StudentResourceSessionMetrics().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentResourceSessionMetrics {
    return new StudentResourceSessionMetrics().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentResourceSessionMetrics {
    return new StudentResourceSessionMetrics().fromJsonString(jsonString, options);
  }

  static equals(a: StudentResourceSessionMetrics | PlainMessage<StudentResourceSessionMetrics> | undefined, b: StudentResourceSessionMetrics | PlainMessage<StudentResourceSessionMetrics> | undefined): boolean {
    return proto3.util.equals(StudentResourceSessionMetrics, a, b);
  }
}

/**
 * StudentResourceSessionMetrics represents the metrics for a student's lesson session.
 *
 * @generated from message geneo.lms.db.TeacherResourceSessionMetrics
 */
export class TeacherResourceSessionMetrics extends Message<TeacherResourceSessionMetrics> {
  /**
   * Unique identifier for the student's lesson session.
   *
   * @generated from field: optional int64 teacher_resource_session_id = 1;
   */
  teacherResourceSessionId?: bigint;

  /**
   * Indicates if the lesson session is complete or not. Optional field.
   *
   * @generated from field: bool is_complete = 2;
   */
  isComplete = false;

  /**
   * @generated from field: float response_score = 3;
   */
  responseScore = 0;

  /**
   * @generated from field: float max_score = 4;
   */
  maxScore = 0;

  /**
   * List of resource IDs that have been completed by the student.
   *
   * @generated from field: repeated int32 completed_pages = 5;
   */
  completedPages: number[] = [];

  /**
   * List of visited resource content information.
   *
   * @generated from field: repeated geneo.lms.db.VisitedResourceContentInfoList visited_resource_content_info_list = 6;
   */
  visitedResourceContentInfoList: VisitedResourceContentInfoList[] = [];

  constructor(data?: PartialMessage<TeacherResourceSessionMetrics>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.TeacherResourceSessionMetrics";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_resource_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "is_complete", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "response_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "max_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "completed_pages", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 6, name: "visited_resource_content_info_list", kind: "message", T: VisitedResourceContentInfoList, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherResourceSessionMetrics {
    return new TeacherResourceSessionMetrics().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherResourceSessionMetrics {
    return new TeacherResourceSessionMetrics().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherResourceSessionMetrics {
    return new TeacherResourceSessionMetrics().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherResourceSessionMetrics | PlainMessage<TeacherResourceSessionMetrics> | undefined, b: TeacherResourceSessionMetrics | PlainMessage<TeacherResourceSessionMetrics> | undefined): boolean {
    return proto3.util.equals(TeacherResourceSessionMetrics, a, b);
  }
}

/**
 * StudentResourceSession represents a resource session for a student.
 *
 * @generated from message geneo.lms.db.StudentResourceSession
 */
export class StudentResourceSession extends Message<StudentResourceSession> {
  /**
   * Unique identifier for the student's resource session.
   *
   * @generated from field: optional int64 student_resource_session_id = 1;
   */
  studentResourceSessionId?: bigint;

  /**
   * ID of the student associated with the resource session.
   *
   * @generated from field: optional int64 student_id = 2;
   */
  studentId?: bigint;

  /**
   * ID of the resource associated with the session.
   *
   * @generated from field: optional string resource_id = 3;
   */
  resourceId?: string;

  /**
   * ID of the school where the lesson session takes place.
   *
   * @generated from field: optional int32 school_id = 4;
   */
  schoolId?: number;

  /**
   * Academic year associated with the lesson session.
   *
   * @generated from field: int32 academic_year = 5;
   */
  academicYear = 0;

  /**
   * Grade associated with the lesson session.
   *
   * @generated from field: geneo.common.db.Class.ClassEnum class = 6;
   */
  class = Class_ClassEnum.UNDEFINED;

  /**
   * Section associated with the lesson session.
   *
   * @generated from field: string section = 7;
   */
  section = "";

  /**
   * Subject associated with the lesson session.
   *
   * @generated from field: optional int32 module_id = 8;
   */
  moduleId?: number;

  /**
   * Subject associated with the lesson session.
   *
   * @generated from field: optional geneo.common.db.Subject.SubjectEnum subject = 9;
   */
  subject?: Subject_SubjectEnum;

  /**
   * Resource version at the time of the session.
   *
   * @generated from field: int32 resource_content_version = 10;
   */
  resourceContentVersion = 0;

  /**
   * ID of the user's lesson session. Nullable field.
   *
   * @generated from field: optional int64 student_lesson_session_id = 11;
   */
  studentLessonSessionId?: bigint;

  /**
   * Mode of the resource session (e.g., online, offline, etc.).
   *
   * @generated from field: geneo.lms.db.SessionModeEnum session_mode = 12;
   */
  sessionMode = SessionModeEnum.SESSION_MODE_UNDEFINED;

  /**
   * Status of the resource session (e.g., in progress, completed, etc.).
   *
   * @generated from field: geneo.lms.db.SessionStatusEnum session_status = 13;
   */
  sessionStatus = SessionStatusEnum.SESSION_STATUS_UNDEFINED;

  /**
   * Start time of the resource session.
   *
   * @generated from field: google.protobuf.Timestamp start_time = 14;
   */
  startTime?: Timestamp;

  /**
   * End time of the resource session. Nullable field.
   *
   * @generated from field: google.protobuf.Timestamp end_time = 15;
   */
  endTime?: Timestamp;

  /**
   * Response associated with the resource session (e.g., ResourceResponseModel).
   *
   * @generated from field: repeated geneo.lms.db.StudentContentResponse response = 16;
   */
  response: StudentContentResponse[] = [];

  /**
   * Metrics associated with the lesson session. Nullable field.
   *
   * @generated from field: geneo.lms.db.StudentResourceSessionMetrics metrics = 17;
   */
  metrics?: StudentResourceSessionMetrics;

  /**
   * @generated from field: optional int64 active_session_id = 18;
   */
  activeSessionId?: bigint;

  /**
   * @generated from field: optional string nano_id = 19;
   */
  nanoId?: string;

  /**
   * optional int32 school_id = 12 ;
   *
   * @generated from field: optional int64 school_device_id = 20;
   */
  schoolDeviceId?: bigint;

  /**
   * @generated from field: optional int32 version = 21;
   */
  version?: number;

  constructor(data?: PartialMessage<StudentResourceSession>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.StudentResourceSession";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_resource_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 3, name: "resource_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "academic_year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "class", kind: "enum", T: proto3.getEnumType(Class_ClassEnum) },
    { no: 7, name: "section", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "module_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 9, name: "subject", kind: "enum", T: proto3.getEnumType(Subject_SubjectEnum), opt: true },
    { no: 10, name: "resource_content_version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "student_lesson_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 12, name: "session_mode", kind: "enum", T: proto3.getEnumType(SessionModeEnum) },
    { no: 13, name: "session_status", kind: "enum", T: proto3.getEnumType(SessionStatusEnum) },
    { no: 14, name: "start_time", kind: "message", T: Timestamp },
    { no: 15, name: "end_time", kind: "message", T: Timestamp },
    { no: 16, name: "response", kind: "message", T: StudentContentResponse, repeated: true },
    { no: 17, name: "metrics", kind: "message", T: StudentResourceSessionMetrics },
    { no: 18, name: "active_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 19, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 20, name: "school_device_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 21, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentResourceSession {
    return new StudentResourceSession().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentResourceSession {
    return new StudentResourceSession().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentResourceSession {
    return new StudentResourceSession().fromJsonString(jsonString, options);
  }

  static equals(a: StudentResourceSession | PlainMessage<StudentResourceSession> | undefined, b: StudentResourceSession | PlainMessage<StudentResourceSession> | undefined): boolean {
    return proto3.util.equals(StudentResourceSession, a, b);
  }
}

/**
 * Per-sitting metrics for a project session. Deliberately identical in shape to
 * StudentLessonSessionMetrics - a project is a set of lesson-plan resources, so
 * "what did I cover" means the same thing in both flows.
 *
 * @generated from message geneo.lms.db.StudentProjectSessionMetrics
 */
export class StudentProjectSessionMetrics extends Message<StudentProjectSessionMetrics> {
  /**
   * Unique identifier for the student's project session.
   *
   * @generated from field: optional int64 student_project_session_id = 1;
   */
  studentProjectSessionId?: bigint;

  /**
   * This sitting covered everything it set out to.
   *
   * @generated from field: bool is_complete = 2;
   */
  isComplete = false;

  /**
   * Reserved; projects are teacher-marked, not auto-scored.
   *
   * @generated from field: float response_score = 3;
   */
  responseScore = 0;

  /**
   * Reserved, for parity with the lesson metrics message.
   *
   * @generated from field: float max_score = 4;
   */
  maxScore = 0;

  /**
   * Client-computed, exactly as in the learn flow.
   *
   * @generated from field: repeated string completed_resource_ids = 5;
   */
  completedResourceIds: string[] = [];

  /**
   * List of visited resource content information.
   *
   * @generated from field: repeated geneo.lms.db.VisitedResourceContentInfoList visited_resource_content_info_list = 6;
   */
  visitedResourceContentInfoList: VisitedResourceContentInfoList[] = [];

  /**
   * @generated from field: optional string nano_id = 7;
   */
  nanoId?: string;

  /**
   * @generated from field: optional int32 version = 8;
   */
  version?: number;

  constructor(data?: PartialMessage<StudentProjectSessionMetrics>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.StudentProjectSessionMetrics";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_project_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "is_complete", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "response_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "max_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "completed_resource_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "visited_resource_content_info_list", kind: "message", T: VisitedResourceContentInfoList, repeated: true },
    { no: 7, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentProjectSessionMetrics {
    return new StudentProjectSessionMetrics().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentProjectSessionMetrics {
    return new StudentProjectSessionMetrics().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentProjectSessionMetrics {
    return new StudentProjectSessionMetrics().fromJsonString(jsonString, options);
  }

  static equals(a: StudentProjectSessionMetrics | PlainMessage<StudentProjectSessionMetrics> | undefined, b: StudentProjectSessionMetrics | PlainMessage<StudentProjectSessionMetrics> | undefined): boolean {
    return proto3.util.equals(StudentProjectSessionMetrics, a, b);
  }
}

/**
 * One sitting of a student on a project assessment. Mirrors StudentLessonSession
 * because a project renders as lesson plans; assessment_id/task_id replace
 * lesson_id, and there is no teacher project session to point back at.
 *
 * @generated from message geneo.lms.db.StudentProjectSession
 */
export class StudentProjectSession extends Message<StudentProjectSession> {
  /**
   * Unique identifier for the student's project session.
   *
   * @generated from field: optional int64 student_project_session_id = 1;
   */
  studentProjectSessionId?: bigint;

  /**
   * ID of the student associated with the project session.
   *
   * @generated from field: optional int64 student_id = 2;
   */
  studentId?: bigint;

  /**
   * task.id - what every assessment API keys on.
   *
   * @generated from field: optional int64 assessment_id = 3;
   */
  assessmentId?: bigint;

  /**
   * task.taskId - what the project progress engine keys on.
   *
   * @generated from field: optional string task_id = 4;
   */
  taskId?: string;

  /**
   * ID of the school where the project session takes place.
   *
   * @generated from field: optional int32 school_id = 5;
   */
  schoolId?: number;

  /**
   * Academic year associated with the project session.
   *
   * @generated from field: int32 academic_year = 6;
   */
  academicYear = 0;

  /**
   * Grade of the student.
   *
   * @generated from field: geneo.common.db.Class.ClassEnum class = 7;
   */
  class = Class_ClassEnum.UNDEFINED;

  /**
   * Section of the student.
   *
   * @generated from field: string section = 8;
   */
  section = "";

  /**
   * Subject of the project.
   *
   * @generated from field: geneo.common.db.Subject.SubjectEnum subject = 9;
   */
  subject = Subject_SubjectEnum.UNDEFINED;

  /**
   * Mode of the project session.
   *
   * @generated from field: geneo.lms.db.SessionModeEnum session_mode = 10;
   */
  sessionMode = SessionModeEnum.SESSION_MODE_UNDEFINED;

  /**
   * Status of the project session.
   *
   * @generated from field: geneo.lms.db.SessionStatusEnum session_status = 11;
   */
  sessionStatus = SessionStatusEnum.SESSION_STATUS_UNDEFINED;

  /**
   * Resources this sitting set out to cover.
   *
   * @generated from field: repeated string session_resource_ids = 12;
   */
  sessionResourceIds: string[] = [];

  /**
   * Start time of the project session.
   *
   * @generated from field: google.protobuf.Timestamp start_time = 13;
   */
  startTime?: Timestamp;

  /**
   * End time of the project session. Nullable field.
   *
   * @generated from field: google.protobuf.Timestamp end_time = 14;
   */
  endTime?: Timestamp;

  /**
   * Metrics associated with the session. Nullable field.
   *
   * @generated from field: geneo.lms.db.StudentProjectSessionMetrics metrics = 15;
   */
  metrics?: StudentProjectSessionMetrics;

  /**
   * Timestamp when the session was created. Nullable field.
   *
   * @generated from field: google.protobuf.Timestamp created_on = 16;
   */
  createdOn?: Timestamp;

  /**
   * ID of the user who created the session. Nullable field.
   *
   * @generated from field: optional int64 created_by = 17;
   */
  createdBy?: bigint;

  /**
   * Timestamp when the session was last modified. Nullable field.
   *
   * @generated from field: optional google.protobuf.Timestamp modified_on = 18;
   */
  modifiedOn?: Timestamp;

  /**
   * ID of the user who last modified the session. Nullable field.
   *
   * @generated from field: optional int64 modified_by = 19;
   */
  modifiedBy?: bigint;

  /**
   * @generated from field: optional int64 active_session_id = 20;
   */
  activeSessionId?: bigint;

  /**
   * @generated from field: optional string nano_id = 21;
   */
  nanoId?: string;

  /**
   * @generated from field: optional int64 school_device_id = 22;
   */
  schoolDeviceId?: bigint;

  /**
   * @generated from field: optional int32 version = 23;
   */
  version?: number;

  constructor(data?: PartialMessage<StudentProjectSession>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.StudentProjectSession";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_project_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 3, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 4, name: "task_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "academic_year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "class", kind: "enum", T: proto3.getEnumType(Class_ClassEnum) },
    { no: 8, name: "section", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "subject", kind: "enum", T: proto3.getEnumType(Subject_SubjectEnum) },
    { no: 10, name: "session_mode", kind: "enum", T: proto3.getEnumType(SessionModeEnum) },
    { no: 11, name: "session_status", kind: "enum", T: proto3.getEnumType(SessionStatusEnum) },
    { no: 12, name: "session_resource_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 13, name: "start_time", kind: "message", T: Timestamp },
    { no: 14, name: "end_time", kind: "message", T: Timestamp },
    { no: 15, name: "metrics", kind: "message", T: StudentProjectSessionMetrics },
    { no: 16, name: "created_on", kind: "message", T: Timestamp },
    { no: 17, name: "created_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 18, name: "modified_on", kind: "message", T: Timestamp, opt: true },
    { no: 19, name: "modified_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 20, name: "active_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 21, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 22, name: "school_device_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 23, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentProjectSession {
    return new StudentProjectSession().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentProjectSession {
    return new StudentProjectSession().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentProjectSession {
    return new StudentProjectSession().fromJsonString(jsonString, options);
  }

  static equals(a: StudentProjectSession | PlainMessage<StudentProjectSession> | undefined, b: StudentProjectSession | PlainMessage<StudentProjectSession> | undefined): boolean {
    return proto3.util.equals(StudentProjectSession, a, b);
  }
}

/**
 * One resource opened inside a project session. Mirrors StudentResourceSession
 * and reuses StudentResourceSessionMetrics unchanged.
 *
 * @generated from message geneo.lms.db.StudentProjectResourceSession
 */
export class StudentProjectResourceSession extends Message<StudentProjectResourceSession> {
  /**
   * Unique identifier for the student's project resource session.
   *
   * @generated from field: optional int64 student_project_resource_session_id = 1;
   */
  studentProjectResourceSessionId?: bigint;

  /**
   * ID of the student associated with the resource session.
   *
   * @generated from field: optional int64 student_id = 2;
   */
  studentId?: bigint;

  /**
   * ID of the resource associated with the session.
   *
   * @generated from field: optional string resource_id = 3;
   */
  resourceId?: string;

  /**
   * ID of the school where the session takes place.
   *
   * @generated from field: optional int32 school_id = 4;
   */
  schoolId?: number;

  /**
   * Academic year associated with the session.
   *
   * @generated from field: int32 academic_year = 5;
   */
  academicYear = 0;

  /**
   * Grade associated with the session.
   *
   * @generated from field: geneo.common.db.Class.ClassEnum class = 6;
   */
  class = Class_ClassEnum.UNDEFINED;

  /**
   * Section associated with the session.
   *
   * @generated from field: string section = 7;
   */
  section = "";

  /**
   * Module associated with the session.
   *
   * @generated from field: optional int32 module_id = 8;
   */
  moduleId?: number;

  /**
   * Subject associated with the session.
   *
   * @generated from field: optional geneo.common.db.Subject.SubjectEnum subject = 9;
   */
  subject?: Subject_SubjectEnum;

  /**
   * Resource version at the time of the session.
   *
   * @generated from field: int32 resource_content_version = 10;
   */
  resourceContentVersion = 0;

  /**
   * Parent project session. Replaces student_lesson_session_id.
   *
   * @generated from field: optional int64 student_project_session_id = 11;
   */
  studentProjectSessionId?: bigint;

  /**
   * Mode of the resource session.
   *
   * @generated from field: geneo.lms.db.SessionModeEnum session_mode = 12;
   */
  sessionMode = SessionModeEnum.SESSION_MODE_UNDEFINED;

  /**
   * Status of the resource session.
   *
   * @generated from field: geneo.lms.db.SessionStatusEnum session_status = 13;
   */
  sessionStatus = SessionStatusEnum.SESSION_STATUS_UNDEFINED;

  /**
   * Start time of the resource session.
   *
   * @generated from field: google.protobuf.Timestamp start_time = 14;
   */
  startTime?: Timestamp;

  /**
   * End time of the resource session. Nullable field.
   *
   * @generated from field: google.protobuf.Timestamp end_time = 15;
   */
  endTime?: Timestamp;

  /**
   * Response associated with the resource session.
   *
   * @generated from field: repeated geneo.lms.db.StudentContentResponse response = 16;
   */
  response: StudentContentResponse[] = [];

  /**
   * Metrics associated with the session. Nullable field.
   *
   * @generated from field: geneo.lms.db.StudentResourceSessionMetrics metrics = 17;
   */
  metrics?: StudentResourceSessionMetrics;

  /**
   * @generated from field: optional int64 active_session_id = 18;
   */
  activeSessionId?: bigint;

  /**
   * @generated from field: optional string nano_id = 19;
   */
  nanoId?: string;

  /**
   * @generated from field: optional int64 school_device_id = 20;
   */
  schoolDeviceId?: bigint;

  /**
   * @generated from field: optional int32 version = 21;
   */
  version?: number;

  /**
   * New vs the learn flow: a project spans several lesson plans, so the resource
   * alone does not tell you which lesson plan the student came in through.
   *
   * @generated from field: optional string lesson_id = 22;
   */
  lessonId?: string;

  /**
   * @generated from field: optional int64 assessment_id = 23;
   */
  assessmentId?: bigint;

  /**
   * @generated from field: optional string task_id = 24;
   */
  taskId?: string;

  /**
   * @generated from field: optional geneo.content.db.PracticalProject practical_response = 25;
   */
  practicalResponse?: PracticalProject;

  constructor(data?: PartialMessage<StudentProjectResourceSession>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.StudentProjectResourceSession";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_project_resource_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 3, name: "resource_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "academic_year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "class", kind: "enum", T: proto3.getEnumType(Class_ClassEnum) },
    { no: 7, name: "section", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "module_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 9, name: "subject", kind: "enum", T: proto3.getEnumType(Subject_SubjectEnum), opt: true },
    { no: 10, name: "resource_content_version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "student_project_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 12, name: "session_mode", kind: "enum", T: proto3.getEnumType(SessionModeEnum) },
    { no: 13, name: "session_status", kind: "enum", T: proto3.getEnumType(SessionStatusEnum) },
    { no: 14, name: "start_time", kind: "message", T: Timestamp },
    { no: 15, name: "end_time", kind: "message", T: Timestamp },
    { no: 16, name: "response", kind: "message", T: StudentContentResponse, repeated: true },
    { no: 17, name: "metrics", kind: "message", T: StudentResourceSessionMetrics },
    { no: 18, name: "active_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 19, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 20, name: "school_device_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 21, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 22, name: "lesson_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 23, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 24, name: "task_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 25, name: "practical_response", kind: "message", T: PracticalProject, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentProjectResourceSession {
    return new StudentProjectResourceSession().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentProjectResourceSession {
    return new StudentProjectResourceSession().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentProjectResourceSession {
    return new StudentProjectResourceSession().fromJsonString(jsonString, options);
  }

  static equals(a: StudentProjectResourceSession | PlainMessage<StudentProjectResourceSession> | undefined, b: StudentProjectResourceSession | PlainMessage<StudentProjectResourceSession> | undefined): boolean {
    return proto3.util.equals(StudentProjectResourceSession, a, b);
  }
}

/**
 * TeacherResourceSession represents a resource session for a teacher.
 *
 * @generated from message geneo.lms.db.TeacherResourceSession
 */
export class TeacherResourceSession extends Message<TeacherResourceSession> {
  /**
   * Unique identifier for the teacher's resource session.
   *
   * @generated from field: optional int64 teacher_resource_session_id = 1;
   */
  teacherResourceSessionId?: bigint;

  /**
   * ID of the teacher associated with the resource session.
   *
   * @generated from field: optional int64 teacher_id = 2;
   */
  teacherId?: bigint;

  /**
   * ID of the resource associated with the session.
   *
   * @generated from field: optional string resource_id = 3;
   */
  resourceId?: string;

  /**
   * ID of the school where the lesson session takes place.
   *
   * @generated from field: optional int32 school_id = 4;
   */
  schoolId?: number;

  /**
   * Academic year associated with the lesson session.
   *
   * @generated from field: int32 academic_year = 5;
   */
  academicYear = 0;

  /**
   * Grade associated with the lesson session.
   *
   * @generated from field: geneo.common.db.Class.ClassEnum class = 6;
   */
  class = Class_ClassEnum.UNDEFINED;

  /**
   * Section associated with the lesson session.
   *
   * @generated from field: string section = 7;
   */
  section = "";

  /**
   * Subject associated with the lesson session.
   *
   * @generated from field: geneo.common.db.Subject.SubjectEnum subject = 8;
   */
  subject = Subject_SubjectEnum.UNDEFINED;

  /**
   * Subject associated with the lesson session.
   *
   * @generated from field: optional int32 module_id = 9;
   */
  moduleId?: number;

  /**
   * Resource version at the time of the session.
   *
   * @generated from field: int32 resource_content_version = 10;
   */
  resourceContentVersion = 0;

  /**
   * ID of the user's lesson session. Nullable field.
   *
   * @generated from field: optional int64 teacher_lesson_session_id = 11;
   */
  teacherLessonSessionId?: bigint;

  /**
   * Mode of the resource session (e.g., online, offline, etc.).
   *
   * @generated from field: geneo.lms.db.SessionModeEnum session_mode = 12;
   */
  sessionMode = SessionModeEnum.SESSION_MODE_UNDEFINED;

  /**
   * Status of the resource session (e.g., in progress, completed, etc.).
   *
   * @generated from field: geneo.lms.db.SessionStatusEnum session_status = 13;
   */
  sessionStatus = SessionStatusEnum.SESSION_STATUS_UNDEFINED;

  /**
   * Start time of the resource session.
   *
   * @generated from field: google.protobuf.Timestamp start_time = 14;
   */
  startTime?: Timestamp;

  /**
   * End time of the resource session. Nullable field.
   *
   * @generated from field: google.protobuf.Timestamp end_time = 15;
   */
  endTime?: Timestamp;

  /**
   * Response associated with the resource session (e.g., ResourceResponseModel).
   *
   * @generated from field: repeated geneo.lms.db.TeacherContentResponse response = 16;
   */
  response: TeacherContentResponse[] = [];

  /**
   * Metrics associated with the lesson session. Nullable field.
   *
   * @generated from field: geneo.lms.db.TeacherResourceSessionMetrics metrics = 17;
   */
  metrics?: TeacherResourceSessionMetrics;

  /**
   * @generated from field: optional int64 active_session_id = 18;
   */
  activeSessionId?: bigint;

  /**
   * @generated from field: optional string nano_id = 19;
   */
  nanoId?: string;

  /**
   * optional int32 school_id = 12 ;
   *
   * @generated from field: optional int64 school_device_id = 20;
   */
  schoolDeviceId?: bigint;

  /**
   * @generated from field: optional int32 version = 21;
   */
  version?: number;

  constructor(data?: PartialMessage<TeacherResourceSession>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.TeacherResourceSession";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_resource_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 3, name: "resource_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "academic_year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "class", kind: "enum", T: proto3.getEnumType(Class_ClassEnum) },
    { no: 7, name: "section", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "subject", kind: "enum", T: proto3.getEnumType(Subject_SubjectEnum) },
    { no: 9, name: "module_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 10, name: "resource_content_version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "teacher_lesson_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 12, name: "session_mode", kind: "enum", T: proto3.getEnumType(SessionModeEnum) },
    { no: 13, name: "session_status", kind: "enum", T: proto3.getEnumType(SessionStatusEnum) },
    { no: 14, name: "start_time", kind: "message", T: Timestamp },
    { no: 15, name: "end_time", kind: "message", T: Timestamp },
    { no: 16, name: "response", kind: "message", T: TeacherContentResponse, repeated: true },
    { no: 17, name: "metrics", kind: "message", T: TeacherResourceSessionMetrics },
    { no: 18, name: "active_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 19, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 20, name: "school_device_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 21, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherResourceSession {
    return new TeacherResourceSession().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherResourceSession {
    return new TeacherResourceSession().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherResourceSession {
    return new TeacherResourceSession().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherResourceSession | PlainMessage<TeacherResourceSession> | undefined, b: TeacherResourceSession | PlainMessage<TeacherResourceSession> | undefined): boolean {
    return proto3.util.equals(TeacherResourceSession, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.StudentModuleAnalytics
 */
export class StudentModuleAnalytics extends Message<StudentModuleAnalytics> {
  /**
   * @generated from field: int64 student_module_analytics_id = 1;
   */
  studentModuleAnalyticsId = protoInt64.zero;

  /**
   * @generated from field: int64 student_id = 2;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: int32 course_id = 3;
   */
  courseId = 0;

  /**
   * @generated from field: int32 module_id = 4;
   */
  moduleId = 0;

  /**
   * @generated from field: float score = 5;
   */
  score = 0;

  /**
   * @generated from field: int32 no_of_hw_completed = 6;
   */
  noOfHwCompleted = 0;

  /**
   * @generated from field: float time_spent_in_min = 7;
   */
  timeSpentInMin = 0;

  /**
   * @generated from field: google.protobuf.Timestamp expiry_timestamp = 8;
   */
  expiryTimestamp?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp last_updated_time = 9;
   */
  lastUpdatedTime?: Timestamp;

  /**
   * Timestamp when the session was created. Nullable field.
   *
   * @generated from field: google.protobuf.Timestamp created_on = 10;
   */
  createdOn?: Timestamp;

  /**
   * ID of the user who created the session. Nullable field.
   *
   * @generated from field: optional int64 created_by = 11;
   */
  createdBy?: bigint;

  /**
   * Timestamp when the session was last modified. Nullable field.
   *
   * @generated from field: optional google.protobuf.Timestamp modified_on = 12;
   */
  modifiedOn?: Timestamp;

  /**
   * ID of the user who last modified the session. Nullable field.
   *
   * @generated from field: optional int64 modified_by = 13;
   */
  modifiedBy?: bigint;

  /**
   * @generated from field: int32 version = 14;
   */
  version = 0;

  /**
   * 0 -> book, 1 -> chapter, 2 -> topic
   *
   * @generated from field: int32 level = 15;
   */
  level = 0;

  /**
   * @generated from field: optional int64 teacher_id = 16;
   */
  teacherId?: bigint;

  /**
   * @generated from field: optional string nano_id = 17;
   */
  nanoId?: string;

  /**
   * @generated from field: optional int32 school_id = 18;
   */
  schoolId?: number;

  /**
   * @generated from field: optional int64 school_device_id = 19;
   */
  schoolDeviceId?: bigint;

  /**
   * @generated from field: int32 no_of_assessments_completed = 20;
   */
  noOfAssessmentsCompleted = 0;

  constructor(data?: PartialMessage<StudentModuleAnalytics>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.StudentModuleAnalytics";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_module_analytics_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "course_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "module_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "no_of_hw_completed", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "time_spent_in_min", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 8, name: "expiry_timestamp", kind: "message", T: Timestamp },
    { no: 9, name: "last_updated_time", kind: "message", T: Timestamp },
    { no: 10, name: "created_on", kind: "message", T: Timestamp },
    { no: 11, name: "created_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 12, name: "modified_on", kind: "message", T: Timestamp, opt: true },
    { no: 13, name: "modified_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 14, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "level", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 17, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 18, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 19, name: "school_device_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 20, name: "no_of_assessments_completed", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentModuleAnalytics {
    return new StudentModuleAnalytics().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentModuleAnalytics {
    return new StudentModuleAnalytics().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentModuleAnalytics {
    return new StudentModuleAnalytics().fromJsonString(jsonString, options);
  }

  static equals(a: StudentModuleAnalytics | PlainMessage<StudentModuleAnalytics> | undefined, b: StudentModuleAnalytics | PlainMessage<StudentModuleAnalytics> | undefined): boolean {
    return proto3.util.equals(StudentModuleAnalytics, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.TeacherModuleAnalytics
 */
export class TeacherModuleAnalytics extends Message<TeacherModuleAnalytics> {
  /**
   * @generated from field: int64 teacher_module_analytics_id = 1;
   */
  teacherModuleAnalyticsId = protoInt64.zero;

  /**
   * @generated from field: int64 teacher_id = 2;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int64 school_class_section_id = 3;
   */
  schoolClassSectionId = protoInt64.zero;

  /**
   * @generated from field: int32 course_id = 5;
   */
  courseId = 0;

  /**
   * @generated from field: int32 module_id = 4;
   */
  moduleId = 0;

  /**
   * @generated from field: float score = 6;
   */
  score = 0;

  /**
   * @generated from field: int32 no_of_hw_assigned = 7;
   */
  noOfHwAssigned = 0;

  /**
   * @generated from field: int32 no_of_lesson_taughts = 8;
   */
  noOfLessonTaughts = 0;

  /**
   * @generated from field: float time_spent_in_min = 9;
   */
  timeSpentInMin = 0;

  /**
   * @generated from field: google.protobuf.Timestamp expiry_timestamp = 10;
   */
  expiryTimestamp?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp last_updated_time = 11;
   */
  lastUpdatedTime?: Timestamp;

  /**
   * Timestamp when the session was created. Nullable field.
   *
   * @generated from field: google.protobuf.Timestamp created_on = 12;
   */
  createdOn?: Timestamp;

  /**
   * ID of the user who created the session. Nullable field.
   *
   * @generated from field: optional int64 created_by = 13;
   */
  createdBy?: bigint;

  /**
   * Timestamp when the session was last modified. Nullable field.
   *
   * @generated from field: optional google.protobuf.Timestamp modified_on = 14;
   */
  modifiedOn?: Timestamp;

  /**
   * ID of the user who last modified the session. Nullable field.
   *
   * @generated from field: optional int64 modified_by = 15;
   */
  modifiedBy?: bigint;

  /**
   * @generated from field: int32 version = 16;
   */
  version = 0;

  /**
   * 0 -> book, 1 -> chapter, 2 -> topic
   *
   * @generated from field: int32 level = 17;
   */
  level = 0;

  /**
   * @generated from field: optional string nano_id = 18;
   */
  nanoId?: string;

  /**
   * @generated from field: optional int32 school_id = 19;
   */
  schoolId?: number;

  /**
   * @generated from field: optional int64 school_device_id = 20;
   */
  schoolDeviceId?: bigint;

  /**
   * @generated from field: int32 no_of_fa_assigned = 21;
   */
  noOfFaAssigned = 0;

  constructor(data?: PartialMessage<TeacherModuleAnalytics>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.TeacherModuleAnalytics";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_module_analytics_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "school_class_section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "course_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "module_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "no_of_hw_assigned", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "no_of_lesson_taughts", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "time_spent_in_min", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 10, name: "expiry_timestamp", kind: "message", T: Timestamp },
    { no: 11, name: "last_updated_time", kind: "message", T: Timestamp },
    { no: 12, name: "created_on", kind: "message", T: Timestamp },
    { no: 13, name: "created_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 14, name: "modified_on", kind: "message", T: Timestamp, opt: true },
    { no: 15, name: "modified_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 16, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 17, name: "level", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 18, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 19, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 20, name: "school_device_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 21, name: "no_of_fa_assigned", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherModuleAnalytics {
    return new TeacherModuleAnalytics().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherModuleAnalytics {
    return new TeacherModuleAnalytics().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherModuleAnalytics {
    return new TeacherModuleAnalytics().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherModuleAnalytics | PlainMessage<TeacherModuleAnalytics> | undefined, b: TeacherModuleAnalytics | PlainMessage<TeacherModuleAnalytics> | undefined): boolean {
    return proto3.util.equals(TeacherModuleAnalytics, a, b);
  }
}

/**
 * Message for connected_class session table
 *
 * @generated from message geneo.lms.db.ConnectedClassSession
 */
export class ConnectedClassSession extends Message<ConnectedClassSession> {
  /**
   * Primary key for connected_class_session
   *
   * @generated from field: int64 connected_class_session_id = 1;
   */
  connectedClassSessionId = protoInt64.zero;

  /**
   * referencing school id
   *
   * @generated from field: int32 school_id = 2;
   */
  schoolId = 0;

  /**
   * referencing class
   *
   * @generated from field: int32 classId = 3;
   */
  classId = 0;

  /**
   * referencing section
   *
   * @generated from field: int64 section_id = 4;
   */
  sectionId = protoInt64.zero;

  /**
   * referencing subject
   *
   * @generated from field: optional geneo.common.db.Subject.SubjectEnum subject = 5;
   */
  subject?: Subject_SubjectEnum;

  /**
   * referencing base receiver id
   *
   * @generated from field: int64 base_receiver_id = 6;
   */
  baseReceiverId = protoInt64.zero;

  /**
   * referencing teacher profile id
   *
   * @generated from field: int64 teacher_id = 7;
   */
  teacherId = protoInt64.zero;

  /**
   * referencing lesson id
   *
   * @generated from field: optional string lesson_id = 8;
   */
  lessonId?: string;

  /**
   * referencing lesson session id
   *
   * @generated from field: optional int64 teacher_lesson_session_id = 9;
   */
  teacherLessonSessionId?: bigint;

  /**
   * session start time
   *
   * @generated from field: google.protobuf.Timestamp session_start_time = 10;
   */
  sessionStartTime?: Timestamp;

  /**
   * session end time
   *
   * @generated from field: google.protobuf.Timestamp session_end_time = 11;
   */
  sessionEndTime?: Timestamp;

  /**
   * session status
   *
   * @generated from field: geneo.lms.db.SessionStatusEnum session_status = 12;
   */
  sessionStatus = SessionStatusEnum.SESSION_STATUS_UNDEFINED;

  /**
   * Creation timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_on = 13;
   */
  createdOn?: Timestamp;

  /**
   * User who created the entry
   *
   * @generated from field: optional int64 created_by = 14;
   */
  createdBy?: bigint;

  /**
   * Last modification timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp modified_on = 15;
   */
  modifiedOn?: Timestamp;

  /**
   * User who last modified the entry
   *
   * @generated from field: optional int64 modified_by = 16;
   */
  modifiedBy?: bigint;

  /**
   * represents the deleted timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 17;
   */
  deletedAt?: Timestamp;

  /**
   * @generated from field: optional string nano_id = 18;
   */
  nanoId?: string;

  /**
   * optional int32 school_id = 19 ;
   *
   * @generated from field: optional int64 school_device_id = 19;
   */
  schoolDeviceId?: bigint;

  /**
   * @generated from field: optional int32 version = 20;
   */
  version?: number;

  /**
   * referencing homework id
   *
   * @generated from field: optional int64 reference_id = 21;
   */
  referenceId?: bigint;

  /**
   * referencing homework session id
   *
   * @generated from field: optional int32 teacher_session_id = 22;
   */
  teacherSessionId?: number;

  /**
   * lesson or homework
   *
   * @generated from field: optional geneo.lms.db.CCSessionEnum session_type = 23;
   */
  sessionType?: CCSessionEnum;

  /**
   * subjects for multi-subject assessments
   *
   * @generated from field: repeated geneo.common.db.Subject.SubjectEnum subjects = 24;
   */
  subjects: Subject_SubjectEnum[] = [];

  constructor(data?: PartialMessage<ConnectedClassSession>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.ConnectedClassSession";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "connected_class_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "classId", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "subject", kind: "enum", T: proto3.getEnumType(Subject_SubjectEnum), opt: true },
    { no: 6, name: "base_receiver_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "lesson_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "teacher_lesson_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 10, name: "session_start_time", kind: "message", T: Timestamp },
    { no: 11, name: "session_end_time", kind: "message", T: Timestamp },
    { no: 12, name: "session_status", kind: "enum", T: proto3.getEnumType(SessionStatusEnum) },
    { no: 13, name: "created_on", kind: "message", T: Timestamp },
    { no: 14, name: "created_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 15, name: "modified_on", kind: "message", T: Timestamp, opt: true },
    { no: 16, name: "modified_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 17, name: "deleted_at", kind: "message", T: Timestamp, opt: true },
    { no: 18, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 19, name: "school_device_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 20, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 21, name: "reference_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 22, name: "teacher_session_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 23, name: "session_type", kind: "enum", T: proto3.getEnumType(CCSessionEnum), opt: true },
    { no: 24, name: "subjects", kind: "enum", T: proto3.getEnumType(Subject_SubjectEnum), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConnectedClassSession {
    return new ConnectedClassSession().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConnectedClassSession {
    return new ConnectedClassSession().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConnectedClassSession {
    return new ConnectedClassSession().fromJsonString(jsonString, options);
  }

  static equals(a: ConnectedClassSession | PlainMessage<ConnectedClassSession> | undefined, b: ConnectedClassSession | PlainMessage<ConnectedClassSession> | undefined): boolean {
    return proto3.util.equals(ConnectedClassSession, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.ConnectedClassResourceSession
 */
export class ConnectedClassResourceSession extends Message<ConnectedClassResourceSession> {
  /**
   * Primary key for connected_class_question_session
   *
   * @generated from field: int64 connected_class_resource_session_id = 1;
   */
  connectedClassResourceSessionId = protoInt64.zero;

  /**
   * referencing connected_class_session_id
   *
   * @generated from field: int64 connected_class_session_id = 2;
   */
  connectedClassSessionId = protoInt64.zero;

  /**
   * referencing question id
   *
   * @generated from field: string resource_id = 3;
   */
  resourceId = "";

  /**
   * question start time
   *
   * @generated from field: google.protobuf.Timestamp session_start_time = 4;
   */
  sessionStartTime?: Timestamp;

  /**
   * question end time
   *
   * @generated from field: optional google.protobuf.Timestamp session_end_time = 5;
   */
  sessionEndTime?: Timestamp;

  /**
   * session status
   *
   * @generated from field: geneo.lms.db.SessionStatusEnum session_status = 6;
   */
  sessionStatus = SessionStatusEnum.SESSION_STATUS_UNDEFINED;

  /**
   * Creation timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_on = 7;
   */
  createdOn?: Timestamp;

  /**
   * User who created the entry
   *
   * @generated from field: optional int64 created_by = 8;
   */
  createdBy?: bigint;

  /**
   * Last modification timestamp
   *
   * @generated from field: google.protobuf.Timestamp modified_on = 9;
   */
  modifiedOn?: Timestamp;

  /**
   * User who last modified the entry
   *
   * @generated from field: optional int64 modified_by = 10;
   */
  modifiedBy?: bigint;

  /**
   * represents the deleted timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 11;
   */
  deletedAt?: Timestamp;

  /**
   * @generated from field: optional string nano_id = 12;
   */
  nanoId?: string;

  /**
   * @generated from field: optional int32 school_id = 13;
   */
  schoolId?: number;

  /**
   * @generated from field: optional int64 school_device_id = 14;
   */
  schoolDeviceId?: bigint;

  /**
   * @generated from field: optional int32 version = 15;
   */
  version?: number;

  constructor(data?: PartialMessage<ConnectedClassResourceSession>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.ConnectedClassResourceSession";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "connected_class_resource_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "connected_class_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "resource_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "session_start_time", kind: "message", T: Timestamp },
    { no: 5, name: "session_end_time", kind: "message", T: Timestamp, opt: true },
    { no: 6, name: "session_status", kind: "enum", T: proto3.getEnumType(SessionStatusEnum) },
    { no: 7, name: "created_on", kind: "message", T: Timestamp },
    { no: 8, name: "created_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 9, name: "modified_on", kind: "message", T: Timestamp },
    { no: 10, name: "modified_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 11, name: "deleted_at", kind: "message", T: Timestamp, opt: true },
    { no: 12, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 13, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 14, name: "school_device_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 15, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConnectedClassResourceSession {
    return new ConnectedClassResourceSession().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConnectedClassResourceSession {
    return new ConnectedClassResourceSession().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConnectedClassResourceSession {
    return new ConnectedClassResourceSession().fromJsonString(jsonString, options);
  }

  static equals(a: ConnectedClassResourceSession | PlainMessage<ConnectedClassResourceSession> | undefined, b: ConnectedClassResourceSession | PlainMessage<ConnectedClassResourceSession> | undefined): boolean {
    return proto3.util.equals(ConnectedClassResourceSession, a, b);
  }
}

/**
 * message for connected_class_question_session table
 *
 * @generated from message geneo.lms.db.ConnectedClassQuestionSession
 */
export class ConnectedClassQuestionSession extends Message<ConnectedClassQuestionSession> {
  /**
   * Primary key for connected_class_question_session
   *
   * @generated from field: int64 connected_class_question_session_id = 1;
   */
  connectedClassQuestionSessionId = protoInt64.zero;

  /**
   * referencing connected_class_session_id
   *
   * @generated from field: optional int64 connected_class_resource_session_id = 2;
   */
  connectedClassResourceSessionId?: bigint;

  /**
   * referencing question id
   *
   * @generated from field: string question_id = 3;
   */
  questionId = "";

  /**
   * sequence number
   *
   * @generated from field: optional int32 sequence = 4;
   */
  sequence?: number;

  /**
   * question start time
   *
   * @generated from field: google.protobuf.Timestamp start_time = 5;
   */
  startTime?: Timestamp;

  /**
   * question end time
   *
   * @generated from field: optional google.protobuf.Timestamp end_time = 6;
   */
  endTime?: Timestamp;

  /**
   * Creation timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_on = 7;
   */
  createdOn?: Timestamp;

  /**
   * User who created the entry
   *
   * @generated from field: optional int64 created_by = 8;
   */
  createdBy?: bigint;

  /**
   * Last modification timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp modified_on = 9;
   */
  modifiedOn?: Timestamp;

  /**
   * User who last modified the entry
   *
   * @generated from field: optional int64 modified_by = 10;
   */
  modifiedBy?: bigint;

  /**
   * represents the deleted timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 11;
   */
  deletedAt?: Timestamp;

  /**
   * session status
   *
   * @generated from field: geneo.lms.db.SessionStatusEnum session_status = 12;
   */
  sessionStatus = SessionStatusEnum.SESSION_STATUS_UNDEFINED;

  /**
   * @generated from field: optional string nano_id = 13;
   */
  nanoId?: string;

  /**
   * @generated from field: optional int32 school_id = 14;
   */
  schoolId?: number;

  /**
   * @generated from field: optional int64 school_device_id = 15;
   */
  schoolDeviceId?: bigint;

  /**
   * @generated from field: optional int32 version = 16;
   */
  version?: number;

  /**
   * referencing connected_class_session_id
   *
   * @generated from field: optional int64 connected_class_session_id = 17;
   */
  connectedClassSessionId?: bigint;

  /**
   * @generated from field: optional int64 teacher_assessment_session_id = 18;
   */
  teacherAssessmentSessionId?: bigint;

  constructor(data?: PartialMessage<ConnectedClassQuestionSession>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.ConnectedClassQuestionSession";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "connected_class_question_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "connected_class_resource_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 3, name: "question_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "sequence", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "start_time", kind: "message", T: Timestamp },
    { no: 6, name: "end_time", kind: "message", T: Timestamp, opt: true },
    { no: 7, name: "created_on", kind: "message", T: Timestamp },
    { no: 8, name: "created_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 9, name: "modified_on", kind: "message", T: Timestamp, opt: true },
    { no: 10, name: "modified_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 11, name: "deleted_at", kind: "message", T: Timestamp, opt: true },
    { no: 12, name: "session_status", kind: "enum", T: proto3.getEnumType(SessionStatusEnum) },
    { no: 13, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 14, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 15, name: "school_device_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 16, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 17, name: "connected_class_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 18, name: "teacher_assessment_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConnectedClassQuestionSession {
    return new ConnectedClassQuestionSession().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConnectedClassQuestionSession {
    return new ConnectedClassQuestionSession().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConnectedClassQuestionSession {
    return new ConnectedClassQuestionSession().fromJsonString(jsonString, options);
  }

  static equals(a: ConnectedClassQuestionSession | PlainMessage<ConnectedClassQuestionSession> | undefined, b: ConnectedClassQuestionSession | PlainMessage<ConnectedClassQuestionSession> | undefined): boolean {
    return proto3.util.equals(ConnectedClassQuestionSession, a, b);
  }
}

/**
 * Message for connected_class_student_session table
 * TODO: do we need to support multiple sessions for a student in a class? and shall we consider it as 1 session even if it's not continuous? -- individual session
 * TODO: check for the user active status and need to maintain that?
 *
 * @generated from message geneo.lms.db.ConnectedClassStudentSession
 */
export class ConnectedClassStudentSession extends Message<ConnectedClassStudentSession> {
  /**
   * Primary key for connected_class_student_session
   *
   * @generated from field: int64 connected_class_student_session_id = 1;
   */
  connectedClassStudentSessionId = protoInt64.zero;

  /**
   * referencing connected_class_session_id
   *
   * @generated from field: int64 connected_class_session_id = 2;
   */
  connectedClassSessionId = protoInt64.zero;

  /**
   * referencing student profile id
   *
   * @generated from field: int64 student_id = 3;
   */
  studentId = protoInt64.zero;

  /**
   * referencing clicker id
   *
   * @generated from field: string clicker_id = 4;
   */
  clickerId = "";

  /**
   * Response associated with the resource session (e.g., ResourceResponseModel).
   *
   * @generated from field: repeated geneo.lms.db.StudentContentedClassResponse response = 5;
   */
  response: StudentContentedClassResponse[] = [];

  /**
   * session start time
   *
   * @generated from field: google.protobuf.Timestamp session_start_time = 6;
   */
  sessionStartTime?: Timestamp;

  /**
   * session end time
   *
   * @generated from field: optional google.protobuf.Timestamp session_end_time = 7;
   */
  sessionEndTime?: Timestamp;

  /**
   * Creation timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_on = 8;
   */
  createdOn?: Timestamp;

  /**
   * session status
   *
   * @generated from field: geneo.lms.db.SessionStatusEnum session_status = 9;
   */
  sessionStatus = SessionStatusEnum.SESSION_STATUS_UNDEFINED;

  /**
   * User who created the entry
   *
   * @generated from field: optional int64 created_by = 10;
   */
  createdBy?: bigint;

  /**
   * Last modification timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp modified_on = 11;
   */
  modifiedOn?: Timestamp;

  /**
   * User who last modified the entry
   *
   * @generated from field: optional int64 modified_by = 12;
   */
  modifiedBy?: bigint;

  /**
   * represents the deleted timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 13;
   */
  deletedAt?: Timestamp;

  /**
   * @generated from field: repeated geneo.lms.db.ClickerConnectionAttempt clicker_connection_attempts = 14;
   */
  clickerConnectionAttempts: ClickerConnectionAttempt[] = [];

  /**
   * @generated from field: optional string nano_id = 15;
   */
  nanoId?: string;

  /**
   * @generated from field: optional int32 school_id = 16;
   */
  schoolId?: number;

  /**
   * @generated from field: optional int64 school_device_id = 17;
   */
  schoolDeviceId?: bigint;

  /**
   * @generated from field: optional int32 version = 18;
   */
  version?: number;

  constructor(data?: PartialMessage<ConnectedClassStudentSession>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.ConnectedClassStudentSession";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "connected_class_student_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "connected_class_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "clicker_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "response", kind: "message", T: StudentContentedClassResponse, repeated: true },
    { no: 6, name: "session_start_time", kind: "message", T: Timestamp },
    { no: 7, name: "session_end_time", kind: "message", T: Timestamp, opt: true },
    { no: 8, name: "created_on", kind: "message", T: Timestamp },
    { no: 9, name: "session_status", kind: "enum", T: proto3.getEnumType(SessionStatusEnum) },
    { no: 10, name: "created_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 11, name: "modified_on", kind: "message", T: Timestamp, opt: true },
    { no: 12, name: "modified_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 13, name: "deleted_at", kind: "message", T: Timestamp, opt: true },
    { no: 14, name: "clicker_connection_attempts", kind: "message", T: ClickerConnectionAttempt, repeated: true },
    { no: 15, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 16, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 17, name: "school_device_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 18, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConnectedClassStudentSession {
    return new ConnectedClassStudentSession().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConnectedClassStudentSession {
    return new ConnectedClassStudentSession().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConnectedClassStudentSession {
    return new ConnectedClassStudentSession().fromJsonString(jsonString, options);
  }

  static equals(a: ConnectedClassStudentSession | PlainMessage<ConnectedClassStudentSession> | undefined, b: ConnectedClassStudentSession | PlainMessage<ConnectedClassStudentSession> | undefined): boolean {
    return proto3.util.equals(ConnectedClassStudentSession, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.ClickerConnectionAttempt
 */
export class ClickerConnectionAttempt extends Message<ClickerConnectionAttempt> {
  /**
   * @generated from field: google.protobuf.Timestamp connected_at = 1;
   */
  connectedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp disconnected_at = 2;
   */
  disconnectedAt?: Timestamp;

  constructor(data?: PartialMessage<ClickerConnectionAttempt>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.ClickerConnectionAttempt";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "connected_at", kind: "message", T: Timestamp },
    { no: 2, name: "disconnected_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClickerConnectionAttempt {
    return new ClickerConnectionAttempt().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClickerConnectionAttempt {
    return new ClickerConnectionAttempt().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClickerConnectionAttempt {
    return new ClickerConnectionAttempt().fromJsonString(jsonString, options);
  }

  static equals(a: ClickerConnectionAttempt | PlainMessage<ClickerConnectionAttempt> | undefined, b: ClickerConnectionAttempt | PlainMessage<ClickerConnectionAttempt> | undefined): boolean {
    return proto3.util.equals(ClickerConnectionAttempt, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.StudentContentedClassResponse
 */
export class StudentContentedClassResponse extends Message<StudentContentedClassResponse> {
  /**
   * @generated from field: optional int64 connected_class_resource_session_id = 1;
   */
  connectedClassResourceSessionId?: bigint;

  /**
   * @generated from field: int64 connected_class_question_session_id = 2;
   */
  connectedClassQuestionSessionId = protoInt64.zero;

  /**
   * ID of the question
   *
   * @generated from field: string question_id = 3;
   */
  questionId = "";

  /**
   * Answer given by the student
   *
   * @generated from field: string answer = 4;
   */
  answer = "";

  /**
   * Indicates whether the answer is correct or not
   *
   * @generated from field: optional geneo.lms.db.QAttemptResultEnum is_correct = 5;
   */
  isCorrect?: QAttemptResultEnum;

  /**
   * @generated from field: optional float response_score = 8;
   */
  responseScore?: number;

  /**
   * Timestamp when the response was submitted
   *
   * @generated from field: google.protobuf.Timestamp response_submission_time = 6;
   */
  responseSubmissionTime?: Timestamp;

  /**
   * Duration of the response in minutes
   *
   * @generated from field: float duration_in_mins = 7;
   */
  durationInMins = 0;

  constructor(data?: PartialMessage<StudentContentedClassResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.StudentContentedClassResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "connected_class_resource_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "connected_class_question_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "question_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "answer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "is_correct", kind: "enum", T: proto3.getEnumType(QAttemptResultEnum), opt: true },
    { no: 8, name: "response_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 6, name: "response_submission_time", kind: "message", T: Timestamp },
    { no: 7, name: "duration_in_mins", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentContentedClassResponse {
    return new StudentContentedClassResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentContentedClassResponse {
    return new StudentContentedClassResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentContentedClassResponse {
    return new StudentContentedClassResponse().fromJsonString(jsonString, options);
  }

  static equals(a: StudentContentedClassResponse | PlainMessage<StudentContentedClassResponse> | undefined, b: StudentContentedClassResponse | PlainMessage<StudentContentedClassResponse> | undefined): boolean {
    return proto3.util.equals(StudentContentedClassResponse, a, b);
  }
}

/**
 * TODO: metrics tables to be added - refine the tables
 * message for the connected class metrics
 *
 * @generated from message geneo.lms.db.ConnectedClassSessionAnalytics
 */
export class ConnectedClassSessionAnalytics extends Message<ConnectedClassSessionAnalytics> {
  /**
   * Primary key for connected_class_session_metrics
   *
   * @generated from field: int64 connected_class_session_analytics_id = 1;
   */
  connectedClassSessionAnalyticsId = protoInt64.zero;

  /**
   * referencing connected_class_session_id
   *
   * @generated from field: int64 connected_class_session_id = 2;
   */
  connectedClassSessionId = protoInt64.zero;

  /**
   * number of students in the session
   *
   * @generated from field: int32 no_of_students = 3;
   */
  noOfStudents = 0;

  /**
   * number of questions in the session
   *
   * @generated from field: int32 no_of_questions = 4;
   */
  noOfQuestions = 0;

  /**
   * number of correct answers in the session
   *
   * @generated from field: int32 no_of_correct_answers = 5;
   */
  noOfCorrectAnswers = 0;

  /**
   * number of incorrect answers in the session
   *
   * @generated from field: int32 no_of_incorrect_answers = 6;
   */
  noOfIncorrectAnswers = 0;

  /**
   * @generated from field: int32 no_of_unanswered_questions = 7;
   */
  noOfUnansweredQuestions = 0;

  /**
   * maximum score for all the questions in the session
   *
   * @generated from field: int32 max_score = 8;
   */
  maxScore = 0;

  /**
   * number of marks gained by the students
   *
   * @generated from field: float score = 9;
   */
  score = 0;

  /**
   * time spent by the students in the session
   *
   * @generated from field: int32 time_spent_in_min = 10;
   */
  timeSpentInMin = 0;

  /**
   * Creation timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_on = 11;
   */
  createdOn?: Timestamp;

  /**
   * User who created the entry
   *
   * @generated from field: optional int64 created_by = 12;
   */
  createdBy?: bigint;

  /**
   * Last modification timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp modified_on = 13;
   */
  modifiedOn?: Timestamp;

  /**
   * User who last modified the entry
   *
   * @generated from field: optional int64 modified_by = 14;
   */
  modifiedBy?: bigint;

  /**
   * represents the deleted timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 15;
   */
  deletedAt?: Timestamp;

  /**
   * @generated from field: repeated geneo.lms.db.StudentAnalytics student_analytics = 16;
   */
  studentAnalytics: StudentAnalytics[] = [];

  /**
   * @generated from field: optional string nano_id = 17;
   */
  nanoId?: string;

  /**
   * @generated from field: optional int32 school_id = 18;
   */
  schoolId?: number;

  /**
   * @generated from field: optional int64 school_device_id = 19;
   */
  schoolDeviceId?: bigint;

  /**
   * @generated from field: optional bool is_cron_updated = 20;
   */
  isCronUpdated?: boolean;

  /**
   * @generated from field: optional int32 version = 21;
   */
  version?: number;

  constructor(data?: PartialMessage<ConnectedClassSessionAnalytics>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.ConnectedClassSessionAnalytics";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "connected_class_session_analytics_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "connected_class_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "no_of_students", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "no_of_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "no_of_correct_answers", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "no_of_incorrect_answers", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "no_of_unanswered_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "max_score", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 10, name: "time_spent_in_min", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "created_on", kind: "message", T: Timestamp },
    { no: 12, name: "created_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 13, name: "modified_on", kind: "message", T: Timestamp, opt: true },
    { no: 14, name: "modified_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 15, name: "deleted_at", kind: "message", T: Timestamp, opt: true },
    { no: 16, name: "student_analytics", kind: "message", T: StudentAnalytics, repeated: true },
    { no: 17, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 18, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 19, name: "school_device_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 20, name: "is_cron_updated", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 21, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConnectedClassSessionAnalytics {
    return new ConnectedClassSessionAnalytics().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConnectedClassSessionAnalytics {
    return new ConnectedClassSessionAnalytics().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConnectedClassSessionAnalytics {
    return new ConnectedClassSessionAnalytics().fromJsonString(jsonString, options);
  }

  static equals(a: ConnectedClassSessionAnalytics | PlainMessage<ConnectedClassSessionAnalytics> | undefined, b: ConnectedClassSessionAnalytics | PlainMessage<ConnectedClassSessionAnalytics> | undefined): boolean {
    return proto3.util.equals(ConnectedClassSessionAnalytics, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.StudentAnalytics
 */
export class StudentAnalytics extends Message<StudentAnalytics> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: float score = 2;
   */
  score = 0;

  /**
   * @generated from field: optional float response_submission_time_in_mins = 3;
   */
  responseSubmissionTimeInMins?: number;

  constructor(data?: PartialMessage<StudentAnalytics>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.StudentAnalytics";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "response_submission_time_in_mins", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentAnalytics {
    return new StudentAnalytics().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentAnalytics {
    return new StudentAnalytics().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentAnalytics {
    return new StudentAnalytics().fromJsonString(jsonString, options);
  }

  static equals(a: StudentAnalytics | PlainMessage<StudentAnalytics> | undefined, b: StudentAnalytics | PlainMessage<StudentAnalytics> | undefined): boolean {
    return proto3.util.equals(StudentAnalytics, a, b);
  }
}

/**
 * message for the connected class student wise sessions metrics
 *
 * @generated from message geneo.lms.db.ConnectedClassStudentSessionAnalytics
 */
export class ConnectedClassStudentSessionAnalytics extends Message<ConnectedClassStudentSessionAnalytics> {
  /**
   * Primary key for connected_class_student_session_metrics
   *
   * @generated from field: int64 connected_class_student_session_analytics_id = 1;
   */
  connectedClassStudentSessionAnalyticsId = protoInt64.zero;

  /**
   * referencing connected_class_student_session_id
   *
   * @generated from field: int64 connected_class_student_session_id = 2;
   */
  connectedClassStudentSessionId = protoInt64.zero;

  /**
   * number of questions in the session
   *
   * @generated from field: int32 no_of_questions = 3;
   */
  noOfQuestions = 0;

  /**
   * number of correct answers in the session
   *
   * @generated from field: int32 no_of_correct_answers = 4;
   */
  noOfCorrectAnswers = 0;

  /**
   * number of incorrect answers in the session
   *
   * @generated from field: int32 no_of_incorrect_answers = 5;
   */
  noOfIncorrectAnswers = 0;

  /**
   * @generated from field: int32 no_of_unanswered_questions = 6;
   */
  noOfUnansweredQuestions = 0;

  /**
   * maximum score for all the questions in the session
   *
   * @generated from field: int32 max_score = 7;
   */
  maxScore = 0;

  /**
   * number of marks gained by the student
   *
   * @generated from field: float score = 8;
   */
  score = 0;

  /**
   * time spent by the students in the session
   *
   * @generated from field: int32 time_spent_in_min = 9;
   */
  timeSpentInMin = 0;

  /**
   * Creation timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_on = 10;
   */
  createdOn?: Timestamp;

  /**
   * User who created the entry
   *
   * @generated from field: optional int64 created_by = 11;
   */
  createdBy?: bigint;

  /**
   * Last modification timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp modified_on = 12;
   */
  modifiedOn?: Timestamp;

  /**
   * User who last modified the entry
   *
   * @generated from field: optional int64 modified_by = 13;
   */
  modifiedBy?: bigint;

  /**
   * represents the deleted timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 14;
   */
  deletedAt?: Timestamp;

  /**
   * @generated from field: optional string nano_id = 15;
   */
  nanoId?: string;

  /**
   * @generated from field: optional int32 school_id = 16;
   */
  schoolId?: number;

  /**
   * @generated from field: optional int64 school_device_id = 17;
   */
  schoolDeviceId?: bigint;

  /**
   * @generated from field: optional int32 version = 18;
   */
  version?: number;

  constructor(data?: PartialMessage<ConnectedClassStudentSessionAnalytics>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.ConnectedClassStudentSessionAnalytics";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "connected_class_student_session_analytics_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "connected_class_student_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "no_of_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "no_of_correct_answers", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "no_of_incorrect_answers", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "no_of_unanswered_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "max_score", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 9, name: "time_spent_in_min", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "created_on", kind: "message", T: Timestamp },
    { no: 11, name: "created_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 12, name: "modified_on", kind: "message", T: Timestamp, opt: true },
    { no: 13, name: "modified_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 14, name: "deleted_at", kind: "message", T: Timestamp, opt: true },
    { no: 15, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 16, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 17, name: "school_device_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 18, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConnectedClassStudentSessionAnalytics {
    return new ConnectedClassStudentSessionAnalytics().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConnectedClassStudentSessionAnalytics {
    return new ConnectedClassStudentSessionAnalytics().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConnectedClassStudentSessionAnalytics {
    return new ConnectedClassStudentSessionAnalytics().fromJsonString(jsonString, options);
  }

  static equals(a: ConnectedClassStudentSessionAnalytics | PlainMessage<ConnectedClassStudentSessionAnalytics> | undefined, b: ConnectedClassStudentSessionAnalytics | PlainMessage<ConnectedClassStudentSessionAnalytics> | undefined): boolean {
    return proto3.util.equals(ConnectedClassStudentSessionAnalytics, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.KeypadOnlineInfo
 */
export class KeypadOnlineInfo extends Message<KeypadOnlineInfo> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: string keypad_sn = 2;
   */
  keypadSn = "";

  /**
   * @generated from field: bool is_online = 3;
   */
  isOnline = false;

  /**
   * @generated from field: google.protobuf.Timestamp created_on = 4;
   */
  createdOn?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp modified_on = 5;
   */
  modifiedOn?: Timestamp;

  constructor(data?: PartialMessage<KeypadOnlineInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.KeypadOnlineInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "keypad_sn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "is_online", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "created_on", kind: "message", T: Timestamp },
    { no: 5, name: "modified_on", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): KeypadOnlineInfo {
    return new KeypadOnlineInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): KeypadOnlineInfo {
    return new KeypadOnlineInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): KeypadOnlineInfo {
    return new KeypadOnlineInfo().fromJsonString(jsonString, options);
  }

  static equals(a: KeypadOnlineInfo | PlainMessage<KeypadOnlineInfo> | undefined, b: KeypadOnlineInfo | PlainMessage<KeypadOnlineInfo> | undefined): boolean {
    return proto3.util.equals(KeypadOnlineInfo, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.ConnectedClassBaseStationDocument
 */
export class ConnectedClassBaseStationDocument extends Message<ConnectedClassBaseStationDocument> {
  /**
   * @generated from field: int32 connected_class_base_station_document_id = 1;
   */
  connectedClassBaseStationDocumentId = 0;

  /**
   * @generated from field: string base_station_id = 2;
   */
  baseStationId = "";

  /**
   * @generated from field: optional string base_id = 3;
   */
  baseId?: string;

  /**
   * @generated from field: bool is_online = 4;
   */
  isOnline = false;

  /**
   * @generated from field: optional int32 class_id = 5;
   */
  classId?: number;

  /**
   * @generated from field: optional int64 school_class_section_id = 6;
   */
  schoolClassSectionId?: bigint;

  /**
   * @generated from field: optional int64 session_id = 7;
   */
  sessionId?: bigint;

  /**
   * @generated from field: bool session_status = 8;
   */
  sessionStatus = false;

  /**
   * @generated from field: repeated geneo.lms.db.KeypadOnlineInfo key_pads = 9;
   */
  keyPads: KeypadOnlineInfo[] = [];

  /**
   * @generated from field: optional string active_question_id = 10;
   */
  activeQuestionId?: string;

  /**
   * @generated from field: optional int64 question_session_id = 11;
   */
  questionSessionId?: bigint;

  /**
   * @generated from field: optional int32 question_type = 12;
   */
  questionType?: number;

  /**
   * @generated from field: optional string question_options = 13;
   */
  questionOptions?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_on = 14;
   */
  createdOn?: Timestamp;

  /**
   * @generated from field: optional int64 created_by = 15;
   */
  createdBy?: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp modified_on = 16;
   */
  modifiedOn?: Timestamp;

  /**
   * @generated from field: optional int64 modified_by = 17;
   */
  modifiedBy?: bigint;

  constructor(data?: PartialMessage<ConnectedClassBaseStationDocument>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.ConnectedClassBaseStationDocument";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "connected_class_base_station_document_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "base_station_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "base_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "is_online", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "class_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "school_class_section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 7, name: "session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 8, name: "session_status", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "key_pads", kind: "message", T: KeypadOnlineInfo, repeated: true },
    { no: 10, name: "active_question_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "question_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 12, name: "question_type", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 13, name: "question_options", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 14, name: "created_on", kind: "message", T: Timestamp, opt: true },
    { no: 15, name: "created_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 16, name: "modified_on", kind: "message", T: Timestamp, opt: true },
    { no: 17, name: "modified_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConnectedClassBaseStationDocument {
    return new ConnectedClassBaseStationDocument().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConnectedClassBaseStationDocument {
    return new ConnectedClassBaseStationDocument().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConnectedClassBaseStationDocument {
    return new ConnectedClassBaseStationDocument().fromJsonString(jsonString, options);
  }

  static equals(a: ConnectedClassBaseStationDocument | PlainMessage<ConnectedClassBaseStationDocument> | undefined, b: ConnectedClassBaseStationDocument | PlainMessage<ConnectedClassBaseStationDocument> | undefined): boolean {
    return proto3.util.equals(ConnectedClassBaseStationDocument, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.KepadResponse
 */
export class KepadResponse extends Message<KepadResponse> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: string keypad_sn = 2;
   */
  keypadSn = "";

  /**
   * @generated from field: string response = 3;
   */
  response = "";

  /**
   * @generated from field: double time_spent = 4;
   */
  timeSpent = 0;

  /**
   * @generated from field: google.protobuf.Timestamp created_on = 5;
   */
  createdOn?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp modified_on = 6;
   */
  modifiedOn?: Timestamp;

  constructor(data?: PartialMessage<KepadResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.KepadResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "keypad_sn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "response", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "time_spent", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "created_on", kind: "message", T: Timestamp },
    { no: 6, name: "modified_on", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): KepadResponse {
    return new KepadResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): KepadResponse {
    return new KepadResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): KepadResponse {
    return new KepadResponse().fromJsonString(jsonString, options);
  }

  static equals(a: KepadResponse | PlainMessage<KepadResponse> | undefined, b: KepadResponse | PlainMessage<KepadResponse> | undefined): boolean {
    return proto3.util.equals(KepadResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.ConnectedClassQuestionSessionDocument
 */
export class ConnectedClassQuestionSessionDocument extends Message<ConnectedClassQuestionSessionDocument> {
  /**
   * @generated from field: int32 connected_class_question_session_document_id = 1;
   */
  connectedClassQuestionSessionDocumentId = 0;

  /**
   * @generated from field: string base_station_id = 2;
   */
  baseStationId = "";

  /**
   * @generated from field: int64 question_session_id = 3;
   */
  questionSessionId = protoInt64.zero;

  /**
   * @generated from field: string question_id = 4;
   */
  questionId = "";

  /**
   * @generated from field: string question = 5;
   */
  question = "";

  /**
   * @generated from field: repeated geneo.lms.db.KepadResponse responses = 6;
   */
  responses: KepadResponse[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp created_on = 7;
   */
  createdOn?: Timestamp;

  /**
   * @generated from field: optional int64 created_by = 8;
   */
  createdBy?: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp modified_on = 9;
   */
  modifiedOn?: Timestamp;

  /**
   * @generated from field: optional int64 modified_by = 10;
   */
  modifiedBy?: bigint;

  constructor(data?: PartialMessage<ConnectedClassQuestionSessionDocument>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.ConnectedClassQuestionSessionDocument";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "connected_class_question_session_document_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "base_station_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "question_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "question_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "question", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "responses", kind: "message", T: KepadResponse, repeated: true },
    { no: 7, name: "created_on", kind: "message", T: Timestamp },
    { no: 8, name: "created_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 9, name: "modified_on", kind: "message", T: Timestamp, opt: true },
    { no: 10, name: "modified_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConnectedClassQuestionSessionDocument {
    return new ConnectedClassQuestionSessionDocument().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConnectedClassQuestionSessionDocument {
    return new ConnectedClassQuestionSessionDocument().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConnectedClassQuestionSessionDocument {
    return new ConnectedClassQuestionSessionDocument().fromJsonString(jsonString, options);
  }

  static equals(a: ConnectedClassQuestionSessionDocument | PlainMessage<ConnectedClassQuestionSessionDocument> | undefined, b: ConnectedClassQuestionSessionDocument | PlainMessage<ConnectedClassQuestionSessionDocument> | undefined): boolean {
    return proto3.util.equals(ConnectedClassQuestionSessionDocument, a, b);
  }
}

/**
 * LiveQuiz module (web-based live clicker assessment).
 * This is deliberately a thin orchestration layer only: "which question is
 * live right now, since when". Actual student attempt data (answers, scores)
 * is persisted on the existing TaskStudentAssignment/StudentHomeworkSession
 * messages, not duplicated here, so a live quiz attempt is a real attempt as
 * far as gradebook/reports are concerned.
 *
 * @generated from message geneo.lms.db.LiveQuizSession
 */
export class LiveQuizSession extends Message<LiveQuizSession> {
  /**
   * Primary key for live_quiz_session
   *
   * @generated from field: int64 live_quiz_session_id = 1;
   */
  liveQuizSessionId = protoInt64.zero;

  /**
   * referencing school id
   *
   * @generated from field: int32 school_id = 2;
   */
  schoolId = 0;

  /**
   * referencing school_class_section, same key used by Task/SchoolStudentCourse
   *
   * @generated from field: int64 school_class_section_id = 3;
   */
  schoolClassSectionId = protoInt64.zero;

  /**
   * referencing teacher profile id
   *
   * @generated from field: int64 teacher_id = 4;
   */
  teacherId = protoInt64.zero;

  /**
   * referencing the pre-authored assessment Task
   *
   * @generated from field: string task_id = 5;
   */
  taskId = "";

  /**
   * session status
   *
   * @generated from field: geneo.lms.db.SessionStatusEnum session_status = 6;
   */
  sessionStatus = SessionStatusEnum.SESSION_STATUS_UNDEFINED;

  /**
   * sequence of the currently live question, if any
   *
   * @generated from field: optional int32 current_question_sequence = 7;
   */
  currentQuestionSequence?: number;

  /**
   * the lockstep pointer: authoritative "currently live" question session
   *
   * @generated from field: optional int64 current_question_session_id = 8;
   */
  currentQuestionSessionId?: bigint;

  /**
   * @generated from field: int32 total_questions = 9;
   */
  totalQuestions = 0;

  /**
   * doc id in the liveQuizSessions Firestore collection
   *
   * @generated from field: optional string firestore_doc_id = 10;
   */
  firestoreDocId?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp session_start_time = 11;
   */
  sessionStartTime?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp session_end_time = 12;
   */
  sessionEndTime?: Timestamp;

  /**
   * Creation timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_on = 13;
   */
  createdOn?: Timestamp;

  /**
   * User who created the entry
   *
   * @generated from field: optional int64 created_by = 14;
   */
  createdBy?: bigint;

  /**
   * Last modification timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp modified_on = 15;
   */
  modifiedOn?: Timestamp;

  /**
   * User who last modified the entry
   *
   * @generated from field: optional int64 modified_by = 16;
   */
  modifiedBy?: bigint;

  /**
   * represents the deleted timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 17;
   */
  deletedAt?: Timestamp;

  /**
   * @generated from field: optional string nano_id = 18;
   */
  nanoId?: string;

  /**
   * @generated from field: optional int64 school_device_id = 19;
   */
  schoolDeviceId?: bigint;

  /**
   * @generated from field: optional int32 version = 20;
   */
  version?: number;

  /**
   * Denormalized display fields, snapshotted once at session-creation time —
   * spares the student join-popup (and any other read path) from having to
   * join Task/TeacherProfile/Course/SchoolClassSection every time it just
   * wants to show "who/what/where" for a session.
   *
   * @generated from field: optional string teacher_name = 21;
   */
  teacherName?: string;

  /**
   * @generated from field: optional string subject = 22;
   */
  subject?: string;

  /**
   * @generated from field: optional string class_name = 23;
   */
  className?: string;

  /**
   * @generated from field: optional string section_name = 24;
   */
  sectionName?: string;

  /**
   * @generated from field: optional string task_title = 25;
   */
  taskTitle?: string;

  /**
   * True only when this session was force-completed by the same-teacher
   * "stuck session" cleanup in createLiveQuizSession (not a genuine
   * teacher-initiated endLiveQuizSession call).
   *
   * @generated from field: optional bool ended_by_system = 26;
   */
  endedBySystem?: boolean;

  /**
   * @generated from field: optional string session_instance_id = 27;
   */
  sessionInstanceId?: string;

  constructor(data?: PartialMessage<LiveQuizSession>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.LiveQuizSession";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "live_quiz_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "school_class_section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "task_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "session_status", kind: "enum", T: proto3.getEnumType(SessionStatusEnum) },
    { no: 7, name: "current_question_sequence", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 8, name: "current_question_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 9, name: "total_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "firestore_doc_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "session_start_time", kind: "message", T: Timestamp, opt: true },
    { no: 12, name: "session_end_time", kind: "message", T: Timestamp, opt: true },
    { no: 13, name: "created_on", kind: "message", T: Timestamp },
    { no: 14, name: "created_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 15, name: "modified_on", kind: "message", T: Timestamp, opt: true },
    { no: 16, name: "modified_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 17, name: "deleted_at", kind: "message", T: Timestamp, opt: true },
    { no: 18, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 19, name: "school_device_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 20, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 21, name: "teacher_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 22, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 23, name: "class_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 24, name: "section_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 25, name: "task_title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 26, name: "ended_by_system", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 27, name: "session_instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LiveQuizSession {
    return new LiveQuizSession().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LiveQuizSession {
    return new LiveQuizSession().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LiveQuizSession {
    return new LiveQuizSession().fromJsonString(jsonString, options);
  }

  static equals(a: LiveQuizSession | PlainMessage<LiveQuizSession> | undefined, b: LiveQuizSession | PlainMessage<LiveQuizSession> | undefined): boolean {
    return proto3.util.equals(LiveQuizSession, a, b);
  }
}

/**
 * One row per question in a LiveQuizSession, pre-materialized (all N questions,
 * sequence 1..N, PENDING) at session-creation time so late joiners immediately
 * know "question 3 of 10" and question-advance is a pure state transition.
 *
 * @generated from message geneo.lms.db.LiveQuizQuestionSession
 */
export class LiveQuizQuestionSession extends Message<LiveQuizQuestionSession> {
  /**
   * Primary key for live_quiz_question_session
   *
   * @generated from field: int64 live_quiz_question_session_id = 1;
   */
  liveQuizQuestionSessionId = protoInt64.zero;

  /**
   * referencing live_quiz_session_id
   *
   * @generated from field: int64 live_quiz_session_id = 2;
   */
  liveQuizSessionId = protoInt64.zero;

  /**
   * referencing question id
   *
   * @generated from field: string question_id = 3;
   */
  questionId = "";

  /**
   * sequence number within the session
   *
   * @generated from field: int32 sequence = 4;
   */
  sequence = 0;

  /**
   * PENDING (unstarted) / STARTED (live now) / COMPLETED (ended, revealed)
   *
   * @generated from field: geneo.lms.db.SessionStatusEnum session_status = 5;
   */
  sessionStatus = SessionStatusEnum.SESSION_STATUS_UNDEFINED;

  /**
   * @generated from field: optional google.protobuf.Timestamp start_time = 6;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp end_time = 7;
   */
  endTime?: Timestamp;

  /**
   * Creation timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_on = 8;
   */
  createdOn?: Timestamp;

  /**
   * User who created the entry
   *
   * @generated from field: optional int64 created_by = 9;
   */
  createdBy?: bigint;

  /**
   * Last modification timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp modified_on = 10;
   */
  modifiedOn?: Timestamp;

  /**
   * User who last modified the entry
   *
   * @generated from field: optional int64 modified_by = 11;
   */
  modifiedBy?: bigint;

  /**
   * represents the deleted timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 12;
   */
  deletedAt?: Timestamp;

  /**
   * @generated from field: optional string nano_id = 13;
   */
  nanoId?: string;

  /**
   * @generated from field: optional int32 school_id = 14;
   */
  schoolId?: number;

  /**
   * @generated from field: optional int64 school_device_id = 15;
   */
  schoolDeviceId?: bigint;

  /**
   * @generated from field: optional int32 version = 16;
   */
  version?: number;

  constructor(data?: PartialMessage<LiveQuizQuestionSession>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.LiveQuizQuestionSession";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "live_quiz_question_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "live_quiz_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "question_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "sequence", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "session_status", kind: "enum", T: proto3.getEnumType(SessionStatusEnum) },
    { no: 6, name: "start_time", kind: "message", T: Timestamp, opt: true },
    { no: 7, name: "end_time", kind: "message", T: Timestamp, opt: true },
    { no: 8, name: "created_on", kind: "message", T: Timestamp },
    { no: 9, name: "created_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 10, name: "modified_on", kind: "message", T: Timestamp, opt: true },
    { no: 11, name: "modified_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 12, name: "deleted_at", kind: "message", T: Timestamp, opt: true },
    { no: 13, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 14, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 15, name: "school_device_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 16, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LiveQuizQuestionSession {
    return new LiveQuizQuestionSession().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LiveQuizQuestionSession {
    return new LiveQuizQuestionSession().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LiveQuizQuestionSession {
    return new LiveQuizQuestionSession().fromJsonString(jsonString, options);
  }

  static equals(a: LiveQuizQuestionSession | PlainMessage<LiveQuizQuestionSession> | undefined, b: LiveQuizQuestionSession | PlainMessage<LiveQuizQuestionSession> | undefined): boolean {
    return proto3.util.equals(LiveQuizQuestionSession, a, b);
  }
}

/**
 * Reveal payload for a single student's answer to a question, only ever sent
 * once the teacher has ended that question — never before, since that's the
 * teacher-controlled reveal guarantee.
 *
 * @generated from message geneo.lms.db.LiveQuizParticipantAnswerReveal
 */
export class LiveQuizParticipantAnswerReveal extends Message<LiveQuizParticipantAnswerReveal> {
  /**
   * @generated from field: string question_id = 1;
   */
  questionId = "";

  /**
   * @generated from field: geneo.lms.db.QAttemptResultEnum is_correct = 2;
   */
  isCorrect = QAttemptResultEnum.RESPONSE_UNDEFINED;

  /**
   * @generated from field: float response_score = 3;
   */
  responseScore = 0;

  /**
   * @generated from field: float max_score = 4;
   */
  maxScore = 0;

  constructor(data?: PartialMessage<LiveQuizParticipantAnswerReveal>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.LiveQuizParticipantAnswerReveal";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "question_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_correct", kind: "enum", T: proto3.getEnumType(QAttemptResultEnum) },
    { no: 3, name: "response_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "max_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LiveQuizParticipantAnswerReveal {
    return new LiveQuizParticipantAnswerReveal().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LiveQuizParticipantAnswerReveal {
    return new LiveQuizParticipantAnswerReveal().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LiveQuizParticipantAnswerReveal {
    return new LiveQuizParticipantAnswerReveal().fromJsonString(jsonString, options);
  }

  static equals(a: LiveQuizParticipantAnswerReveal | PlainMessage<LiveQuizParticipantAnswerReveal> | undefined, b: LiveQuizParticipantAnswerReveal | PlainMessage<LiveQuizParticipantAnswerReveal> | undefined): boolean {
    return proto3.util.equals(LiveQuizParticipantAnswerReveal, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.AssessmentReport
 */
export class AssessmentReport extends Message<AssessmentReport> {
  /**
   * Primary key
   *
   * @generated from field: int64 assessment_report_id = 1;
   */
  assessmentReportId = protoInt64.zero;

  /**
   * FK to homework
   *
   * @generated from field: int64 homework_id = 2;
   */
  homeworkId = protoInt64.zero;

  /**
   * GCP-hosted report URL
   *
   * @generated from field: optional string gcp_report_url = 3;
   */
  gcpReportUrl?: string;

  /**
   * JSON string representing responses
   *
   * @generated from field: optional string responses = 4;
   */
  responses?: string;

  /**
   * Created timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_on = 5;
   */
  createdOn?: Timestamp;

  /**
   * Created by user ID
   *
   * @generated from field: optional int64 created_by = 6;
   */
  createdBy?: bigint;

  /**
   * Modified timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp modified_on = 7;
   */
  modifiedOn?: Timestamp;

  /**
   * Modified by user ID
   *
   * @generated from field: optional int64 modified_by = 8;
   */
  modifiedBy?: bigint;

  /**
   * Soft delete timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 9;
   */
  deletedAt?: Timestamp;

  /**
   * Teacher ID
   *
   * @generated from field: optional int64 teacher_id = 10;
   */
  teacherId?: bigint;

  /**
   * Status of PDF generation
   *
   * @generated from field: geneo.lms.db.PDFGenStatus processing_status = 11;
   */
  processingStatus = PDFGenStatus.PDF_GENERATION_STATUS_UNDEFINED;

  /**
   * Profile ID
   *
   * @generated from field: optional int64 profile_id = 12;
   */
  profileId?: bigint;

  /**
   * report Type of assessment
   *
   * @generated from field: optional geneo.lms.db.ReportTypeEnum assessment_type = 13;
   */
  assessmentType?: ReportTypeEnum;

  /**
   * Role (Teacher/Student)
   *
   * @generated from field: optional geneo.ums.db.ReportRoleTypeEnum report_role_type = 14;
   */
  reportRoleType?: ReportRoleTypeEnum;

  /**
   * @generated from field: optional string nano_id = 15;
   */
  nanoId?: string;

  /**
   * School ID
   *
   * @generated from field: optional int32 school_id = 16;
   */
  schoolId?: number;

  /**
   * Device ID
   *
   * @generated from field: optional int64 school_device_id = 17;
   */
  schoolDeviceId?: bigint;

  /**
   * Versioning
   *
   * @generated from field: optional int32 version = 18;
   */
  version?: number;

  /**
   * connected_class_session_id
   *
   * @generated from field: optional int64 connected_class_session_id = 19;
   */
  connectedClassSessionId?: bigint;

  /**
   * Type of assessment
   *
   * @generated from field: optional geneo.lms.db.TaskEnum type = 20;
   */
  type?: TaskEnum;

  /**
   * @generated from field: optional geneo.lms.db.ModeOfConductionEnum mode_of_conduction = 21;
   */
  modeOfConduction?: ModeOfConductionEnum;

  /**
   * attempt number
   *
   * @generated from field: optional int32 attempt_number = 22;
   */
  attemptNumber?: number;

  /**
   * @generated from field: optional geneo.lms.db.AttemptTypeEnum attempt_type = 23;
   */
  attemptType?: AttemptTypeEnum;

  /**
   * @generated from field: optional string gcp_summary_report_url = 24;
   */
  gcpSummaryReportUrl?: string;

  constructor(data?: PartialMessage<AssessmentReport>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.AssessmentReport";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_report_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "homework_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "gcp_report_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "responses", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "created_on", kind: "message", T: Timestamp },
    { no: 6, name: "created_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 7, name: "modified_on", kind: "message", T: Timestamp, opt: true },
    { no: 8, name: "modified_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 9, name: "deleted_at", kind: "message", T: Timestamp, opt: true },
    { no: 10, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 11, name: "processing_status", kind: "enum", T: proto3.getEnumType(PDFGenStatus) },
    { no: 12, name: "profile_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 13, name: "assessment_type", kind: "enum", T: proto3.getEnumType(ReportTypeEnum), opt: true },
    { no: 14, name: "report_role_type", kind: "enum", T: proto3.getEnumType(ReportRoleTypeEnum), opt: true },
    { no: 15, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 16, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 17, name: "school_device_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 18, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 19, name: "connected_class_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 20, name: "type", kind: "enum", T: proto3.getEnumType(TaskEnum), opt: true },
    { no: 21, name: "mode_of_conduction", kind: "enum", T: proto3.getEnumType(ModeOfConductionEnum), opt: true },
    { no: 22, name: "attempt_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 23, name: "attempt_type", kind: "enum", T: proto3.getEnumType(AttemptTypeEnum), opt: true },
    { no: 24, name: "gcp_summary_report_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AssessmentReport {
    return new AssessmentReport().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AssessmentReport {
    return new AssessmentReport().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AssessmentReport {
    return new AssessmentReport().fromJsonString(jsonString, options);
  }

  static equals(a: AssessmentReport | PlainMessage<AssessmentReport> | undefined, b: AssessmentReport | PlainMessage<AssessmentReport> | undefined): boolean {
    return proto3.util.equals(AssessmentReport, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.BulkReportJob
 */
export class BulkReportJob extends Message<BulkReportJob> {
  /**
   * Unique job identifier
   *
   * @generated from field: string job_id = 1;
   */
  jobId = "";

  /**
   * Assessment ID for the bulk report
   *
   * @generated from field: int64 assessment_id = 2;
   */
  assessmentId = protoInt64.zero;

  /**
   * Current status of the job
   *
   * @generated from field: geneo.lms.db.BulkJobStatus status = 3;
   */
  status = BulkJobStatus.UNDEFINED;

  /**
   * Total number of reports to generate
   *
   * @generated from field: int32 total_reports = 4;
   */
  totalReports = 0;

  /**
   * Number of completed reports
   *
   * @generated from field: int32 completed_reports = 5;
   */
  completedReports = 0;

  /**
   * Name of the generated ZIP file
   *
   * @generated from field: optional string zip_file_name = 6;
   */
  zipFileName?: string;

  /**
   * GCP URL of the uploaded ZIP file
   *
   * @generated from field: optional string gcp_zip_url = 7;
   */
  gcpZipUrl?: string;

  /**
   * Signed URL for downloading
   *
   * @generated from field: optional string download_url = 8;
   */
  downloadUrl?: string;

  /**
   * Error message if job failed
   *
   * @generated from field: optional string error_message = 9;
   */
  errorMessage?: string;

  /**
   * Job creation timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_on = 10;
   */
  createdOn?: Timestamp;

  /**
   * Job completion timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp completed_at = 11;
   */
  completedAt?: Timestamp;

  /**
   * User who created the job
   *
   * @generated from field: optional int64 created_by = 12;
   */
  createdBy?: bigint;

  /**
   * attempt number for bulk report
   *
   * @generated from field: optional int32 attempt_number = 13;
   */
  attemptNumber?: number;

  /**
   * attempt type for bulk report
   *
   * @generated from field: optional geneo.lms.db.AttemptTypeEnum attempt_type = 14;
   */
  attemptType?: AttemptTypeEnum;

  /**
   * School ID
   *
   * @generated from field: optional int32 school_id = 15;
   */
  schoolId?: number;

  constructor(data?: PartialMessage<BulkReportJob>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.BulkReportJob";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "job_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(BulkJobStatus) },
    { no: 4, name: "total_reports", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "completed_reports", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "zip_file_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "gcp_zip_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "download_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "error_message", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "created_on", kind: "message", T: Timestamp },
    { no: 11, name: "completed_at", kind: "message", T: Timestamp, opt: true },
    { no: 12, name: "created_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 13, name: "attempt_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 14, name: "attempt_type", kind: "enum", T: proto3.getEnumType(AttemptTypeEnum), opt: true },
    { no: 15, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BulkReportJob {
    return new BulkReportJob().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BulkReportJob {
    return new BulkReportJob().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BulkReportJob {
    return new BulkReportJob().fromJsonString(jsonString, options);
  }

  static equals(a: BulkReportJob | PlainMessage<BulkReportJob> | undefined, b: BulkReportJob | PlainMessage<BulkReportJob> | undefined): boolean {
    return proto3.util.equals(BulkReportJob, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.StudentAssessmentSession
 */
export class StudentAssessmentSession extends Message<StudentAssessmentSession> {
  /**
   * @generated from field: int32 student_assessment_session_id = 1;
   */
  studentAssessmentSessionId = 0;

  /**
   * @generated from field: int64 task_student_assignment_id = 12;
   */
  taskStudentAssignmentId = protoInt64.zero;

  /**
   * @generated from field: int64 homework_id = 2;
   */
  homeworkId = protoInt64.zero;

  /**
   * @generated from field: int64 student_id = 3;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 4;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 5;
   */
  endTime?: Timestamp;

  /**
   * Task status for the student (enum: task_student_status_enum)
   *
   * @generated from field: geneo.lms.db.TaskStudentAttemptStatusEnum session_status = 6;
   */
  sessionStatus = TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_UNDEFINED;

  /**
   * @generated from field: geneo.lms.db.HomeworkSessionModeEnum session_mode = 7;
   */
  sessionMode = HomeworkSessionModeEnum.HOMEWORK_SESSION_MODE_UNDEFINED;

  /**
   * @generated from field: repeated geneo.lms.db.StudentTaskResponse responses = 8;
   */
  responses: StudentTaskResponse[] = [];

  /**
   * Metrics associated with the lesson session. Nullable field.
   *
   * @generated from field: geneo.lms.db.MetricsModel metrics = 9;
   */
  metrics?: MetricsModel;

  /**
   * @generated from field: int32 session_number = 10;
   */
  sessionNumber = 0;

  /**
   * @generated from field: optional int32 previous_student_assessment_session_id = 11;
   */
  previousStudentAssessmentSessionId?: number;

  /**
   * @generated from field: optional int64 active_session_id = 13;
   */
  activeSessionId?: bigint;

  /**
   * @generated from field: repeated geneo.lms.db.CloudUpload user_uploads = 14;
   */
  userUploads: CloudUpload[] = [];

  /**
   * @generated from field: optional bool is_evaluation_completed = 15;
   */
  isEvaluationCompleted?: boolean;

  /**
   * @generated from field: optional int32 version = 16;
   */
  version?: number;

  constructor(data?: PartialMessage<StudentAssessmentSession>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.StudentAssessmentSession";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_assessment_session_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "task_student_assignment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "homework_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "start_time", kind: "message", T: Timestamp },
    { no: 5, name: "end_time", kind: "message", T: Timestamp },
    { no: 6, name: "session_status", kind: "enum", T: proto3.getEnumType(TaskStudentAttemptStatusEnum) },
    { no: 7, name: "session_mode", kind: "enum", T: proto3.getEnumType(HomeworkSessionModeEnum) },
    { no: 8, name: "responses", kind: "message", T: StudentTaskResponse, repeated: true },
    { no: 9, name: "metrics", kind: "message", T: MetricsModel },
    { no: 10, name: "session_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "previous_student_assessment_session_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 13, name: "active_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 14, name: "user_uploads", kind: "message", T: CloudUpload, repeated: true },
    { no: 15, name: "is_evaluation_completed", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 16, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentAssessmentSession {
    return new StudentAssessmentSession().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentAssessmentSession {
    return new StudentAssessmentSession().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentAssessmentSession {
    return new StudentAssessmentSession().fromJsonString(jsonString, options);
  }

  static equals(a: StudentAssessmentSession | PlainMessage<StudentAssessmentSession> | undefined, b: StudentAssessmentSession | PlainMessage<StudentAssessmentSession> | undefined): boolean {
    return proto3.util.equals(StudentAssessmentSession, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.FileUploadTracking
 */
export class FileUploadTracking extends Message<FileUploadTracking> {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId = "";

  /**
   * @generated from field: string file_name = 2;
   */
  fileName = "";

  /**
   * @generated from field: string file_url = 3;
   */
  fileUrl = "";

  /**
   * @generated from field: geneo.lms.db.FileUploadStatus status = 4;
   */
  status = FileUploadStatus.UNDEFINED;

  /**
   * @generated from field: int64 uploader_id = 5;
   */
  uploaderId = protoInt64.zero;

  /**
   * @generated from field: geneo.ums.db.ProfileRolesEnum uploader_role = 6;
   */
  uploaderRole = ProfileRolesEnum.PROFILE_ROLE_UNDEFINED;

  /**
   * @generated from field: optional string validation_errors = 7;
   */
  validationErrors?: string;

  /**
   * @generated from field: google.protobuf.Timestamp uploaded_on = 8;
   */
  uploadedOn?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp processed_on = 9;
   */
  processedOn?: Timestamp;

  /**
   * @generated from field: optional string processing_logs = 10;
   */
  processingLogs?: string;

  /**
   * @generated from field: optional string session_id = 11;
   */
  sessionId?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 12;
   */
  deletedAt?: Timestamp;

  constructor(data?: PartialMessage<FileUploadTracking>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.FileUploadTracking";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "upload_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "file_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "file_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status", kind: "enum", T: proto3.getEnumType(FileUploadStatus) },
    { no: 5, name: "uploader_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "uploader_role", kind: "enum", T: proto3.getEnumType(ProfileRolesEnum) },
    { no: 7, name: "validation_errors", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "uploaded_on", kind: "message", T: Timestamp },
    { no: 9, name: "processed_on", kind: "message", T: Timestamp },
    { no: 10, name: "processing_logs", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "deleted_at", kind: "message", T: Timestamp, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FileUploadTracking {
    return new FileUploadTracking().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FileUploadTracking {
    return new FileUploadTracking().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FileUploadTracking {
    return new FileUploadTracking().fromJsonString(jsonString, options);
  }

  static equals(a: FileUploadTracking | PlainMessage<FileUploadTracking> | undefined, b: FileUploadTracking | PlainMessage<FileUploadTracking> | undefined): boolean {
    return proto3.util.equals(FileUploadTracking, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.AttemptStats
 */
export class AttemptStats extends Message<AttemptStats> {
  /**
   * @generated from field: int32 attempt_number = 1;
   */
  attemptNumber = 0;

  /**
   * @generated from field: geneo.lms.db.AttemptTypeEnum attempt_type = 2;
   */
  attemptType = AttemptTypeEnum.ATTEMPT_TYPE_UNDEFINED;

  /**
   * @generated from field: geneo.lms.db.SessionStatusEnum attempt_status = 3;
   */
  attemptStatus = SessionStatusEnum.SESSION_STATUS_UNDEFINED;

  /**
   * @generated from field: int64 teacher_assessment_session_id = 4;
   */
  teacherAssessmentSessionId = protoInt64.zero;

  /**
   * @generated from field: int64 connected_class_session_id = 5;
   */
  connectedClassSessionId = protoInt64.zero;

  constructor(data?: PartialMessage<AttemptStats>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.AttemptStats";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "attempt_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "attempt_type", kind: "enum", T: proto3.getEnumType(AttemptTypeEnum) },
    { no: 3, name: "attempt_status", kind: "enum", T: proto3.getEnumType(SessionStatusEnum) },
    { no: 4, name: "teacher_assessment_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "connected_class_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AttemptStats {
    return new AttemptStats().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AttemptStats {
    return new AttemptStats().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AttemptStats {
    return new AttemptStats().fromJsonString(jsonString, options);
  }

  static equals(a: AttemptStats | PlainMessage<AttemptStats> | undefined, b: AttemptStats | PlainMessage<AttemptStats> | undefined): boolean {
    return proto3.util.equals(AttemptStats, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.QuestionSection
 */
export class QuestionSection extends Message<QuestionSection> {
  /**
   * @generated from field: string section_name = 1;
   */
  sectionName = "";

  /**
   * @generated from field: geneo.content.db.Question.QuestionEnum question_type = 2;
   */
  questionType = Question_QuestionEnum.QUESTION_TYPE_UNDEFINED;

  /**
   * @generated from field: int32 no_of_question = 3;
   */
  noOfQuestion = 0;

  /**
   * @generated from field: optional int32 marks = 4;
   */
  marks?: number;

  /**
   * @generated from field: bool is_alternate_enable = 5;
   */
  isAlternateEnable = false;

  /**
   * @generated from field: int32 section_number = 6;
   */
  sectionNumber = 0;

  constructor(data?: PartialMessage<QuestionSection>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.QuestionSection";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "section_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "question_type", kind: "enum", T: proto3.getEnumType(Question_QuestionEnum) },
    { no: 3, name: "no_of_question", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "marks", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "is_alternate_enable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "section_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuestionSection {
    return new QuestionSection().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuestionSection {
    return new QuestionSection().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuestionSection {
    return new QuestionSection().fromJsonString(jsonString, options);
  }

  static equals(a: QuestionSection | PlainMessage<QuestionSection> | undefined, b: QuestionSection | PlainMessage<QuestionSection> | undefined): boolean {
    return proto3.util.equals(QuestionSection, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.MultiSubjectSectionTemplate
 */
export class MultiSubjectSectionTemplate extends Message<MultiSubjectSectionTemplate> {
  /**
   * @generated from field: optional string section_tittle = 1;
   */
  sectionTittle?: string;

  /**
   * @generated from field: int32 no_of_questions = 2;
   */
  noOfQuestions = 0;

  /**
   * @generated from field: int32 marks = 3;
   */
  marks = 0;

  /**
   * @generated from field: repeated geneo.lms.db.SubSectionTemplate sub_section_template = 4;
   */
  subSectionTemplate: SubSectionTemplate[] = [];

  constructor(data?: PartialMessage<MultiSubjectSectionTemplate>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.MultiSubjectSectionTemplate";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "section_tittle", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "no_of_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "marks", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "sub_section_template", kind: "message", T: SubSectionTemplate, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MultiSubjectSectionTemplate {
    return new MultiSubjectSectionTemplate().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MultiSubjectSectionTemplate {
    return new MultiSubjectSectionTemplate().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MultiSubjectSectionTemplate {
    return new MultiSubjectSectionTemplate().fromJsonString(jsonString, options);
  }

  static equals(a: MultiSubjectSectionTemplate | PlainMessage<MultiSubjectSectionTemplate> | undefined, b: MultiSubjectSectionTemplate | PlainMessage<MultiSubjectSectionTemplate> | undefined): boolean {
    return proto3.util.equals(MultiSubjectSectionTemplate, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.SubSectionQuestionTemplate
 */
export class SubSectionQuestionTemplate extends Message<SubSectionQuestionTemplate> {
  /**
   * @generated from field: geneo.content.db.Question.QuestionEnum question_type = 2;
   */
  questionType = Question_QuestionEnum.QUESTION_TYPE_UNDEFINED;

  /**
   * @generated from field: int32 no_of_question = 3;
   */
  noOfQuestion = 0;

  /**
   * @generated from field: optional int32 marks = 4;
   */
  marks?: number;

  /**
   * @generated from field: bool is_alternate_enable = 5;
   */
  isAlternateEnable = false;

  constructor(data?: PartialMessage<SubSectionQuestionTemplate>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.SubSectionQuestionTemplate";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 2, name: "question_type", kind: "enum", T: proto3.getEnumType(Question_QuestionEnum) },
    { no: 3, name: "no_of_question", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "marks", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "is_alternate_enable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubSectionQuestionTemplate {
    return new SubSectionQuestionTemplate().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubSectionQuestionTemplate {
    return new SubSectionQuestionTemplate().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubSectionQuestionTemplate {
    return new SubSectionQuestionTemplate().fromJsonString(jsonString, options);
  }

  static equals(a: SubSectionQuestionTemplate | PlainMessage<SubSectionQuestionTemplate> | undefined, b: SubSectionQuestionTemplate | PlainMessage<SubSectionQuestionTemplate> | undefined): boolean {
    return proto3.util.equals(SubSectionQuestionTemplate, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.SubSectionTemplate
 */
export class SubSectionTemplate extends Message<SubSectionTemplate> {
  /**
   * @generated from field: string sub_section_tittle = 1;
   */
  subSectionTittle = "";

  /**
   * @generated from field: optional int32 sub_section_number = 2;
   */
  subSectionNumber?: number;

  /**
   * @generated from field: repeated geneo.lms.db.SubSectionQuestionTemplate sub_section_question_template = 3;
   */
  subSectionQuestionTemplate: SubSectionQuestionTemplate[] = [];

  constructor(data?: PartialMessage<SubSectionTemplate>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.SubSectionTemplate";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sub_section_tittle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sub_section_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 3, name: "sub_section_question_template", kind: "message", T: SubSectionQuestionTemplate, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubSectionTemplate {
    return new SubSectionTemplate().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubSectionTemplate {
    return new SubSectionTemplate().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubSectionTemplate {
    return new SubSectionTemplate().fromJsonString(jsonString, options);
  }

  static equals(a: SubSectionTemplate | PlainMessage<SubSectionTemplate> | undefined, b: SubSectionTemplate | PlainMessage<SubSectionTemplate> | undefined): boolean {
    return proto3.util.equals(SubSectionTemplate, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.QuestionPaperTemplate
 */
export class QuestionPaperTemplate extends Message<QuestionPaperTemplate> {
  /**
   * @generated from field: int64 question_paper_template_id = 1;
   */
  questionPaperTemplateId = protoInt64.zero;

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: repeated geneo.lms.db.QuestionSection question_section_info = 3;
   */
  questionSectionInfo: QuestionSection[] = [];

  /**
   * @generated from field: int64 teacher_id = 4;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: optional int32 course_id = 5;
   */
  courseId?: number;

  /**
   * @generated from field: bool include_ai_questions = 6;
   */
  includeAiQuestions = false;

  /**
   * @generated from field: optional geneo.lms.db.MultiSubjectSectionTemplate multi_subject_section_template = 15;
   */
  multiSubjectSectionTemplate?: MultiSubjectSectionTemplate;

  /**
   * @generated from field: optional string nano_id = 7;
   */
  nanoId?: string;

  /**
   * @generated from field: optional int32 school_id = 8;
   */
  schoolId?: number;

  /**
   * @generated from field: optional int64 school_device_id = 9;
   */
  schoolDeviceId?: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 10;
   */
  deletedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_on = 11;
   */
  createdOn?: Timestamp;

  /**
   * @generated from field: optional int64 created_by = 12;
   */
  createdBy?: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp modified_on = 13;
   */
  modifiedOn?: Timestamp;

  /**
   * @generated from field: optional int64 modified_by = 14;
   */
  modifiedBy?: bigint;

  /**
   * @generated from field: optional geneo.lms.db.TaskEnum task_type = 16;
   */
  taskType?: TaskEnum;

  constructor(data?: PartialMessage<QuestionPaperTemplate>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.QuestionPaperTemplate";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "question_paper_template_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "question_section_info", kind: "message", T: QuestionSection, repeated: true },
    { no: 4, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "course_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "include_ai_questions", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "multi_subject_section_template", kind: "message", T: MultiSubjectSectionTemplate, opt: true },
    { no: 7, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 9, name: "school_device_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 10, name: "deleted_at", kind: "message", T: Timestamp, opt: true },
    { no: 11, name: "created_on", kind: "message", T: Timestamp },
    { no: 12, name: "created_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 13, name: "modified_on", kind: "message", T: Timestamp, opt: true },
    { no: 14, name: "modified_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 16, name: "task_type", kind: "enum", T: proto3.getEnumType(TaskEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuestionPaperTemplate {
    return new QuestionPaperTemplate().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuestionPaperTemplate {
    return new QuestionPaperTemplate().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuestionPaperTemplate {
    return new QuestionPaperTemplate().fromJsonString(jsonString, options);
  }

  static equals(a: QuestionPaperTemplate | PlainMessage<QuestionPaperTemplate> | undefined, b: QuestionPaperTemplate | PlainMessage<QuestionPaperTemplate> | undefined): boolean {
    return proto3.util.equals(QuestionPaperTemplate, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.TimeStampWithKey
 */
export class TimeStampWithKey extends Message<TimeStampWithKey> {
  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 1;
   */
  timestamp?: Timestamp;

  /**
   * @generated from field: optional string key = 2;
   */
  key?: string;

  constructor(data?: PartialMessage<TimeStampWithKey>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.TimeStampWithKey";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "timestamp", kind: "message", T: Timestamp },
    { no: 2, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TimeStampWithKey {
    return new TimeStampWithKey().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TimeStampWithKey {
    return new TimeStampWithKey().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TimeStampWithKey {
    return new TimeStampWithKey().fromJsonString(jsonString, options);
  }

  static equals(a: TimeStampWithKey | PlainMessage<TimeStampWithKey> | undefined, b: TimeStampWithKey | PlainMessage<TimeStampWithKey> | undefined): boolean {
    return proto3.util.equals(TimeStampWithKey, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.IdleTimeInformation
 */
export class IdleTimeInformation extends Message<IdleTimeInformation> {
  /**
   * @generated from field: google.protobuf.Timestamp idle_start_time = 1;
   */
  idleStartTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp idle_end_time = 2;
   */
  idleEndTime?: Timestamp;

  constructor(data?: PartialMessage<IdleTimeInformation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.IdleTimeInformation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "idle_start_time", kind: "message", T: Timestamp },
    { no: 2, name: "idle_end_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IdleTimeInformation {
    return new IdleTimeInformation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IdleTimeInformation {
    return new IdleTimeInformation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IdleTimeInformation {
    return new IdleTimeInformation().fromJsonString(jsonString, options);
  }

  static equals(a: IdleTimeInformation | PlainMessage<IdleTimeInformation> | undefined, b: IdleTimeInformation | PlainMessage<IdleTimeInformation> | undefined): boolean {
    return proto3.util.equals(IdleTimeInformation, a, b);
  }
}

/**
 * Proctoring Logs table
 *
 * @generated from message geneo.lms.db.ProctoringLogs
 */
export class ProctoringLogs extends Message<ProctoringLogs> {
  /**
   * @generated from field: optional int64 proctoring_log_id = 1;
   */
  proctoringLogId?: bigint;

  /**
   * @generated from field: optional string nano_id = 2;
   */
  nanoId?: string;

  /**
   * @generated from field: int64 student_id = 3;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: int64 assessment_id = 4;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: int64 homework_session_id = 5;
   */
  homeworkSessionId = protoInt64.zero;

  /**
   * @generated from field: int64 task_student_assignment_id = 6;
   */
  taskStudentAssignmentId = protoInt64.zero;

  /**
   * @generated from field: string question_id = 7;
   */
  questionId = "";

  /**
   * @generated from field: repeated google.protobuf.Timestamp full_screen_exits = 8;
   */
  fullScreenExits: Timestamp[] = [];

  /**
   * @generated from field: repeated google.protobuf.Timestamp tab_switches = 9;
   */
  tabSwitches: Timestamp[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.TimeStampWithKey copy_attempts = 10;
   */
  copyAttempts: TimeStampWithKey[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.TimeStampWithKey paste_attempts = 11;
   */
  pasteAttempts: TimeStampWithKey[] = [];

  /**
   * @generated from field: repeated google.protobuf.Timestamp right_click_attempts = 12;
   */
  rightClickAttempts: Timestamp[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.TimeStampWithKey blocked_shortcuts = 13;
   */
  blockedShortcuts: TimeStampWithKey[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.IdleTimeInformation idle_time_data = 14;
   */
  idleTimeData: IdleTimeInformation[] = [];

  /**
   * @generated from field: repeated google.protobuf.Timestamp multiple_sessions = 15;
   */
  multipleSessions: Timestamp[] = [];

  /**
   * @generated from field: optional google.protobuf.Timestamp created_on = 16;
   */
  createdOn?: Timestamp;

  /**
   * @generated from field: optional int32 school_id = 17;
   */
  schoolId?: number;

  /**
   * @generated from field: optional int64 school_device_id = 18;
   */
  schoolDeviceId?: bigint;

  /**
   * Client/server clock mismatches; timestamp is server time, key carries mismatch info.
   *
   * @generated from field: repeated geneo.lms.db.TimeStampWithKey time_mismatches = 19;
   */
  timeMismatches: TimeStampWithKey[] = [];

  constructor(data?: PartialMessage<ProctoringLogs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.ProctoringLogs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "proctoring_log_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "homework_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "task_student_assignment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "question_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "full_screen_exits", kind: "message", T: Timestamp, repeated: true },
    { no: 9, name: "tab_switches", kind: "message", T: Timestamp, repeated: true },
    { no: 10, name: "copy_attempts", kind: "message", T: TimeStampWithKey, repeated: true },
    { no: 11, name: "paste_attempts", kind: "message", T: TimeStampWithKey, repeated: true },
    { no: 12, name: "right_click_attempts", kind: "message", T: Timestamp, repeated: true },
    { no: 13, name: "blocked_shortcuts", kind: "message", T: TimeStampWithKey, repeated: true },
    { no: 14, name: "idle_time_data", kind: "message", T: IdleTimeInformation, repeated: true },
    { no: 15, name: "multiple_sessions", kind: "message", T: Timestamp, repeated: true },
    { no: 16, name: "created_on", kind: "message", T: Timestamp, opt: true },
    { no: 17, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 18, name: "school_device_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 19, name: "time_mismatches", kind: "message", T: TimeStampWithKey, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProctoringLogs {
    return new ProctoringLogs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProctoringLogs {
    return new ProctoringLogs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProctoringLogs {
    return new ProctoringLogs().fromJsonString(jsonString, options);
  }

  static equals(a: ProctoringLogs | PlainMessage<ProctoringLogs> | undefined, b: ProctoringLogs | PlainMessage<ProctoringLogs> | undefined): boolean {
    return proto3.util.equals(ProctoringLogs, a, b);
  }
}

/**
 * Admin Class Report table for admin-level performance reports
 * Supports both section-level and school-wide reports
 *
 * @generated from message geneo.lms.db.AdminClassReport
 */
export class AdminClassReport extends Message<AdminClassReport> {
  /**
   * Primary key
   *
   * @generated from field: int64 admin_class_report_id = 1;
   */
  adminClassReportId = protoInt64.zero;

  /**
   * School ID
   *
   * @generated from field: int32 school_id = 2;
   */
  schoolId = 0;

  /**
   * SECTION_REPORT or SCHOOL_REPORT
   *
   * @generated from field: geneo.lms.db.AdminLevelReportTypeEnum report_type = 3;
   */
  reportType = AdminLevelReportTypeEnum.ADMIN_LEVEL_REPORT_TYPE_UNDEFINED;

  /**
   * Class ID (nullable for school-wide reports)
   *
   * @generated from field: optional int32 class_id = 4;
   */
  classId?: number;

  /**
   * Section ID (nullable for school-wide reports)
   *
   * @generated from field: optional int64 section_id = 5;
   */
  sectionId?: bigint;

  /**
   * Admin profile ID
   *
   * @generated from field: int64 admin_id = 6;
   */
  adminId = protoInt64.zero;

  /**
   * Report start date
   *
   * @generated from field: google.protobuf.Timestamp start_date = 7;
   */
  startDate?: Timestamp;

  /**
   * Report end date
   *
   * @generated from field: google.protobuf.Timestamp end_date = 8;
   */
  endDate?: Timestamp;

  /**
   * Best/Latest/First attempt filter
   *
   * @generated from field: optional geneo.lms.db.AttemptTypeEnum attempt_type = 9;
   */
  attemptType?: AttemptTypeEnum;

  /**
   * PDF generation status
   *
   * @generated from field: geneo.lms.db.PDFGenStatus processing_status = 10;
   */
  processingStatus = PDFGenStatus.PDF_GENERATION_STATUS_UNDEFINED;

  /**
   * GCS URL of generated PDF
   *
   * @generated from field: optional string gcp_report_url = 11;
   */
  gcpReportUrl?: string;

  /**
   * Full report data (jsonb)
   *
   * @generated from field: optional string responses = 12;
   */
  responses?: string;

  /**
   * JSON array of assessment IDs
   *
   * @generated from field: repeated int64 assessment_ids = 13;
   */
  assessmentIds: bigint[] = [];

  /**
   * Unique nano ID
   *
   * @generated from field: optional string nano_id = 14;
   */
  nanoId?: string;

  /**
   * School device ID
   *
   * @generated from field: optional int64 school_device_id = 15;
   */
  schoolDeviceId?: bigint;

  /**
   * Version number
   *
   * @generated from field: optional int32 version = 16;
   */
  version?: number;

  /**
   * Created timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_on = 17;
   */
  createdOn?: Timestamp;

  /**
   * Created by user ID
   *
   * @generated from field: optional int64 created_by = 18;
   */
  createdBy?: bigint;

  /**
   * Modified timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp modified_on = 19;
   */
  modifiedOn?: Timestamp;

  /**
   * Modified by user ID
   *
   * @generated from field: optional int64 modified_by = 20;
   */
  modifiedBy?: bigint;

  /**
   * Soft delete timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 21;
   */
  deletedAt?: Timestamp;

  constructor(data?: PartialMessage<AdminClassReport>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.AdminClassReport";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "admin_class_report_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "report_type", kind: "enum", T: proto3.getEnumType(AdminLevelReportTypeEnum) },
    { no: 4, name: "class_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 6, name: "admin_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "start_date", kind: "message", T: Timestamp },
    { no: 8, name: "end_date", kind: "message", T: Timestamp },
    { no: 9, name: "attempt_type", kind: "enum", T: proto3.getEnumType(AttemptTypeEnum), opt: true },
    { no: 10, name: "processing_status", kind: "enum", T: proto3.getEnumType(PDFGenStatus) },
    { no: 11, name: "gcp_report_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "responses", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 13, name: "assessment_ids", kind: "scalar", T: 3 /* ScalarType.INT64 */, repeated: true },
    { no: 14, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 15, name: "school_device_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 16, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 17, name: "created_on", kind: "message", T: Timestamp },
    { no: 18, name: "created_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 19, name: "modified_on", kind: "message", T: Timestamp, opt: true },
    { no: 20, name: "modified_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 21, name: "deleted_at", kind: "message", T: Timestamp, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminClassReport {
    return new AdminClassReport().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminClassReport {
    return new AdminClassReport().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminClassReport {
    return new AdminClassReport().fromJsonString(jsonString, options);
  }

  static equals(a: AdminClassReport | PlainMessage<AdminClassReport> | undefined, b: AdminClassReport | PlainMessage<AdminClassReport> | undefined): boolean {
    return proto3.util.equals(AdminClassReport, a, b);
  }
}

/**
 * @generated from message geneo.lms.db.SectionQuestionsUsage
 */
export class SectionQuestionsUsage extends Message<SectionQuestionsUsage> {
  /**
   * @generated from field: int64 section_questions_usage_id = 1;
   */
  sectionQuestionsUsageId = protoInt64.zero;

  /**
   * @generated from field: int32 course_id = 2;
   */
  courseId = 0;

  /**
   * @generated from field: int64 section_id = 3;
   */
  sectionId = protoInt64.zero;

  /**
   * @generated from field: repeated string question_ids = 4;
   */
  questionIds: string[] = [];

  /**
   * @generated from field: optional int32 school_id = 5;
   */
  schoolId?: number;

  /**
   * Unique nano ID
   *
   * @generated from field: optional string nano_id = 6;
   */
  nanoId?: string;

  /**
   * School device ID
   *
   * @generated from field: optional int64 school_device_id = 7;
   */
  schoolDeviceId?: bigint;

  /**
   * Version number
   *
   * @generated from field: optional int32 version = 8;
   */
  version?: number;

  /**
   * Created timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_on = 9;
   */
  createdOn?: Timestamp;

  /**
   * Created by user ID
   *
   * @generated from field: optional int64 created_by = 10;
   */
  createdBy?: bigint;

  /**
   * Modified timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp modified_on = 11;
   */
  modifiedOn?: Timestamp;

  /**
   * Modified by user ID
   *
   * @generated from field: optional int64 modified_by = 12;
   */
  modifiedBy?: bigint;

  /**
   * Soft delete timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 13;
   */
  deletedAt?: Timestamp;

  constructor(data?: PartialMessage<SectionQuestionsUsage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.SectionQuestionsUsage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "section_questions_usage_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "course_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "question_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "nano_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "school_device_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 8, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 9, name: "created_on", kind: "message", T: Timestamp },
    { no: 10, name: "created_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 11, name: "modified_on", kind: "message", T: Timestamp, opt: true },
    { no: 12, name: "modified_by", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 13, name: "deleted_at", kind: "message", T: Timestamp, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SectionQuestionsUsage {
    return new SectionQuestionsUsage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SectionQuestionsUsage {
    return new SectionQuestionsUsage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SectionQuestionsUsage {
    return new SectionQuestionsUsage().fromJsonString(jsonString, options);
  }

  static equals(a: SectionQuestionsUsage | PlainMessage<SectionQuestionsUsage> | undefined, b: SectionQuestionsUsage | PlainMessage<SectionQuestionsUsage> | undefined): boolean {
    return proto3.util.equals(SectionQuestionsUsage, a, b);
  }
}

/**
 * Message for content_management.content_coverage_snapshot table
 *
 * @generated from message geneo.lms.db.ContentCoverageSnapshot
 */
export class ContentCoverageSnapshot extends Message<ContentCoverageSnapshot> {
  /**
   * Primary key
   *
   * @generated from field: optional int32 id = 1;
   */
  id?: number;

  /**
   * 'root' | 'board' | 'grade' | 'subject'
   *
   * @generated from field: string node_type = 2;
   */
  nodeType = "";

  /**
   * e.g. 'root', 'board:3', 'board:3/grade:5', 'board:3/grade:5/book:12'
   *
   * @generated from field: string node_key = 3;
   */
  nodeKey = "";

  /**
   * @generated from field: optional string parent_node_key = 4;
   */
  parentNodeKey?: string;

  /**
   * @generated from field: optional int32 board_id = 5;
   */
  boardId?: number;

  /**
   * @generated from field: optional string board_name = 6;
   */
  boardName?: string;

  /**
   * @generated from field: optional int32 grade_id = 7;
   */
  gradeId?: number;

  /**
   * @generated from field: optional string grade_name = 8;
   */
  gradeName?: string;

  /**
   * @generated from field: optional int32 subject_id = 9;
   */
  subjectId?: number;

  /**
   * @generated from field: optional string subject_name = 10;
   */
  subjectName?: string;

  /**
   * @generated from field: optional int32 book_id = 11;
   */
  bookId?: number;

  /**
   * @generated from field: optional string book_title = 12;
   */
  bookTitle?: string;

  /**
   * @generated from field: int32 resource_count = 13;
   */
  resourceCount = 0;

  /**
   * JSON object: { [category]: count }
   *
   * @generated from field: optional string resource_breakdown = 14;
   */
  resourceBreakdown?: string;

  /**
   * @generated from field: int32 lesson_plan_count = 15;
   */
  lessonPlanCount = 0;

  /**
   * @generated from field: int32 question_bank_count = 16;
   */
  questionBankCount = 0;

  /**
   * @generated from field: int32 question_count = 17;
   */
  questionCount = 0;

  /**
   * @generated from field: optional google.protobuf.Timestamp filter_start = 18;
   */
  filterStart?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp filter_end = 19;
   */
  filterEnd?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp computed_at = 20;
   */
  computedAt?: Timestamp;

  constructor(data?: PartialMessage<ContentCoverageSnapshot>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.db.ContentCoverageSnapshot";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 2, name: "node_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "node_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "parent_node_key", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "board_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "board_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "grade_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 8, name: "grade_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 10, name: "subject_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "book_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 12, name: "book_title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 13, name: "resource_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "resource_breakdown", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 15, name: "lesson_plan_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "question_bank_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 17, name: "question_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 18, name: "filter_start", kind: "message", T: Timestamp, opt: true },
    { no: 19, name: "filter_end", kind: "message", T: Timestamp, opt: true },
    { no: 20, name: "computed_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ContentCoverageSnapshot {
    return new ContentCoverageSnapshot().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ContentCoverageSnapshot {
    return new ContentCoverageSnapshot().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ContentCoverageSnapshot {
    return new ContentCoverageSnapshot().fromJsonString(jsonString, options);
  }

  static equals(a: ContentCoverageSnapshot | PlainMessage<ContentCoverageSnapshot> | undefined, b: ContentCoverageSnapshot | PlainMessage<ContentCoverageSnapshot> | undefined): boolean {
    return proto3.util.equals(ContentCoverageSnapshot, a, b);
  }
}

